// US universities and their web domains (source: github.com/Hipo/university-domains-list)
export const UNIVERSITIES = [
  {
    "name": "42 US",
    "domain": "student.42.us.org"
  },
  {
    "name": "A.T. Still University",
    "domain": "atsu.edu"
  },
  {
    "name": "Aaniiih Nakoda College",
    "domain": "ancollege.edu"
  },
  {
    "name": "Abilene Christian University",
    "domain": "acu.edu"
  },
  {
    "name": "Abraham Baldwin Agricultural College",
    "domain": "abac.edu, stallions.abac.edu"
  },
  {
    "name": "Academic medical center at State University of New York at Stony Brook",
    "domain": "stonybrookmedicine.edu"
  },
  {
    "name": "Academy of Art University",
    "domain": "academyart.edu, art.edu"
  },
  {
    "name": "Adelphi University",
    "domain": "adelphi.edu"
  },
  {
    "name": "Adirondack Community College",
    "domain": "www.sunyacc.edu"
  },
  {
    "name": "Adrian College",
    "domain": "adrian.edu"
  },
  {
    "name": "Agnes Scott College",
    "domain": "agnesscott.edu"
  },
  {
    "name": "Aiken Technical College",
    "domain": "atc.edu"
  },
  {
    "name": "Aims Community College",
    "domain": "aims.edu"
  },
  {
    "name": "Air Force Institute of Technology",
    "domain": "afit.edu"
  },
  {
    "name": "Alabama A&M University",
    "domain": "aamu.edu"
  },
  {
    "name": "Alabama Southern Community College",
    "domain": "ascc.edu"
  },
  {
    "name": "Alabama State University",
    "domain": "alasu.edu"
  },
  {
    "name": "Alamance Community College",
    "domain": "alamancecc.edu"
  },
  {
    "name": "Alamo Colleges",
    "domain": "aloma.edu"
  },
  {
    "name": "Alamo Colleges District",
    "domain": "alamo.edu"
  },
  {
    "name": "Alaska Pacific University",
    "domain": "alaskapacific.edu"
  },
  {
    "name": "Albany State University",
    "domain": "asurams.edu"
  },
  {
    "name": "Albany Technical College",
    "domain": "albanytech.edu"
  },
  {
    "name": "Albertson College of Idaho",
    "domain": "acofi.edu"
  },
  {
    "name": "Albion College",
    "domain": "albion.edu"
  },
  {
    "name": "Alcorn State University",
    "domain": "alcorn.edu"
  },
  {
    "name": "Alexandria Technical & Community College",
    "domain": "alextech.edu"
  },
  {
    "name": "Alfred University",
    "domain": "alfred.edu"
  },
  {
    "name": "Allan Hancock College",
    "domain": "hancockcollege.edu"
  },
  {
    "name": "Allegany College of Maryland",
    "domain": "allegany.edu"
  },
  {
    "name": "Allegheny College",
    "domain": "alleg.edu"
  },
  {
    "name": "Allen College",
    "domain": "allencollege.edu"
  },
  {
    "name": "Allen County Community College",
    "domain": "allencc.edu"
  },
  {
    "name": "Allen University",
    "domain": "allenuniversity.edu"
  },
  {
    "name": "Allentown College of Saint Francis de Sales",
    "domain": "allencol.edu"
  },
  {
    "name": "Alliant International University",
    "domain": "alliant.edu"
  },
  {
    "name": "Alma College",
    "domain": "alma.edu"
  },
  {
    "name": "Alpena Community College",
    "domain": "alpenacc.edu"
  },
  {
    "name": "Alvernia University",
    "domain": "alvernia.edu"
  },
  {
    "name": "Alverno College",
    "domain": "alverno.edu"
  },
  {
    "name": "Alvin Community College",
    "domain": "alvincollege.edu"
  },
  {
    "name": "Amarillo College",
    "domain": "actx.edu"
  },
  {
    "name": "Ambassador University",
    "domain": "ambassador.edu"
  },
  {
    "name": "American Academy of Dramatic Arts-New York",
    "domain": "aada.edu"
  },
  {
    "name": "American Baptist College",
    "domain": "abcnash.edu"
  },
  {
    "name": "American Coastline University",
    "domain": "amercoastuniv.edu"
  },
  {
    "name": "American International College",
    "domain": "aic.edu"
  },
  {
    "name": "American Public University System",
    "domain": "apus.edu"
  },
  {
    "name": "American River College",
    "domain": "arc.losrios.edu"
  },
  {
    "name": "American University",
    "domain": "american.edu"
  },
  {
    "name": "Amherst College",
    "domain": "amherst.edu"
  },
  {
    "name": "Ancilla College",
    "domain": "ancilla.edu"
  },
  {
    "name": "Anderson University",
    "domain": "andersonuniversity.edu"
  },
  {
    "name": "Andrew College",
    "domain": "andrewcollege.edu"
  },
  {
    "name": "Andrews University",
    "domain": "andrews.edu"
  },
  {
    "name": "Angelina College",
    "domain": "angelina.edu"
  },
  {
    "name": "Angelo State University",
    "domain": "angelo.edu"
  },
  {
    "name": "Anne Arundel Community College",
    "domain": "aacc.edu"
  },
  {
    "name": "Anoka Technical College",
    "domain": "anokatech.edu"
  },
  {
    "name": "Anoka-Ramsey Community College",
    "domain": "anokaramsey.edu"
  },
  {
    "name": "Antelope Valley College",
    "domain": "avc.edu"
  },
  {
    "name": "Antioch New England",
    "domain": "antiochne.edu"
  },
  {
    "name": "Antioch University",
    "domain": "antioch.edu"
  },
  {
    "name": "Antioch University - Los Angeles",
    "domain": "antiochla.edu"
  },
  {
    "name": "Antioch University - Seattle",
    "domain": "seattleantioch.edu"
  },
  {
    "name": "Appalachian State University",
    "domain": "appstate.edu"
  },
  {
    "name": "Aquinas College",
    "domain": "aquinas.edu"
  },
  {
    "name": "Arapahoe Community College",
    "domain": "arapahoe.edu"
  },
  {
    "name": "Arcadia College",
    "domain": "arcadia.edu"
  },
  {
    "name": "Arizona State University",
    "domain": "asu.edu"
  },
  {
    "name": "Arizona Western College",
    "domain": "azwestern.edu"
  },
  {
    "name": "Arkansas at Pine Bluff, University of",
    "domain": "uapb.edu"
  },
  {
    "name": "Arkansas Baptist College",
    "domain": "arkansasbaptist.edu"
  },
  {
    "name": "Arkansas Northeastern College",
    "domain": "anc.edu"
  },
  {
    "name": "Arkansas State University",
    "domain": "astate.edu"
  },
  {
    "name": "Arkansas State University-Beebe",
    "domain": "asub.edu"
  },
  {
    "name": "Arkansas State University-Mountain Home",
    "domain": "asumh.edu"
  },
  {
    "name": "Arkansas State University-Newport",
    "domain": "asun.edu"
  },
  {
    "name": "Arkansas Tech University",
    "domain": "atu.edu"
  },
  {
    "name": "Armstrong State College",
    "domain": "armstrong.edu"
  },
  {
    "name": "ASA College",
    "domain": "asa.edu"
  },
  {
    "name": "Asheville-Buncombe Technical Community College",
    "domain": "abtech.edu"
  },
  {
    "name": "Ashford University",
    "domain": "ashford.edu"
  },
  {
    "name": "Ashland Community and Technical College",
    "domain": "ashland.kctcs.edu"
  },
  {
    "name": "Ashland University",
    "domain": "ashland.edu"
  },
  {
    "name": "Asnuntuck Community College",
    "domain": "asnuntuck.edu"
  },
  {
    "name": "Aspen University",
    "domain": "aspen.edu"
  },
  {
    "name": "Assumption College",
    "domain": "assumption.edu"
  },
  {
    "name": "Assumption College for Sisters",
    "domain": "acs350.org"
  },
  {
    "name": "Athens State University",
    "domain": "athens.edu"
  },
  {
    "name": "Athens Technical College",
    "domain": "athenstech.edu"
  },
  {
    "name": "Atlanta Technical College",
    "domain": "atlantatech.edu"
  },
  {
    "name": "Atlantic Cape Community College",
    "domain": "atlantic.edu"
  },
  {
    "name": "Auburn University",
    "domain": "auburn.edu"
  },
  {
    "name": "Auburn University at Montgomery",
    "domain": "aum.edu"
  },
  {
    "name": "Augsburg College",
    "domain": "augsburg.edu"
  },
  {
    "name": "Augusta Technical College",
    "domain": "augustatech.edu"
  },
  {
    "name": "Augusta University",
    "domain": "augusta.edu, gru.edu"
  },
  {
    "name": "Augustana College (IL)",
    "domain": "augustana.edu"
  },
  {
    "name": "Augustana College (SD)",
    "domain": "augie.edu"
  },
  {
    "name": "Aurora University",
    "domain": "aurora.edu"
  },
  {
    "name": "Austin College",
    "domain": "austincollege.edu"
  },
  {
    "name": "Austin Community College",
    "domain": "austincc.edu"
  },
  {
    "name": "Austin Peay State University",
    "domain": "apsu.edu"
  },
  {
    "name": "Averett College",
    "domain": "averett.edu"
  },
  {
    "name": "Avila College",
    "domain": "avila.edu"
  },
  {
    "name": "Azusa Pacific University",
    "domain": "apu.edu"
  },
  {
    "name": "Babson College",
    "domain": "babson.edu"
  },
  {
    "name": "Bainbridge State College",
    "domain": "bainbridge.edu"
  },
  {
    "name": "Baker College",
    "domain": "baker.edu"
  },
  {
    "name": "Baker University",
    "domain": "bakeru.edu"
  },
  {
    "name": "Bakersfield College",
    "domain": "bakersfieldcollege.edu"
  },
  {
    "name": "Baldwin Wallace University",
    "domain": "bw.edu"
  },
  {
    "name": "Ball State University",
    "domain": "bsu.edu"
  },
  {
    "name": "Baltimore City Community College",
    "domain": "bccc.edu"
  },
  {
    "name": "Baptist Bible College",
    "domain": "bbc.edu"
  },
  {
    "name": "Barber-Scotia College",
    "domain": "b-sc.edu"
  },
  {
    "name": "Bard College",
    "domain": "bard.edu"
  },
  {
    "name": "Barnard College",
    "domain": "barnard.edu"
  },
  {
    "name": "Barry University",
    "domain": "barry.edu"
  },
  {
    "name": "Barstow Community College",
    "domain": "barstow.edu"
  },
  {
    "name": "Barton County Community College",
    "domain": "bartonccc.edu"
  },
  {
    "name": "Bastyr University",
    "domain": "bastyr.edu"
  },
  {
    "name": "Bates College",
    "domain": "bates.edu"
  },
  {
    "name": "Bates Technical College",
    "domain": "bates.ctc.edu"
  },
  {
    "name": "Baton Rouge Community College",
    "domain": "mybrcc.edu"
  },
  {
    "name": "Bay Atlantic University",
    "domain": "bau.edu"
  },
  {
    "name": "Bay de Noc Community College",
    "domain": "baycollege.edu"
  },
  {
    "name": "Bay Mills Community College",
    "domain": "bmcc.edu"
  },
  {
    "name": "Bay Path University",
    "domain": "baypath.edu"
  },
  {
    "name": "Baylor College of Medicine",
    "domain": "bcm.edu"
  },
  {
    "name": "Baylor University",
    "domain": "baylor.edu"
  },
  {
    "name": "Beaufort County Community College",
    "domain": "beaufortccc.edu"
  },
  {
    "name": "Belhaven University",
    "domain": "belhaven.edu"
  },
  {
    "name": "Bellevue College",
    "domain": "bellevuecollege.edu"
  },
  {
    "name": "Bellevue University",
    "domain": "bellevue.edu"
  },
  {
    "name": "Bellingham Technical College",
    "domain": "btc.ctc.edu"
  },
  {
    "name": "Belmont College",
    "domain": "belmontcollege.edu"
  },
  {
    "name": "Belmont University",
    "domain": "belmont.edu"
  },
  {
    "name": "Beloit College",
    "domain": "beloit.edu"
  },
  {
    "name": "Bemidji State University",
    "domain": "bemidjistate.edu"
  },
  {
    "name": "Benedict College",
    "domain": "benedict.edu"
  },
  {
    "name": "Benedictine College",
    "domain": "benedictine.edu"
  },
  {
    "name": "Bennett College",
    "domain": "bennet.edu"
  },
  {
    "name": "Bennington College",
    "domain": "bennington.edu"
  },
  {
    "name": "Bentley University",
    "domain": "bentley.edu"
  },
  {
    "name": "Berea College",
    "domain": "berea.edu"
  },
  {
    "name": "Bergen Community College",
    "domain": "bergen.edu"
  },
  {
    "name": "Berkeley City College",
    "domain": "berkeleycitycollege.edu"
  },
  {
    "name": "Berkeley College",
    "domain": "berkeleycollege.edu"
  },
  {
    "name": "Berklee College of Music",
    "domain": "berklee.edu"
  },
  {
    "name": "Berkshire Community College",
    "domain": "berkshirecc.edu"
  },
  {
    "name": "Berry College",
    "domain": "berry.edu"
  },
  {
    "name": "Bethany College",
    "domain": "bethanywv.edu"
  },
  {
    "name": "Bethel College (KS)",
    "domain": "bethelks.edu"
  },
  {
    "name": "Bethel University",
    "domain": "bethel.edu"
  },
  {
    "name": "Bethune-Cookman University",
    "domain": "cookman.edu"
  },
  {
    "name": "Bevill State Community College",
    "domain": "bscc.edu"
  },
  {
    "name": "Big Bend Community College",
    "domain": "bigbend.edu"
  },
  {
    "name": "Big Sandy Community and Technical College",
    "domain": "bigsandy.kctcs.edu"
  },
  {
    "name": "Biola University",
    "domain": "biola.edu"
  },
  {
    "name": "Birmingham-Southern College",
    "domain": "bsc.edu"
  },
  {
    "name": "Bishop McNamara High School",
    "domain": "bmhs.org"
  },
  {
    "name": "Bishop State Community College",
    "domain": "bishop.edu"
  },
  {
    "name": "Bismark State College",
    "domain": "bismarckstate.edu"
  },
  {
    "name": "Black Hawk College",
    "domain": "bhc.edu"
  },
  {
    "name": "Black Hills State University",
    "domain": "bhsu.edu"
  },
  {
    "name": "Black River Technical College",
    "domain": "blackrivertech.edu"
  },
  {
    "name": "Blackfeet Community College",
    "domain": "bfcc.edu"
  },
  {
    "name": "Blackhawk Technical College",
    "domain": "blackhawk.edu"
  },
  {
    "name": "Bladen Community College",
    "domain": "bladencc.edu"
  },
  {
    "name": "Blinn College",
    "domain": "blinn.edu"
  },
  {
    "name": "Bloomfield College",
    "domain": "bloomfield.edu"
  },
  {
    "name": "Bloomsburg University of Pennsylvania",
    "domain": "bloomu.edu"
  },
  {
    "name": "Blue Mountain Community College",
    "domain": "bluecc.edu"
  },
  {
    "name": "Blue Ridge Community and Technical College",
    "domain": "blueridgectc.edu"
  },
  {
    "name": "Blue Ridge Community College",
    "domain": "blueridge.edu, brcc.edu"
  },
  {
    "name": "Bluefield State College",
    "domain": "bluefieldstate.edu"
  },
  {
    "name": "Bluegrass Community and Technical College",
    "domain": "bluegrass.kctcs.edu"
  },
  {
    "name": "Bluffton College",
    "domain": "bluffton.edu"
  },
  {
    "name": "Bob Jones University",
    "domain": "bju.edu"
  },
  {
    "name": "Boise State University",
    "domain": "boisestate.edu"
  },
  {
    "name": "Bossier Parish Community College",
    "domain": "bpcc.edu"
  },
  {
    "name": "Boston College",
    "domain": "bc.edu"
  },
  {
    "name": "Boston Graduate School of Psychoanalysis",
    "domain": "bgsp.edu"
  },
  {
    "name": "Boston University",
    "domain": "bu.edu"
  },
  {
    "name": "Bowdoin College",
    "domain": "bowdoin.edu"
  },
  {
    "name": "Bowie State University",
    "domain": "bowiestate.edu"
  },
  {
    "name": "Bowling Green State University",
    "domain": "bgsu.edu"
  },
  {
    "name": "Bradley University",
    "domain": "bradley.edu"
  },
  {
    "name": "Brandeis University",
    "domain": "brandeis.edu"
  },
  {
    "name": "Brandman University",
    "domain": "brandman.edu"
  },
  {
    "name": "Brenau University",
    "domain": "brenau.edu"
  },
  {
    "name": "Brescia University",
    "domain": "brescia.edu"
  },
  {
    "name": "Briar Cliff College",
    "domain": "briar-cliff.edu"
  },
  {
    "name": "Bridgemont Community and Technical College",
    "domain": "bridgemont.edu"
  },
  {
    "name": "Bridgewater College",
    "domain": "bridgewater.edu"
  },
  {
    "name": "Bridgewater State University",
    "domain": "bridgew.edu"
  },
  {
    "name": "Brigham Young University",
    "domain": "byu.edu"
  },
  {
    "name": "Brigham Young University - Idaho",
    "domain": "byui.edu"
  },
  {
    "name": "Brigham Young University Hawaii",
    "domain": "byuh.edu"
  },
  {
    "name": "Bristol Community College",
    "domain": "bristolcc.edu"
  },
  {
    "name": "Brookdale Community College",
    "domain": "brookdalecc.edu"
  },
  {
    "name": "Brookhaven College",
    "domain": "brookhavencollege.edu"
  },
  {
    "name": "Brookings Institution",
    "domain": "brookings.edu"
  },
  {
    "name": "Broward College",
    "domain": "broward.edu"
  },
  {
    "name": "Brown University",
    "domain": "brown.edu"
  },
  {
    "name": "Brunswick Community College",
    "domain": "brunswickcc.edu"
  },
  {
    "name": "Bryant University",
    "domain": "bryant.edu"
  },
  {
    "name": "Bryn Mawr College",
    "domain": "brynmawr.edu"
  },
  {
    "name": "Bucknell University",
    "domain": "bucknell.edu"
  },
  {
    "name": "Bucks County Community College",
    "domain": "bucks.edu"
  },
  {
    "name": "Buena Vista University",
    "domain": "bvu.edu"
  },
  {
    "name": "Bunker Hill Community College",
    "domain": "bhcc.mass.edu"
  },
  {
    "name": "Butler Community College",
    "domain": "butlercc.edu"
  },
  {
    "name": "Butler County Community College",
    "domain": "bc3.edu"
  },
  {
    "name": "Butler University",
    "domain": "butler.edu"
  },
  {
    "name": "Butte College",
    "domain": "butte.edu"
  },
  {
    "name": "Cabrillo College",
    "domain": "cabrillo.edu"
  },
  {
    "name": "Cabrini University",
    "domain": "cabrini.edu"
  },
  {
    "name": "Caldwell Community College and Technical Institute",
    "domain": "cccti.edu"
  },
  {
    "name": "Caldwell University",
    "domain": "caldwell.edu"
  },
  {
    "name": "Calhoun Community College",
    "domain": "calhoun.edu"
  },
  {
    "name": "California Baptist University",
    "domain": "calbaptist.edu"
  },
  {
    "name": "California Coast University",
    "domain": "calcoast.edu"
  },
  {
    "name": "California College of the Arts",
    "domain": "cca.edu"
  },
  {
    "name": "California Institute of Technology",
    "domain": "caltech.edu"
  },
  {
    "name": "California Institute of the Arts",
    "domain": "calarts.edu"
  },
  {
    "name": "California Lutheran University",
    "domain": "callutheran.edu"
  },
  {
    "name": "California Maritime Academy",
    "domain": "csum.edu"
  },
  {
    "name": "California National University",
    "domain": "cnuas.edu"
  },
  {
    "name": "California Polytechnic State University, Pomona",
    "domain": "cpp.edu"
  },
  {
    "name": "California Polytechnic State University, San Luis Obispo",
    "domain": "calpoly.edu"
  },
  {
    "name": "California Southern University",
    "domain": "calsouthern.edu"
  },
  {
    "name": "California State University",
    "domain": "csueastbay.edu"
  },
  {
    "name": "California State University Channel Islands",
    "domain": "csuci.edu"
  },
  {
    "name": "California State University System",
    "domain": "calstate.edu"
  },
  {
    "name": "California State University, Bakersfield",
    "domain": "csub.edu, csubak.edu"
  },
  {
    "name": "California State University, Chico",
    "domain": "csuchico.edu"
  },
  {
    "name": "California State University, Dominguez Hills",
    "domain": "csudh.edu"
  },
  {
    "name": "California State University, Fresno",
    "domain": "csufresno.edu, fresnostate.edu"
  },
  {
    "name": "California State University, Fullerton",
    "domain": "fullerton.edu"
  },
  {
    "name": "California State University, Hayward",
    "domain": "csuhayward.edu"
  },
  {
    "name": "California State University, Long Beach",
    "domain": "csulb.edu"
  },
  {
    "name": "California State University, Los Angeles",
    "domain": "calstatela.edu"
  },
  {
    "name": "California State University, Monterey Bay",
    "domain": "csumb.edu"
  },
  {
    "name": "California State University, Northridge",
    "domain": "csun.edu"
  },
  {
    "name": "California State University, Sacramento",
    "domain": "csus.edu"
  },
  {
    "name": "California State University, San Bernardino",
    "domain": "csusb.edu"
  },
  {
    "name": "California State University, San Marcos",
    "domain": "csusm.edu"
  },
  {
    "name": "California State University, Stanislaus",
    "domain": "csustan.edu"
  },
  {
    "name": "California University of Pennsylvania",
    "domain": "cup.edu"
  },
  {
    "name": "California University of Science and Medicine",
    "domain": "cusm.edu"
  },
  {
    "name": "Calvin College",
    "domain": "calvin.edu"
  },
  {
    "name": "Camden County College",
    "domain": "camdencc.edu"
  },
  {
    "name": "Cameron University",
    "domain": "cameron.edu"
  },
  {
    "name": "Campbell University",
    "domain": "campbell.edu"
  },
  {
    "name": "Campbellsville College",
    "domain": "campbellsville.edu"
  },
  {
    "name": "Canada College",
    "domain": "canadacollege.edu"
  },
  {
    "name": "Canisius College",
    "domain": "canisius.edu"
  },
  {
    "name": "Cankdeska Cikana Community College",
    "domain": "littlehoop.edu"
  },
  {
    "name": "Cape Cod Community College",
    "domain": "capecod.edu"
  },
  {
    "name": "Cape Fear Community College",
    "domain": "cfcc.edu"
  },
  {
    "name": "Capella University",
    "domain": "capella.edu, capellauniversity.edu"
  },
  {
    "name": "Capital Community College",
    "domain": "ccc.commnet.edu"
  },
  {
    "name": "Capital University",
    "domain": "capital.edu"
  },
  {
    "name": "Capitol Technology University",
    "domain": "captechu.edu"
  },
  {
    "name": "Career College of Northern Nevada",
    "domain": "ccnn.edu"
  },
  {
    "name": "Carl Albert State College",
    "domain": "carlalbert.edu"
  },
  {
    "name": "Carl Sandburg College",
    "domain": "sandburg.edu"
  },
  {
    "name": "Carleton College",
    "domain": "carleton.edu"
  },
  {
    "name": "Carlow College",
    "domain": "carlow.edu"
  },
  {
    "name": "Carnegie Mellon University",
    "domain": "cmu.edu"
  },
  {
    "name": "Carolinas College of Health Sciences",
    "domain": "carolinascollege.edu"
  },
  {
    "name": "Carrington College California-Sacramento",
    "domain": "carrington.edu"
  },
  {
    "name": "Carroll College",
    "domain": "carroll.edu"
  },
  {
    "name": "Carroll Community College",
    "domain": "carrollcc.edu"
  },
  {
    "name": "Carroll University",
    "domain": "carrollu.edu"
  },
  {
    "name": "Carson-Newman College",
    "domain": "cn.edu"
  },
  {
    "name": "Carteret Community College",
    "domain": "carteret.edu"
  },
  {
    "name": "Carthage College",
    "domain": "carthage.edu"
  },
  {
    "name": "Carver College",
    "domain": "carver.edu"
  },
  {
    "name": "Cascadia Community College",
    "domain": "cascadia.edu"
  },
  {
    "name": "Case Western Reserve University",
    "domain": "case.edu"
  },
  {
    "name": "Casper College",
    "domain": "caspercollege.edu"
  },
  {
    "name": "Castleton State University",
    "domain": "castleton.edu"
  },
  {
    "name": "Catawba College",
    "domain": "catawba.edu"
  },
  {
    "name": "Catawba Valley Community College",
    "domain": "cvcc.edu"
  },
  {
    "name": "Catholic University of America",
    "domain": "cua.edu"
  },
  {
    "name": "Cayuga County Community College",
    "domain": "cayuga-cc.edu"
  },
  {
    "name": "Cecil College",
    "domain": "cecil.edu"
  },
  {
    "name": "Cedar Valley College",
    "domain": "cedarvalleycollege.edu"
  },
  {
    "name": "Cedarville College",
    "domain": "cedarville.edu"
  },
  {
    "name": "Centenary College of Louisiana",
    "domain": "centenary.edu"
  },
  {
    "name": "Central Alabama Community College",
    "domain": "cacc.edu"
  },
  {
    "name": "Central Arizona College",
    "domain": "centralaz.edu"
  },
  {
    "name": "Central Carolina Community College",
    "domain": "cccc.edu"
  },
  {
    "name": "Central Carolina Technical College",
    "domain": "cctech.edu"
  },
  {
    "name": "Central College",
    "domain": "central.edu"
  },
  {
    "name": "Central Community College",
    "domain": "cccneb.edu"
  },
  {
    "name": "Central Connecticut State University",
    "domain": "ccsu.edu"
  },
  {
    "name": "Central Georgia Technical College",
    "domain": "centralgatech.edu"
  },
  {
    "name": "Central Lakes College-Brainerd",
    "domain": "www.clcmn.edu"
  },
  {
    "name": "Central Maine Community College",
    "domain": "cmcc.edu"
  },
  {
    "name": "Central Maine Medical Center College of Nursing and Health Professions",
    "domain": "cmmccollege.edu"
  },
  {
    "name": "Central Methodist College",
    "domain": "cmc.edu"
  },
  {
    "name": "Central Michigan University",
    "domain": "cmich.edu"
  },
  {
    "name": "Central New Mexico Community College",
    "domain": "cnm.edu"
  },
  {
    "name": "Central Ohio Technical College",
    "domain": "cotc.edu"
  },
  {
    "name": "Central Oregon Community College",
    "domain": "cocc.edu"
  },
  {
    "name": "Central Piedmont Community College",
    "domain": "cpcc.edu"
  },
  {
    "name": "Central State University",
    "domain": "centralstate.edu"
  },
  {
    "name": "Central Texas College",
    "domain": "ctcd.edu"
  },
  {
    "name": "Central Virginia Community College",
    "domain": "cvcc.vccs.edu"
  },
  {
    "name": "Central Washington University",
    "domain": "cwu.edu"
  },
  {
    "name": "Central Wyoming College",
    "domain": "cwc.edu"
  },
  {
    "name": "Centre College",
    "domain": "centre.edu"
  },
  {
    "name": "Century College",
    "domain": "century.edu"
  },
  {
    "name": "Cerritos College",
    "domain": "cerritos.edu"
  },
  {
    "name": "Cerro Coso Community College",
    "domain": "cerrocoso.edu"
  },
  {
    "name": "Chabot College",
    "domain": "chabotcollege.edu"
  },
  {
    "name": "Chabot-Las Positas Community College District",
    "domain": "clpccd.edu"
  },
  {
    "name": "Chadron State College",
    "domain": "csc.edu"
  },
  {
    "name": "Chaffey College",
    "domain": "chaffey.edu"
  },
  {
    "name": "Chaminade University of Honolulu",
    "domain": "chaminade.edu"
  },
  {
    "name": "Champlain College",
    "domain": "champlain.edu"
  },
  {
    "name": "Chandler-Gilbert Community College",
    "domain": "cgc.maricopa.edu"
  },
  {
    "name": "Chapman University",
    "domain": "chapman.edu"
  },
  {
    "name": "Chatfield College",
    "domain": "chatfield.edu"
  },
  {
    "name": "Chatham College",
    "domain": "chatham.edu"
  },
  {
    "name": "Chattahoochee Technical College",
    "domain": "chattahoocheetech.edu"
  },
  {
    "name": "Chattahoochee Valley Community College",
    "domain": "cv.edu"
  },
  {
    "name": "Chattanooga State Community College",
    "domain": "chattanoogastate.edu"
  },
  {
    "name": "Chemeketa Community College",
    "domain": "chemeketa.edu"
  },
  {
    "name": "Chesapeake College",
    "domain": "chesapeake.edu"
  },
  {
    "name": "Cheyney University",
    "domain": "cheyney.edu"
  },
  {
    "name": "Chicago School of Professional Psychology",
    "domain": "csopp.edu"
  },
  {
    "name": "Chicago State University",
    "domain": "csu.edu"
  },
  {
    "name": "Chief Dull Knife College",
    "domain": "cdkc.edu"
  },
  {
    "name": "Chippewa Valley Technical College",
    "domain": "cvtc.edu"
  },
  {
    "name": "Christian Brothers University",
    "domain": "cbu.edu"
  },
  {
    "name": "Christian Theological Seminary",
    "domain": "cts.edu"
  },
  {
    "name": "Christopher Newport University",
    "domain": "cnu.edu"
  },
  {
    "name": "Cincinnati State Technical and Community College",
    "domain": "cincinnatistate.edu"
  },
  {
    "name": "Cisco College",
    "domain": "cisco.edu"
  },
  {
    "name": "Citrus College",
    "domain": "citruscollege.edu"
  },
  {
    "name": "City College of San Francisco",
    "domain": "ccsf.edu"
  },
  {
    "name": "City Colleges of Chicago",
    "domain": "ccc.edu"
  },
  {
    "name": "City University",
    "domain": "cityu.edu"
  },
  {
    "name": "City University of New York",
    "domain": "cuny.edu"
  },
  {
    "name": "Clackamas Community College",
    "domain": "clackamas.edu"
  },
  {
    "name": "Claflin University",
    "domain": "claflin.edu"
  },
  {
    "name": "Claremont Colleges",
    "domain": "claremont.edu"
  },
  {
    "name": "Claremont Graduate School",
    "domain": "cgs.edu"
  },
  {
    "name": "Claremont Graduate University",
    "domain": "cgu.edu"
  },
  {
    "name": "Claremont McKenna College",
    "domain": "claremontmckenna.edu"
  },
  {
    "name": "Claremont School of Theology",
    "domain": "cst.edu"
  },
  {
    "name": "Clarendon College",
    "domain": "clarendoncollege.edu"
  },
  {
    "name": "Clarion University of Pennsylvania",
    "domain": "clarion.edu"
  },
  {
    "name": "Clark Atlanta University",
    "domain": "cau.edu"
  },
  {
    "name": "Clark College",
    "domain": "clark.edu"
  },
  {
    "name": "Clark State Community College",
    "domain": "clarkstate.edu"
  },
  {
    "name": "Clark University",
    "domain": "clarku.edu"
  },
  {
    "name": "Clarke College",
    "domain": "clarke.edu"
  },
  {
    "name": "Clarkson University",
    "domain": "clarkson.edu"
  },
  {
    "name": "Clatsop Community College",
    "domain": "clatsopcc.edu"
  },
  {
    "name": "Clayton State College",
    "domain": "clayton.edu"
  },
  {
    "name": "Clemson University",
    "domain": "clemson.edu"
  },
  {
    "name": "Cleveland Community College",
    "domain": "clevelandcc.edu"
  },
  {
    "name": "Cleveland State Community College",
    "domain": "clevelandstatecc.edu"
  },
  {
    "name": "Cleveland State University",
    "domain": "csuohio.edu"
  },
  {
    "name": "Clinch Valley College",
    "domain": "clinch.edu"
  },
  {
    "name": "Clinton College",
    "domain": "clintoncollege.edu"
  },
  {
    "name": "Clinton Community College",
    "domain": "clinton.edu"
  },
  {
    "name": "Cloud County Community College",
    "domain": "cloud.edu"
  },
  {
    "name": "Clover Park Technical College",
    "domain": "cptc.edu"
  },
  {
    "name": "Clovis Community College",
    "domain": "clovis.edu"
  },
  {
    "name": "Coahoma Community College",
    "domain": "coahomacc.edu"
  },
  {
    "name": "Coast Colleges",
    "domain": "cccd.edu"
  },
  {
    "name": "Coastal Alabama Community College",
    "domain": "coastalalabama.edu"
  },
  {
    "name": "Coastal Bend College",
    "domain": "coastalbend.edu"
  },
  {
    "name": "Coastal Carolina Community College",
    "domain": "coastalcarolina.edu"
  },
  {
    "name": "Coastal Carolina University",
    "domain": "coastal.edu"
  },
  {
    "name": "Coastal Pines Technical College",
    "domain": "coastalpines.edu"
  },
  {
    "name": "Coastline Community College",
    "domain": "coastline.edu"
  },
  {
    "name": "Cochise College",
    "domain": "cochise.edu"
  },
  {
    "name": "Coconino Community College",
    "domain": "coconino.edu"
  },
  {
    "name": "Coe College",
    "domain": "coe.edu"
  },
  {
    "name": "Coffeyville Community College",
    "domain": "coffeyville.edu"
  },
  {
    "name": "Coker College",
    "domain": "coker.edu"
  },
  {
    "name": "Colby College",
    "domain": "colby.edu"
  },
  {
    "name": "Colby Community College",
    "domain": "colbycc.edu"
  },
  {
    "name": "Cold Spring Harbor Laboratory",
    "domain": "cshl.edu"
  },
  {
    "name": "Colgate University",
    "domain": "colgate.edu"
  },
  {
    "name": "College of Alameda",
    "domain": "peralta.edu"
  },
  {
    "name": "College of Charleston",
    "domain": "cofc.edu"
  },
  {
    "name": "College of DuPage",
    "domain": "cod.edu"
  },
  {
    "name": "College of Eastern Utah",
    "domain": "ceu.edu"
  },
  {
    "name": "College of Lake County",
    "domain": "www.clcillinois.edu"
  },
  {
    "name": "College of Marin",
    "domain": "marin.edu"
  },
  {
    "name": "College of Mount Saint Vincent",
    "domain": "mountsaintvincent.edu"
  },
  {
    "name": "College of New Rochelle",
    "domain": "cnr.edu"
  },
  {
    "name": "College of Saint Benedict",
    "domain": "csbsju.edu"
  },
  {
    "name": "College of Saint Catherine",
    "domain": "stkate.edu"
  },
  {
    "name": "College of Saint Rose",
    "domain": "strose.edu"
  },
  {
    "name": "College of San Mateo",
    "domain": "collegeofsanmateo.edu"
  },
  {
    "name": "College of Southern Idaho",
    "domain": "csi.edu"
  },
  {
    "name": "College of Southern Maryland",
    "domain": "csmd.edu"
  },
  {
    "name": "College of Southern Nevada",
    "domain": "csn.edu"
  },
  {
    "name": "College of St. Francis",
    "domain": "stfrancis.edu"
  },
  {
    "name": "College of St. Scholastica",
    "domain": "css.edu"
  },
  {
    "name": "College of the Albemarle",
    "domain": "albemarle.edu"
  },
  {
    "name": "College of the Atlantic",
    "domain": "coa.edu"
  },
  {
    "name": "College of the Canyons",
    "domain": "canyons.edu"
  },
  {
    "name": "College of the Desert",
    "domain": "collegeofthedesert.edu"
  },
  {
    "name": "College of the Holy Cross",
    "domain": "holycross.edu"
  },
  {
    "name": "College of the Mainland",
    "domain": "com.edu"
  },
  {
    "name": "College of the Ouachitas",
    "domain": "coto.edu"
  },
  {
    "name": "College of the Redwoods",
    "domain": "redwoods.edu"
  },
  {
    "name": "College of the Sequoias",
    "domain": "cos.edu"
  },
  {
    "name": "College of the Siskiyous",
    "domain": "siskiyous.edu"
  },
  {
    "name": "College of Western Idaho",
    "domain": "cwidaho.cc"
  },
  {
    "name": "College of William and Mary",
    "domain": "wm.edu"
  },
  {
    "name": "College of Wooster",
    "domain": "wooster.edu"
  },
  {
    "name": "Collin County Community College District",
    "domain": "collin.edu"
  },
  {
    "name": "Colorado Christian University",
    "domain": "ccu.edu"
  },
  {
    "name": "Colorado College",
    "domain": "coloradocollege.edu"
  },
  {
    "name": "Colorado Community College System",
    "domain": "cccs.edu"
  },
  {
    "name": "Colorado Mesa University",
    "domain": "coloradomesa.edu"
  },
  {
    "name": "Colorado Northwestern Community College",
    "domain": "cncc.edu"
  },
  {
    "name": "Colorado School of Mines",
    "domain": "mines.edu"
  },
  {
    "name": "Colorado State University",
    "domain": "colostate.edu"
  },
  {
    "name": "Colorado State University - Global Campus",
    "domain": "csuglobal.edu"
  },
  {
    "name": "Colorado State University-Pueblo",
    "domain": "csupueblo.edu"
  },
  {
    "name": "Colorado Technical University",
    "domain": "coloradotech.edu, ctuonline.edu"
  },
  {
    "name": "Columbia Basin College",
    "domain": "columbiabasin.edu"
  },
  {
    "name": "Columbia College (CA)",
    "domain": "gocolumbia.edu"
  },
  {
    "name": "Columbia College (MO)",
    "domain": "ccis.edu"
  },
  {
    "name": "Columbia College (SC)",
    "domain": "columbiasc.edu"
  },
  {
    "name": "Columbia College Chicago",
    "domain": "colum.edu"
  },
  {
    "name": "Columbia Gorge Community College",
    "domain": "cgcc.cc.or.us"
  },
  {
    "name": "Columbia Southern University",
    "domain": "colsouth.edu"
  },
  {
    "name": "Columbia State Community College",
    "domain": "columbiastate.edu"
  },
  {
    "name": "Columbia Union College",
    "domain": "cuc.edu"
  },
  {
    "name": "Columbia University",
    "domain": "columbia.edu"
  },
  {
    "name": "Columbia-Greene Community College",
    "domain": "sunycgcc.edu"
  },
  {
    "name": "Columbus State Community College",
    "domain": "cscc.edu"
  },
  {
    "name": "Columbus State University",
    "domain": "columbusstate.edu"
  },
  {
    "name": "Columbus Technical College",
    "domain": "columbustech.edu"
  },
  {
    "name": "Community College of Allegheny County",
    "domain": "ccac.edu"
  },
  {
    "name": "Community College of Aurora",
    "domain": "ccaurora.edu"
  },
  {
    "name": "Community College of Baltimore County",
    "domain": "ccbcmd.edu"
  },
  {
    "name": "Community College of Beaver County",
    "domain": "ccbc.edu"
  },
  {
    "name": "Community College of Denver",
    "domain": "ccd.edu"
  },
  {
    "name": "Community College of Philadelphia",
    "domain": "ccp.edu"
  },
  {
    "name": "Community College of Rhode Island",
    "domain": "ccri.edu"
  },
  {
    "name": "Community College of Vermont",
    "domain": "ccv.edu"
  },
  {
    "name": "Community College System of New Hampshire",
    "domain": "ccsnh.edu"
  },
  {
    "name": "Concordia College - Ann Arbor",
    "domain": "ccaa.edu"
  },
  {
    "name": "Concordia College - Moorhead",
    "domain": "cord.edu"
  },
  {
    "name": "Concordia College - Seward",
    "domain": "ccsn.edu"
  },
  {
    "name": "Concordia College - St. Paul",
    "domain": "csp.edu"
  },
  {
    "name": "Concordia University Wisconsin",
    "domain": "cuw.edu"
  },
  {
    "name": "Connecticut College",
    "domain": "conncoll.edu"
  },
  {
    "name": "Connecticut State University System",
    "domain": "ct.edu"
  },
  {
    "name": "Connors State College",
    "domain": "connorsstate.edu"
  },
  {
    "name": "Contra Costa College",
    "domain": "contracosta.edu"
  },
  {
    "name": "Contra Costa Community College District",
    "domain": "4cd.edu"
  },
  {
    "name": "Cooper Union for the Advancement of Science and Art",
    "domain": "cooper.edu"
  },
  {
    "name": "Copiah-Lincoln Community College",
    "domain": "colin.edu"
  },
  {
    "name": "Copper Mountain Community College",
    "domain": "cmccd.edu"
  },
  {
    "name": "Coppin State University",
    "domain": "coppin.edu"
  },
  {
    "name": "Cornell College",
    "domain": "cornell-iowa.edu, cornellcollege.edu"
  },
  {
    "name": "Cornell University",
    "domain": "cornell.edu"
  },
  {
    "name": "Corning Community College",
    "domain": "corning-cc.edu"
  },
  {
    "name": "Cossatot Community College of the University of Arkansas",
    "domain": "cccua.edu"
  },
  {
    "name": "Cosumnes River College",
    "domain": "crc.losrios.edu"
  },
  {
    "name": "County College of Morris",
    "domain": "ccm.edu, student.ccm.edu"
  },
  {
    "name": "Covenant College",
    "domain": "covenant.edu"
  },
  {
    "name": "Cowley County Community College",
    "domain": "cowley.edu"
  },
  {
    "name": "Crafton Hills College",
    "domain": "craftonhills.edu"
  },
  {
    "name": "Craven Community College",
    "domain": "cravencc.edu"
  },
  {
    "name": "Creighton University",
    "domain": "creighton.edu"
  },
  {
    "name": "Crowder College",
    "domain": "crowder.edu"
  },
  {
    "name": "Cuesta College",
    "domain": "www.cuesta.edu"
  },
  {
    "name": "Cumberland County College",
    "domain": "cccnj.edu"
  },
  {
    "name": "CUNY Baruch College",
    "domain": "baruch.cuny.edu"
  },
  {
    "name": "CUNY Borough of Manhattan Community College",
    "domain": "bmcc.cuny.edu"
  },
  {
    "name": "CUNY Bronx Community College",
    "domain": "bcc.cuny.edu"
  },
  {
    "name": "CUNY Brooklyn College",
    "domain": "brooklyn.cuny.edu"
  },
  {
    "name": "CUNY City College of NY",
    "domain": "ccny.cuny.edu"
  },
  {
    "name": "CUNY City Tech",
    "domain": "citytech.cuny.edu"
  },
  {
    "name": "CUNY College of Staten Island",
    "domain": "csi.cuny.edu"
  },
  {
    "name": "CUNY Hostos Community College",
    "domain": "hostos.cuny.edu"
  },
  {
    "name": "CUNY John Jay College of Criminal Justice",
    "domain": "jjay.cuny.edu"
  },
  {
    "name": "CUNY Kingsborough Community College",
    "domain": "kbcc.cuny.edu"
  },
  {
    "name": "CUNY LaGuardia Community College",
    "domain": "lagcc.cuny.edu"
  },
  {
    "name": "CUNY Lehman College",
    "domain": "lehman.cuny.edu"
  },
  {
    "name": "CUNY Macauly Honors College",
    "domain": "macauly.cuny.edu"
  },
  {
    "name": "CUNY Medgar Evers College",
    "domain": "mec.cuny.edu"
  },
  {
    "name": "CUNY Queens College",
    "domain": "qc.cuny.edu"
  },
  {
    "name": "CUNY Queensborough Community College",
    "domain": "qcc.cuny.edu"
  },
  {
    "name": "CUNY School of Law",
    "domain": "law.cuny.edu"
  },
  {
    "name": "CUNY York College",
    "domain": "york.cuny.edu"
  },
  {
    "name": "Curry College",
    "domain": "curry.edu"
  },
  {
    "name": "Cuyahoga Community College District",
    "domain": "tri-c.edu"
  },
  {
    "name": "Cuyamaca College",
    "domain": "cuyamaca.edu"
  },
  {
    "name": "Cypress College",
    "domain": "cypresscollege.edu"
  },
  {
    "name": "Dabney S Lancaster Community College",
    "domain": "dslcc.edu"
  },
  {
    "name": "Daemen College",
    "domain": "daemen.edu"
  },
  {
    "name": "Dakota College at Bottineau",
    "domain": "dakotacollege.edu"
  },
  {
    "name": "Dakota County Technical College",
    "domain": "dctc.edu"
  },
  {
    "name": "Dakota State University",
    "domain": "dsu.edu"
  },
  {
    "name": "Dakota Wesleyan University",
    "domain": "dwu.edu"
  },
  {
    "name": "Dallas Baptist University",
    "domain": "dbu.edu"
  },
  {
    "name": "Dallas College",
    "domain": "dallascollege.edu"
  },
  {
    "name": "Dallas County Community College",
    "domain": "dcccd.edu"
  },
  {
    "name": "Dalton State College",
    "domain": "daltonstate.edu"
  },
  {
    "name": "Dana College",
    "domain": "dana.edu"
  },
  {
    "name": "Daniel Webster College",
    "domain": "dwc.edu"
  },
  {
    "name": "Danville Area Community College",
    "domain": "dacc.edu"
  },
  {
    "name": "Danville Community College",
    "domain": "dcc.vccs.edu"
  },
  {
    "name": "Dartmouth College",
    "domain": "dartmouth.edu"
  },
  {
    "name": "Darton State College",
    "domain": "darton.edu"
  },
  {
    "name": "Davenport University",
    "domain": "davenport.edu"
  },
  {
    "name": "Davidson College",
    "domain": "davidson.edu"
  },
  {
    "name": "Davidson County Community College",
    "domain": "davidsonccc.edu"
  },
  {
    "name": "Davidson-Davie Community College",
    "domain": "davidsondavie.edu"
  },
  {
    "name": "Davis & Elkins College",
    "domain": "dne.wvnet.edu, dewv.edu"
  },
  {
    "name": "Davis College",
    "domain": "daviscollege.edu"
  },
  {
    "name": "Dawson Community College",
    "domain": "dawson.edu"
  },
  {
    "name": "Daytona State College",
    "domain": "daytonastate.edu"
  },
  {
    "name": "De Anza College",
    "domain": "deanza.edu"
  },
  {
    "name": "Defense Language Institute Foreign Language Center",
    "domain": "dliflc.edu"
  },
  {
    "name": "Defiance College",
    "domain": "defiance.edu"
  },
  {
    "name": "Del Mar College",
    "domain": "delmar.edu"
  },
  {
    "name": "Delaware College of Art and Design",
    "domain": "dcad.edu"
  },
  {
    "name": "Delaware County Community College",
    "domain": "dccc.edu"
  },
  {
    "name": "Delaware State University",
    "domain": "desu.edu"
  },
  {
    "name": "Delaware Technical Community College",
    "domain": "dtcc.edu"
  },
  {
    "name": "Delaware Valley University",
    "domain": "delval.edu"
  },
  {
    "name": "Delgado Community College",
    "domain": "dcc.edu"
  },
  {
    "name": "Delta College",
    "domain": "delta.edu"
  },
  {
    "name": "Delta State University",
    "domain": "deltastate.edu"
  },
  {
    "name": "Denison University",
    "domain": "denison.edu"
  },
  {
    "name": "Denmark Technical College",
    "domain": "denmarktech.edu"
  },
  {
    "name": "Denver College of Nursing",
    "domain": "denvercollegeofnursing.edu"
  },
  {
    "name": "DePaul University",
    "domain": "depaul.edu"
  },
  {
    "name": "DePauw University",
    "domain": "depauw.edu"
  },
  {
    "name": "Des Moines Area Community College",
    "domain": "dmacc.edu"
  },
  {
    "name": "Des Moines University",
    "domain": "dmu.edu"
  },
  {
    "name": "Detroit School of Technology",
    "domain": "dsdt.edu"
  },
  {
    "name": "DeVry Institute of Technology",
    "domain": "devry.edu"
  },
  {
    "name": "Diablo Valley College",
    "domain": "dvc.edu"
  },
  {
    "name": "Dickinson College",
    "domain": "dickinson.edu"
  },
  {
    "name": "Dickinson State University",
    "domain": "dickinsonstate.edu"
  },
  {
    "name": "DigiPen Institute of Technology",
    "domain": "digipen.edu"
  },
  {
    "name": "Dillard University",
    "domain": "dillard.edu"
  },
  {
    "name": "Doane University",
    "domain": "doane.edu"
  },
  {
    "name": "Dodge City Community College",
    "domain": "dc3.edu"
  },
  {
    "name": "Dominican College",
    "domain": "dominican.edu"
  },
  {
    "name": "Dominican University",
    "domain": "dom.edu"
  },
  {
    "name": "Dordt College",
    "domain": "dordt.edu"
  },
  {
    "name": "Dowling College",
    "domain": "dowling.edu"
  },
  {
    "name": "Drake University",
    "domain": "drake.edu"
  },
  {
    "name": "Drew University",
    "domain": "drew.edu"
  },
  {
    "name": "Drexel University",
    "domain": "drexel.edu"
  },
  {
    "name": "Drury College",
    "domain": "drury.edu"
  },
  {
    "name": "Duke University",
    "domain": "duke.edu"
  },
  {
    "name": "Duquesne University",
    "domain": "duq.edu"
  },
  {
    "name": "Durham Technical Community College",
    "domain": "durhamtech.edu"
  },
  {
    "name": "Dutchess Community College",
    "domain": "sunydutchess.edu"
  },
  {
    "name": "Dyersburg State Community College",
    "domain": "dscc.edu"
  },
  {
    "name": "Earlham College",
    "domain": "earlham.edu"
  },
  {
    "name": "East Arkansas Community College",
    "domain": "www.eacc.edu"
  },
  {
    "name": "East Carolina University",
    "domain": "ecu.edu"
  },
  {
    "name": "East Central College",
    "domain": "eastcentral.edu"
  },
  {
    "name": "East Central Community College",
    "domain": "eccc.edu"
  },
  {
    "name": "East Central University",
    "domain": "ecok.edu"
  },
  {
    "name": "East Los Angeles College",
    "domain": "elac.edu"
  },
  {
    "name": "East Mississippi Community College",
    "domain": "eastms.edu"
  },
  {
    "name": "East Stroudsburg State University of Pennsylvania",
    "domain": "esu.edu"
  },
  {
    "name": "East Tennessee State University",
    "domain": "etsu.edu"
  },
  {
    "name": "East Texas Baptist University",
    "domain": "etbu.edu"
  },
  {
    "name": "Eastern Arizona College",
    "domain": "eac.edu"
  },
  {
    "name": "Eastern Connecticut State University",
    "domain": "easternct.edu"
  },
  {
    "name": "Eastern Florida State College",
    "domain": "easternflorida.edu"
  },
  {
    "name": "Eastern Gateway Community College",
    "domain": "egcc.edu"
  },
  {
    "name": "Eastern Idaho Technical College",
    "domain": "eitc.edu"
  },
  {
    "name": "Eastern Illinois University",
    "domain": "eiu.edu"
  },
  {
    "name": "Eastern Iowa Community College District",
    "domain": "eicc.edu"
  },
  {
    "name": "Eastern Kentucky University",
    "domain": "eku.edu"
  },
  {
    "name": "Eastern Maine Community College",
    "domain": "emcc.edu"
  },
  {
    "name": "Eastern Mennonite University",
    "domain": "emu.edu"
  },
  {
    "name": "Eastern Michigan University",
    "domain": "emich.edu"
  },
  {
    "name": "Eastern New Mexico University",
    "domain": "enmu.edu"
  },
  {
    "name": "Eastern New Mexico University-Roswell Campus",
    "domain": "roswell.enmu.edu"
  },
  {
    "name": "Eastern Oklahoma State College",
    "domain": "eosc.edu"
  },
  {
    "name": "Eastern Oregon State College",
    "domain": "eou.edu"
  },
  {
    "name": "Eastern Shore Community College",
    "domain": "es.vccs.edu"
  },
  {
    "name": "Eastern Virginia Medical School",
    "domain": "evms.edu"
  },
  {
    "name": "Eastern Washington University",
    "domain": "ewu.edu"
  },
  {
    "name": "Eastern West Virginia Community and Technical College",
    "domain": "eastern.wvnet.edu"
  },
  {
    "name": "Eastern Wyoming College",
    "domain": "ewc.wy.edu"
  },
  {
    "name": "Eastfield College",
    "domain": "eastfieldcollege.edu"
  },
  {
    "name": "Eckerd College",
    "domain": "eckerd.edu"
  },
  {
    "name": "ECPI University",
    "domain": "ecpi.edu"
  },
  {
    "name": "Edgecombe Community College",
    "domain": "edgecombe.edu"
  },
  {
    "name": "Edgewood College",
    "domain": "edgewood.edu"
  },
  {
    "name": "Edinboro University of Pennsylvania",
    "domain": "edinboro.edu"
  },
  {
    "name": "Edison State Community College",
    "domain": "edisonohio.edu"
  },
  {
    "name": "Edmonds Community College",
    "domain": "edcc.edu"
  },
  {
    "name": "Edward Waters University",
    "domain": "ewc.edu"
  },
  {
    "name": "Einsteinmed",
    "domain": "einsteinmed.edu"
  },
  {
    "name": "El Camino College-Compton Center",
    "domain": "compton.edu"
  },
  {
    "name": "El Camino Community College District",
    "domain": "elcamino.edu"
  },
  {
    "name": "El Centro College",
    "domain": "elcentrocollege.edu"
  },
  {
    "name": "El Paso Community College",
    "domain": "epcc.edu"
  },
  {
    "name": "Elgin Community College",
    "domain": "elgin.edu"
  },
  {
    "name": "Elizabeth City State University",
    "domain": "ecsu.edu"
  },
  {
    "name": "Elizabethtown College",
    "domain": "etown.edu"
  },
  {
    "name": "Elizabethtown Community and Technical College",
    "domain": "elizabethtown.kctcs.edu"
  },
  {
    "name": "Elmhurst College",
    "domain": "elmhurst.edu"
  },
  {
    "name": "Elms College",
    "domain": "elms.edu"
  },
  {
    "name": "Elon College",
    "domain": "elon.edu"
  },
  {
    "name": "Embry-Riddle Aeronautical University",
    "domain": "erau.edu"
  },
  {
    "name": "Emerson College",
    "domain": "emerson.edu"
  },
  {
    "name": "Emmanuel College",
    "domain": "emmanuel.edu"
  },
  {
    "name": "Emory & Henry College",
    "domain": "ehc.edu"
  },
  {
    "name": "Emory University",
    "domain": "emory.edu"
  },
  {
    "name": "Emporia State University",
    "domain": "emporia.edu"
  },
  {
    "name": "Endicott College",
    "domain": "endicott.edu"
  },
  {
    "name": "Enterprise State Community College",
    "domain": "escc.edu"
  },
  {
    "name": "Erie Community College",
    "domain": "ecc.edu"
  },
  {
    "name": "Essex County College",
    "domain": "essex.edu"
  },
  {
    "name": "Estrella Mountain Community College",
    "domain": "estrellamountain.edu"
  },
  {
    "name": "Everest College",
    "domain": "everest.edu"
  },
  {
    "name": "Everett Community College",
    "domain": "everettcc.edu"
  },
  {
    "name": "Evergreen State College",
    "domain": "evergreen.edu"
  },
  {
    "name": "Evergreen Valley College",
    "domain": "evc.edu"
  },
  {
    "name": "Fairfield University",
    "domain": "fairfield.edu"
  },
  {
    "name": "Fairleigh Dickinson University",
    "domain": "fdu.edu"
  },
  {
    "name": "Fairmont State College",
    "domain": "fairmontstate.edu"
  },
  {
    "name": "Fayetteville State University",
    "domain": "uncfsu.edu"
  },
  {
    "name": "Fayetteville Technical Community College",
    "domain": "faytechcc.edu"
  },
  {
    "name": "Feather River Community College District",
    "domain": "frc.edu"
  },
  {
    "name": "Ferris State University",
    "domain": "ferris.edu"
  },
  {
    "name": "Fielding Institute",
    "domain": "fielding.edu"
  },
  {
    "name": "Finger Lakes Community College",
    "domain": "flcc.edu"
  },
  {
    "name": "Fisk University",
    "domain": "fisk.edu"
  },
  {
    "name": "Fitchburg State College",
    "domain": "fsc.edu"
  },
  {
    "name": "Flathead Valley Community College",
    "domain": "fvcc.edu"
  },
  {
    "name": "Flint Hills Technical College",
    "domain": "fhtc.edu"
  },
  {
    "name": "Florence-Darlington Technical College",
    "domain": "www.fdtc.edu"
  },
  {
    "name": "Florida Agricultural and Mechanical University",
    "domain": "famu.edu"
  },
  {
    "name": "Florida Atlantic University",
    "domain": "fau.edu"
  },
  {
    "name": "Florida Gulf Coast University",
    "domain": "fgcu.edu"
  },
  {
    "name": "Florida Institute of Technology",
    "domain": "fit.edu"
  },
  {
    "name": "Florida International University",
    "domain": "fiu.edu"
  },
  {
    "name": "Florida Keys Community College",
    "domain": "fkcc.edu"
  },
  {
    "name": "Florida Memorial University",
    "domain": "fmuniv.edu"
  },
  {
    "name": "Florida Polytechnic University",
    "domain": "floridapoly.edu"
  },
  {
    "name": "Florida Southern College",
    "domain": "flsouthern.edu"
  },
  {
    "name": "Florida SouthWestern State College",
    "domain": "fsw.edu"
  },
  {
    "name": "Florida State College at Jacksonville",
    "domain": "fscj.edu"
  },
  {
    "name": "Florida State University",
    "domain": "fsu.edu"
  },
  {
    "name": "Folsom Lake College",
    "domain": "flc.losrios.edu"
  },
  {
    "name": "Fond du Lac Tribal and Community College",
    "domain": "fdltcc.edu"
  },
  {
    "name": "Fontbonne College",
    "domain": "fontbonne.edu"
  },
  {
    "name": "Foothill College",
    "domain": "foothill.edu"
  },
  {
    "name": "Foothill-De Anza Community College District",
    "domain": "fhda.edu"
  },
  {
    "name": "Fordham University",
    "domain": "fordham.edu"
  },
  {
    "name": "Forsyth Technical Community College",
    "domain": "forsythtech.edu"
  },
  {
    "name": "Fort Hays State University",
    "domain": "fhsu.edu"
  },
  {
    "name": "Fort Lewis College",
    "domain": "fortlewis.edu"
  },
  {
    "name": "Fort Peck Community College",
    "domain": "fpcc.edu"
  },
  {
    "name": "Fort Scott Community College",
    "domain": "fortscott.edu"
  },
  {
    "name": "Fort Valley State University",
    "domain": "fvsu.edu"
  },
  {
    "name": "Fountainhead College of Technology",
    "domain": "fountainheadcollege.edu"
  },
  {
    "name": "Fox College",
    "domain": "foxcollege.edu"
  },
  {
    "name": "Fox Valley Technical College",
    "domain": "fvtc.edu"
  },
  {
    "name": "Francis Marion University",
    "domain": "g.fmarion.edu"
  },
  {
    "name": "Frank Phillips College",
    "domain": "fpctx.edu"
  },
  {
    "name": "Franklin and Marshall College",
    "domain": "fandm.edu"
  },
  {
    "name": "Franklin Pierce Law Center",
    "domain": "fplc.edu"
  },
  {
    "name": "Franklin Pierce University",
    "domain": "franklinpierce.edu"
  },
  {
    "name": "Franklin University",
    "domain": "franklin.edu"
  },
  {
    "name": "Frederick Community College",
    "domain": "frederick.edu"
  },
  {
    "name": "Fresno City College",
    "domain": "fresnocitycollege.edu"
  },
  {
    "name": "Fresno Pacific University",
    "domain": "fresno.edu"
  },
  {
    "name": "Friends University",
    "domain": "friends.edu"
  },
  {
    "name": "Front Range Community College",
    "domain": "frontrange.edu"
  },
  {
    "name": "Frostburg State University",
    "domain": "frostburg.edu"
  },
  {
    "name": "Full Sail University",
    "domain": "fullsail.edu"
  },
  {
    "name": "Fuller Theological Seminary",
    "domain": "fuller.edu"
  },
  {
    "name": "Fullerton College",
    "domain": "fullcoll.edu"
  },
  {
    "name": "Fulton-Montgomery Community College",
    "domain": "fmcc.edu"
  },
  {
    "name": "Furman University",
    "domain": "furman.edu"
  },
  {
    "name": "Gadsden State Community College",
    "domain": "gadsdenstate.edu"
  },
  {
    "name": "Galen College of Nursing-Louisville",
    "domain": "galencollege.edu"
  },
  {
    "name": "Gallaudet University",
    "domain": "gallaudet.edu"
  },
  {
    "name": "Galveston College",
    "domain": "gc.edu"
  },
  {
    "name": "Gannon University",
    "domain": "gannon.edu"
  },
  {
    "name": "Garden City Community College",
    "domain": "gcccks.edu"
  },
  {
    "name": "Garrett College",
    "domain": "garrettcollege.edu"
  },
  {
    "name": "Gasden State Community College",
    "domain": "gadsenstate.edu"
  },
  {
    "name": "Gaston College",
    "domain": "gaston.edu"
  },
  {
    "name": "Gateway Community and Technical College",
    "domain": "gateway.kctcs.edu"
  },
  {
    "name": "GateWay Community College",
    "domain": "gatewaycc.edu, gwcc.commnet.edu"
  },
  {
    "name": "Gateway Technical College",
    "domain": "gtc.edu"
  },
  {
    "name": "Gavilan College",
    "domain": "gavilan.edu"
  },
  {
    "name": "Genesee Community College",
    "domain": "genesee.edu"
  },
  {
    "name": "Geneva College",
    "domain": "geneva.edu"
  },
  {
    "name": "George C Wallace State Community College-Dothan",
    "domain": "wallace.edu"
  },
  {
    "name": "George C Wallace State Community College-Hanceville",
    "domain": "wallacestate.edu"
  },
  {
    "name": "George C Wallace State Community College-Selma",
    "domain": "wccs.edu"
  },
  {
    "name": "George Fox College",
    "domain": "gfc.edu"
  },
  {
    "name": "George Fox University",
    "domain": "georgefox.edu"
  },
  {
    "name": "George Mason University",
    "domain": "gmu.edu"
  },
  {
    "name": "George Washington University",
    "domain": "gwu.edu"
  },
  {
    "name": "Georgetown University",
    "domain": "georgetown.edu"
  },
  {
    "name": "Georgia College",
    "domain": "gcsu.edu"
  },
  {
    "name": "Georgia Gwinnett College",
    "domain": "ggc.edu"
  },
  {
    "name": "Georgia Highlands College",
    "domain": "highlands.edu"
  },
  {
    "name": "Georgia Institute of Technology",
    "domain": "gatech.edu"
  },
  {
    "name": "Georgia Military College",
    "domain": "gmc.cc.ga.us"
  },
  {
    "name": "Georgia Northwestern Technical College",
    "domain": "gntc.edu"
  },
  {
    "name": "Georgia Perimeter College",
    "domain": "gpc.edu"
  },
  {
    "name": "Georgia Piedmont Technical College",
    "domain": "gptc.edu"
  },
  {
    "name": "Georgia Southern University",
    "domain": "georgiasouthern.edu"
  },
  {
    "name": "Georgia Southwestern State University",
    "domain": "gsw.edu"
  },
  {
    "name": "Georgia State University",
    "domain": "gsu.edu"
  },
  {
    "name": "Georgian Court University",
    "domain": "georgian.edu"
  },
  {
    "name": "Germanna Community College",
    "domain": "germanna.edu"
  },
  {
    "name": "Gettysburg College",
    "domain": "gettysburg.edu"
  },
  {
    "name": "Glen Oaks Community College",
    "domain": "glenoaks.edu"
  },
  {
    "name": "Glendale Community College",
    "domain": "gccaz.edu, glendale.edu"
  },
  {
    "name": "Globe University & Minnesota School of Business",
    "domain": "msbcollege.edu"
  },
  {
    "name": "Gloucester County College",
    "domain": "gccnj.edu"
  },
  {
    "name": "GMI Engineering and Management Institute",
    "domain": "gmi.edu"
  },
  {
    "name": "Gogebic Community College",
    "domain": "gogebic.edu"
  },
  {
    "name": "Golden Gate University",
    "domain": "ggu.edu"
  },
  {
    "name": "Golden West College",
    "domain": "goldenwestcollege.edu"
  },
  {
    "name": "Goldey-Beacom College",
    "domain": "gbc.edu"
  },
  {
    "name": "Gonzaga University",
    "domain": "gonzaga.edu"
  },
  {
    "name": "Goshen College",
    "domain": "goshen.edu"
  },
  {
    "name": "Goucher College",
    "domain": "goucher.edu"
  },
  {
    "name": "Governors State University",
    "domain": "govst.edu"
  },
  {
    "name": "Grace College",
    "domain": "grace.edu"
  },
  {
    "name": "Graceland College",
    "domain": "graceland.edu"
  },
  {
    "name": "Grambling State University",
    "domain": "gram.edu"
  },
  {
    "name": "Grand Canyon University",
    "domain": "gcu.edu"
  },
  {
    "name": "Grand Rapids Community College",
    "domain": "grcc.edu"
  },
  {
    "name": "Grand Valley State University",
    "domain": "gvsu.edu"
  },
  {
    "name": "Grand View University",
    "domain": "grandview.edu"
  },
  {
    "name": "Grays Harbor College",
    "domain": "ghc.edu"
  },
  {
    "name": "Grayson College",
    "domain": "grayson.edu"
  },
  {
    "name": "Great Basin College",
    "domain": "gbcnv.edu"
  },
  {
    "name": "Great Bay Community College",
    "domain": "greatbay.edu"
  },
  {
    "name": "Great Falls College Montana State University",
    "domain": "gfcmsu.edu"
  },
  {
    "name": "Green River Community College",
    "domain": "greenriver.edu"
  },
  {
    "name": "Greenfield Community College",
    "domain": "gcc.mass.edu"
  },
  {
    "name": "Greenleaf University",
    "domain": "greenleaf.edu"
  },
  {
    "name": "Greensboro College",
    "domain": "greensboro.edu"
  },
  {
    "name": "Greenville Technical College",
    "domain": "gvltec.edu"
  },
  {
    "name": "Greenville University",
    "domain": "greenville.edu"
  },
  {
    "name": "Grinnell College",
    "domain": "grinnell.edu"
  },
  {
    "name": "Grossmont College",
    "domain": "grossmont.edu"
  },
  {
    "name": "Guilford College",
    "domain": "guilford.edu"
  },
  {
    "name": "Guilford Technical Community College",
    "domain": "gtcc.edu"
  },
  {
    "name": "Gulf Coast State College",
    "domain": "gulfcoast.edu"
  },
  {
    "name": "Gustavus Adolphus College",
    "domain": "gac.edu, gustavus.edu"
  },
  {
    "name": "Gwinnett Technical College",
    "domain": "gwinnetttech.edu"
  },
  {
    "name": "Gwynedd Mercy University",
    "domain": "gmercyu.edu"
  },
  {
    "name": "H Councill Trenholm State Technical College",
    "domain": "trenholmstate.edu"
  },
  {
    "name": "Hagerstown Community College",
    "domain": "hagerstowncc.edu"
  },
  {
    "name": "Halifax Community College",
    "domain": "halifaxcc.edu"
  },
  {
    "name": "Hallmark University",
    "domain": "hallmarkuniversity.edu"
  },
  {
    "name": "Hamilton College",
    "domain": "hamilton.edu"
  },
  {
    "name": "Hamline University",
    "domain": "hamline.edu"
  },
  {
    "name": "Hampden-Sydney College",
    "domain": "hsc.edu"
  },
  {
    "name": "Hampshire College",
    "domain": "hampshire.edu"
  },
  {
    "name": "Hampton University",
    "domain": "hamptonu.edu"
  },
  {
    "name": "Hanover College",
    "domain": "hanover.edu"
  },
  {
    "name": "Harcum College",
    "domain": "harcum.edu"
  },
  {
    "name": "Harding University",
    "domain": "harding.edu"
  },
  {
    "name": "Harford Community College",
    "domain": "harford.edu"
  },
  {
    "name": "Harper College",
    "domain": "harpercollege.edu"
  },
  {
    "name": "Harris-Stowe State University",
    "domain": "hssu.edu"
  },
  {
    "name": "Harrisburg Area Community College-Harrisburg",
    "domain": "hacc.edu"
  },
  {
    "name": "Hartnell College",
    "domain": "hartnell.edu"
  },
  {
    "name": "Hartwick College",
    "domain": "hartwick.edu"
  },
  {
    "name": "Harvard University",
    "domain": "harvard.edu"
  },
  {
    "name": "Harvey Mudd College",
    "domain": "hmc.edu"
  },
  {
    "name": "Haskell Indian Nations University",
    "domain": "haskell.edu"
  },
  {
    "name": "Hastings College",
    "domain": "hastings.edu"
  },
  {
    "name": "Haverford College in Pennsylvania",
    "domain": "haverford.edu"
  },
  {
    "name": "Hawaii Community College",
    "domain": "hawaii.hawaii.edu"
  },
  {
    "name": "Hawaii Pacific University",
    "domain": "hpu.edu"
  },
  {
    "name": "Hawkeye Community College",
    "domain": "hawkeyecollege.edu"
  },
  {
    "name": "Haywood Community College",
    "domain": "haywood.edu"
  },
  {
    "name": "Hazard Community and Technical College",
    "domain": "hazard.kctcs.edu"
  },
  {
    "name": "Heartland Community College",
    "domain": "heartland.edu"
  },
  {
    "name": "Heidelberg College",
    "domain": "heidelberg.edu"
  },
  {
    "name": "Helena College University of Montana",
    "domain": "umhelena.edu"
  },
  {
    "name": "Hellenic American University",
    "domain": "hauniv.edu"
  },
  {
    "name": "Henderson Community College",
    "domain": "hencc.kctcs.edu"
  },
  {
    "name": "Hendrix College",
    "domain": "hendrix.edu"
  },
  {
    "name": "Hennepin Technical College",
    "domain": "hennepintech.edu"
  },
  {
    "name": "Henry Ford College",
    "domain": "hfcc.edu"
  },
  {
    "name": "Herkimer County Community College",
    "domain": "herkimer.edu"
  },
  {
    "name": "Hesston College",
    "domain": "hesston.edu"
  },
  {
    "name": "Hibbing Community College",
    "domain": "hibbing.edu"
  },
  {
    "name": "High Point University",
    "domain": "highpoint.edu"
  },
  {
    "name": "Highland Community College",
    "domain": "highland.edu, highlandcc.edu"
  },
  {
    "name": "Highline Community College",
    "domain": "highline.edu"
  },
  {
    "name": "Hill College",
    "domain": "hillcollege.edu"
  },
  {
    "name": "Hillsborough Community College",
    "domain": "hccfl.edu"
  },
  {
    "name": "Hillsdale College",
    "domain": "hillsdale.edu"
  },
  {
    "name": "Hinds Community College",
    "domain": "hindscc.edu"
  },
  {
    "name": "Hiram College",
    "domain": "hiram.edu"
  },
  {
    "name": "Hobart and William Smith Colleges",
    "domain": "hws.edu"
  },
  {
    "name": "Hocking College",
    "domain": "hocking.edu"
  },
  {
    "name": "Hofstra University",
    "domain": "hofstra.edu"
  },
  {
    "name": "Hollins College",
    "domain": "hollins.edu"
  },
  {
    "name": "Holmes Community College",
    "domain": "holmescc.edu"
  },
  {
    "name": "Holyoke Community College",
    "domain": "hcc.edu"
  },
  {
    "name": "Honolulu Community College",
    "domain": "honolulu.hawaii.edu"
  },
  {
    "name": "Hood College",
    "domain": "hood.edu"
  },
  {
    "name": "Hood Theological",
    "domain": "hoodseminary.edu"
  },
  {
    "name": "Hope College",
    "domain": "hope.edu"
  },
  {
    "name": "Hopkinsville Community College",
    "domain": "hopkinsville.kctcs.edu"
  },
  {
    "name": "Horry-Georgetown Technical College",
    "domain": "hgtc.edu"
  },
  {
    "name": "Housatonic Community College",
    "domain": "hcc.commnet.edu"
  },
  {
    "name": "Houston Baptist University",
    "domain": "hbu.edu"
  },
  {
    "name": "Houston Community College",
    "domain": "hccs.edu"
  },
  {
    "name": "Howard College",
    "domain": "howardcollege.edu"
  },
  {
    "name": "Howard Community College",
    "domain": "howardcc.edu"
  },
  {
    "name": "Howard University",
    "domain": "howard.edu"
  },
  {
    "name": "Hudson County Community College",
    "domain": "hccc.edu"
  },
  {
    "name": "Hudson Valley Community College",
    "domain": "hvcc.edu"
  },
  {
    "name": "Humboldt State University",
    "domain": "humboldt.edu"
  },
  {
    "name": "Hunter College CUNY",
    "domain": "hunter.cuny.edu"
  },
  {
    "name": "Huntingdon College",
    "domain": "huntingdon.edu"
  },
  {
    "name": "Huntington Junior College",
    "domain": "huntingtonjuniorcollege.edu"
  },
  {
    "name": "Huntington University",
    "domain": "huntington.edu"
  },
  {
    "name": "Huston-Tillotson University",
    "domain": "htu.edu"
  },
  {
    "name": "Hutchinson Community College",
    "domain": "hutchcc.edu"
  },
  {
    "name": "Icahn School of Medicine at Mount Sinai",
    "domain": "mssm.edu"
  },
  {
    "name": "ICI University",
    "domain": "ici.edu"
  },
  {
    "name": "Idaho State University",
    "domain": "isu.edu"
  },
  {
    "name": "Ilisagvik College",
    "domain": "ilisagvik.edu"
  },
  {
    "name": "Illinois Benedictine College",
    "domain": "ibc.edu"
  },
  {
    "name": "Illinois Central College",
    "domain": "icc.edu"
  },
  {
    "name": "Illinois Eastern Community Colleges",
    "domain": "iecc.edu"
  },
  {
    "name": "Illinois Institute of Technology",
    "domain": "iit.edu, hawk.iit.edu"
  },
  {
    "name": "Illinois State University",
    "domain": "illinoisstate.edu, ilstu.edu"
  },
  {
    "name": "Illinois Valley Community College",
    "domain": "ivcc.edu"
  },
  {
    "name": "Illinois Wesleyan University",
    "domain": "iwu.edu"
  },
  {
    "name": "Imperial Valley College",
    "domain": "imperial.edu"
  },
  {
    "name": "Independence Community College",
    "domain": "indycc.edu"
  },
  {
    "name": "Indian Hills Community College",
    "domain": "indianhills.edu"
  },
  {
    "name": "Indian River State College",
    "domain": "irsc.edu"
  },
  {
    "name": "Indiana Institute of Technology",
    "domain": "indianatech.edu, indianatech.net"
  },
  {
    "name": "Indiana State University",
    "domain": "indstate.edu"
  },
  {
    "name": "Indiana University",
    "domain": "iu.edu"
  },
  {
    "name": "Indiana University - Bloomington",
    "domain": "indiana.edu, iub.edu, bloomington.iu.edu"
  },
  {
    "name": "Indiana University at South Bend",
    "domain": "iusb.edu"
  },
  {
    "name": "Indiana University of Pennsylvania",
    "domain": "iup.edu"
  },
  {
    "name": "Indiana University Southeast",
    "domain": "ius.edu"
  },
  {
    "name": "Indiana University/Purdue University at Columbus",
    "domain": "iupuc.edu"
  },
  {
    "name": "Indiana University/Purdue University at Fort Wayne",
    "domain": "ipfw.edu"
  },
  {
    "name": "Indiana University/Purdue University at Indianapolis",
    "domain": "iupui.edu"
  },
  {
    "name": "Indiana Wesleyan University, Marion",
    "domain": "indwes.edu"
  },
  {
    "name": "Institute for Advanced Study",
    "domain": "ias.edu"
  },
  {
    "name": "Institute for World Politics",
    "domain": "iwp.edu"
  },
  {
    "name": "Interdenominational Theological Center",
    "domain": "itc.edu"
  },
  {
    "name": "International Technological University",
    "domain": "itu.edu"
  },
  {
    "name": "Inver Hills Community College",
    "domain": "inverhills.edu"
  },
  {
    "name": "Iona College",
    "domain": "iona.edu"
  },
  {
    "name": "Iowa Central Community College",
    "domain": "iowacentral.edu"
  },
  {
    "name": "Iowa Lakes Community College",
    "domain": "iowalakes.edu"
  },
  {
    "name": "Iowa State University",
    "domain": "iastate.edu"
  },
  {
    "name": "Iowa Western Community College",
    "domain": "iwcc.edu"
  },
  {
    "name": "Irvine Valley College",
    "domain": "ivc.edu"
  },
  {
    "name": "Island Drafting & Technical Institute",
    "domain": "idti.edu"
  },
  {
    "name": "Isothermal Community College",
    "domain": "isothermal.edu"
  },
  {
    "name": "Itasca Community College",
    "domain": "itascacc.edu"
  },
  {
    "name": "Itawamba Community College",
    "domain": "iccms.edu"
  },
  {
    "name": "Ithaca College",
    "domain": "ithaca.edu"
  },
  {
    "name": "ITT Technical Institute",
    "domain": "itt-tech.info, itt-tech.edu"
  },
  {
    "name": "Ivy Tech Community College",
    "domain": "ivytech.edu"
  },
  {
    "name": "J F Drake State Community and Technical College",
    "domain": "drakestate.edu"
  },
  {
    "name": "J Sargeant Reynolds Community College",
    "domain": "reynolds.edu"
  },
  {
    "name": "Jackson College",
    "domain": "jccmi.edu"
  },
  {
    "name": "Jackson State Community College",
    "domain": "jscc.edu"
  },
  {
    "name": "Jackson State University",
    "domain": "jsums.edu"
  },
  {
    "name": "Jacksonville College-Main Campus",
    "domain": "jacksonville-college.edu"
  },
  {
    "name": "Jacksonville State University",
    "domain": "jsu.edu"
  },
  {
    "name": "Jacksonville University",
    "domain": "ju.edu"
  },
  {
    "name": "James A Rhodes State College",
    "domain": "rhodesstate.edu"
  },
  {
    "name": "James H Faulkner State Community College",
    "domain": "faulknerstate.edu"
  },
  {
    "name": "James Madison University",
    "domain": "jmu.edu"
  },
  {
    "name": "James Sprunt Community College",
    "domain": "jamessprunt.edu"
  },
  {
    "name": "Jamestown Community College",
    "domain": "sunyjcc.edu"
  },
  {
    "name": "Jarvis Christian College",
    "domain": "jarvis.edu"
  },
  {
    "name": "Jefferson College",
    "domain": "jeffco.edu"
  },
  {
    "name": "Jefferson Community and Technical College",
    "domain": "jefferson.kctcs.edu"
  },
  {
    "name": "Jefferson Community College",
    "domain": "sunyjefferson.edu"
  },
  {
    "name": "Jefferson Davis Community College",
    "domain": "jdcc.edu"
  },
  {
    "name": "Jefferson State Community College",
    "domain": "jeffstateonline.com"
  },
  {
    "name": "John A Gupton College",
    "domain": "guptoncollege.edu"
  },
  {
    "name": "John A Logan College",
    "domain": "jalc.edu"
  },
  {
    "name": "John Brown University",
    "domain": "jbu.edu"
  },
  {
    "name": "John F. Kennedy University",
    "domain": "jfku.edu"
  },
  {
    "name": "John Tyler Community College",
    "domain": "jtcc.edu"
  },
  {
    "name": "John Wood Community College",
    "domain": "jwcc.edu"
  },
  {
    "name": "Johns Hopkins University",
    "domain": "jh.edu, jhu.edu, johnshopkins.edu"
  },
  {
    "name": "Johns Hopkins University Applied Physics Laboratory",
    "domain": "jhuapl.edu"
  },
  {
    "name": "Johnson & Wales University",
    "domain": "jwu.edu"
  },
  {
    "name": "Johnson Bible College",
    "domain": "jbc.edu"
  },
  {
    "name": "Johnson C Smith Theological Seminary *",
    "domain": "smithseminary.org"
  },
  {
    "name": "Johnson C. Smith University",
    "domain": "jcsu.edu"
  },
  {
    "name": "Johnson County Community College",
    "domain": "jccc.edu"
  },
  {
    "name": "Johnston Community College",
    "domain": "johnstoncc.edu"
  },
  {
    "name": "Joliet Junior College",
    "domain": "jjc.edu"
  },
  {
    "name": "Jones College",
    "domain": "jones.edu"
  },
  {
    "name": "Jones County Junior College",
    "domain": "jcjc.edu"
  },
  {
    "name": "Judson College",
    "domain": "judson.edu"
  },
  {
    "name": "Juniata College",
    "domain": "juniata.edu"
  },
  {
    "name": "Kalamazoo College",
    "domain": "kzoo.edu"
  },
  {
    "name": "Kalamazoo Valley Community College",
    "domain": "kvcc.edu"
  },
  {
    "name": "Kanawha Valley Community and Technical College",
    "domain": "kvctc.edu"
  },
  {
    "name": "Kankakee Community College",
    "domain": "kcc.edu"
  },
  {
    "name": "Kansas City Kansas Community College",
    "domain": "kckcc.edu"
  },
  {
    "name": "Kansas City University",
    "domain": "kansascity.edu"
  },
  {
    "name": "Kansas State University",
    "domain": "ksu.edu, k-state.edu"
  },
  {
    "name": "Kansas Wesleyan University",
    "domain": "kwu.edu"
  },
  {
    "name": "Kapiolani Community College",
    "domain": "kapiolani.hawaii.edu"
  },
  {
    "name": "Kaplan University",
    "domain": "kaplan.edu"
  },
  {
    "name": "Kaskaskia College",
    "domain": "kaskaskia.edu"
  },
  {
    "name": "Kauai Community College",
    "domain": "kauai.hawaii.edu"
  },
  {
    "name": "Kean College",
    "domain": "kean.edu"
  },
  {
    "name": "Keene State College",
    "domain": "keene.edu"
  },
  {
    "name": "Keiser University",
    "domain": "keiseruniversity.edu"
  },
  {
    "name": "Keller Graduate School of Management",
    "domain": "keller.edu"
  },
  {
    "name": "Kellogg Community College",
    "domain": "kellogg.edu"
  },
  {
    "name": "Kenai Peninsula College",
    "domain": "kpc.alaska.edu"
  },
  {
    "name": "Kennebec Valley Community College",
    "domain": "kvcc.me.edu"
  },
  {
    "name": "Kennesaw State University",
    "domain": "kennesaw.edu"
  },
  {
    "name": "Kent State University",
    "domain": "kent.edu"
  },
  {
    "name": "Kentucky Community & Technical College System",
    "domain": "kctcs.edu"
  },
  {
    "name": "Kentucky State University",
    "domain": "kysu.edu"
  },
  {
    "name": "Kenyon College",
    "domain": "kenyon.edu"
  },
  {
    "name": "Kettering University",
    "domain": "kettering.edu"
  },
  {
    "name": "Keweenaw Bay Ojibwa Community College",
    "domain": "kbocc.org"
  },
  {
    "name": "Kilgore College",
    "domain": "kilgore.edu"
  },
  {
    "name": "Kilian Community College",
    "domain": "kilian.edu"
  },
  {
    "name": "King University",
    "domain": "king.edu"
  },
  {
    "name": "King's College",
    "domain": "kings.edu"
  },
  {
    "name": "Kirkwood Community College",
    "domain": "kirkwood.edu"
  },
  {
    "name": "Kirtland Community College",
    "domain": "kirtland.edu"
  },
  {
    "name": "Kishwaukee College",
    "domain": "kishwaukeecollege.edu"
  },
  {
    "name": "Klamath Community College",
    "domain": "klamathcc.edu"
  },
  {
    "name": "Knox College",
    "domain": "knox.edu"
  },
  {
    "name": "Knoxville College",
    "domain": "knoxvillecollege.edu"
  },
  {
    "name": "Kodiak College",
    "domain": "koc.alaska.edu"
  },
  {
    "name": "Kutztown University of Pennsylvania",
    "domain": "kutztown.edu"
  },
  {
    "name": "L E Fletcher Technical Community College",
    "domain": "fletcher.edu"
  },
  {
    "name": "La Sierra University",
    "domain": "lasierra.edu"
  },
  {
    "name": "Labette Community College",
    "domain": "labette.edu"
  },
  {
    "name": "Lac Courte Oreilles Ojibwa Community College",
    "domain": "lco.edu"
  },
  {
    "name": "Lackawanna College",
    "domain": "lackawanna.edu"
  },
  {
    "name": "Lafayette College",
    "domain": "lafayette.edu"
  },
  {
    "name": "LaGrange College",
    "domain": "lagrange.edu"
  },
  {
    "name": "Lake Area Technical Institute",
    "domain": "lakeareatech.edu"
  },
  {
    "name": "Lake Erie College of Osteopathic Medicine",
    "domain": "lecom.edu"
  },
  {
    "name": "Lake Forest College",
    "domain": "lfc.edu"
  },
  {
    "name": "Lake Land College",
    "domain": "lakeland.cc.il.us"
  },
  {
    "name": "Lake Michigan College",
    "domain": "lakemichigancollege.edu"
  },
  {
    "name": "Lake Region State College",
    "domain": "lrsc.edu"
  },
  {
    "name": "Lake Superior College",
    "domain": "lsc.edu"
  },
  {
    "name": "Lake Superior State University",
    "domain": "lssu.edu"
  },
  {
    "name": "Lake Tahoe Community College",
    "domain": "ltcc.edu"
  },
  {
    "name": "Lakeland Community College",
    "domain": "lakelandcc.edu"
  },
  {
    "name": "Lakes Region Community College",
    "domain": "lrcc.edu"
  },
  {
    "name": "Lakeshore Technical College",
    "domain": "gotoltc.edu"
  },
  {
    "name": "Lamar Community College",
    "domain": "lamarcc.edu"
  },
  {
    "name": "Lamar Institute of Technology",
    "domain": "lit.edu"
  },
  {
    "name": "Lamar State College-Orange",
    "domain": "lsco.edu"
  },
  {
    "name": "Lamar State College-Port Arthur",
    "domain": "lamarpa.edu"
  },
  {
    "name": "Lamar University",
    "domain": "lamar.edu"
  },
  {
    "name": "Lander University",
    "domain": "lander.edu"
  },
  {
    "name": "Lane College",
    "domain": "lanecollege.edu"
  },
  {
    "name": "Lane Community College",
    "domain": "lanecc.edu"
  },
  {
    "name": "Laney College",
    "domain": "laney.edu"
  },
  {
    "name": "Langston University",
    "domain": "langston.edu"
  },
  {
    "name": "Lanier Technical College",
    "domain": "laniertech.edu"
  },
  {
    "name": "Lansing Community College",
    "domain": "lcc.edu"
  },
  {
    "name": "Laramie County Community College",
    "domain": "lccc.wy.edu"
  },
  {
    "name": "Laredo Community College",
    "domain": "laredo.edu"
  },
  {
    "name": "Las Positas College",
    "domain": "laspositascollege.edu"
  },
  {
    "name": "LaSalle University",
    "domain": "lasalle.edu"
  },
  {
    "name": "Lasell College",
    "domain": "lasell.edu"
  },
  {
    "name": "Lassen Community College",
    "domain": "lassencollege.edu"
  },
  {
    "name": "Latter-day Saints Business College",
    "domain": "ldsbc.edu"
  },
  {
    "name": "Laurus College",
    "domain": "lauruscollege.edu"
  },
  {
    "name": "Lawrence Technological University",
    "domain": "ltu.edu"
  },
  {
    "name": "Lawrence University",
    "domain": "lawrence.edu"
  },
  {
    "name": "Lawson State Community College",
    "domain": "lawsonstate.edu"
  },
  {
    "name": "Le Moyne College",
    "domain": "lemoyne.edu"
  },
  {
    "name": "Lebanon Valley College",
    "domain": "lvc.edu"
  },
  {
    "name": "Lee College",
    "domain": "lee.edu"
  },
  {
    "name": "Leech Lake Tribal College",
    "domain": "lltc.edu"
  },
  {
    "name": "Leeward Community College",
    "domain": "leeward.hawaii.edu"
  },
  {
    "name": "Lehigh Carbon Community College",
    "domain": "lccc.edu"
  },
  {
    "name": "Lehigh University",
    "domain": "lehigh.edu"
  },
  {
    "name": "LeMoyne-Owen College",
    "domain": "loc.edu"
  },
  {
    "name": "Lenoir Community College",
    "domain": "lenoircc.edu"
  },
  {
    "name": "Lenoir-Rhyne College",
    "domain": "lrc.edu"
  },
  {
    "name": "Lenoir-Rhyne University",
    "domain": "lr.edu"
  },
  {
    "name": "Lesley University",
    "domain": "lesley.edu"
  },
  {
    "name": "LeTourneau University",
    "domain": "letu.edu"
  },
  {
    "name": "Lewis & Clark College",
    "domain": "lclark.edu"
  },
  {
    "name": "Lewis and Clark Community College",
    "domain": "lc.edu"
  },
  {
    "name": "Lewis University",
    "domain": "lewisu.edu"
  },
  {
    "name": "Lewis-Clark State College",
    "domain": "lcsc.edu"
  },
  {
    "name": "Liberty University",
    "domain": "liberty.edu"
  },
  {
    "name": "Lincoln Land Community College",
    "domain": "llcc.edu"
  },
  {
    "name": "Lincoln Memorial University",
    "domain": "lmunet.edu"
  },
  {
    "name": "Lincoln University",
    "domain": "lincoln.edu"
  },
  {
    "name": "Lindenwood University",
    "domain": "lindenwood.edu"
  },
  {
    "name": "Linfield College",
    "domain": "linfield.edu"
  },
  {
    "name": "Linn State Technical College",
    "domain": "linnstate.edu"
  },
  {
    "name": "Linn-Benton Community College",
    "domain": "linnbenton.edu"
  },
  {
    "name": "Lipscomb University",
    "domain": "lipscomb.edu"
  },
  {
    "name": "Little Big Horn College",
    "domain": "lbhc.edu"
  },
  {
    "name": "Little Priest Tribal College",
    "domain": "littlepriest.edu"
  },
  {
    "name": "Livingstone College",
    "domain": "livingstone.edu"
  },
  {
    "name": "Lock Haven University",
    "domain": "lhup.edu, lockhaven.edu"
  },
  {
    "name": "Loma Linda University",
    "domain": "llu.edu"
  },
  {
    "name": "Lone Star College System",
    "domain": "lonestar.edu"
  },
  {
    "name": "Long Beach City College",
    "domain": "lbcc.edu"
  },
  {
    "name": "Long Island University",
    "domain": "liunet.edu"
  },
  {
    "name": "Longwood University",
    "domain": "longwood.edu"
  },
  {
    "name": "Lorain County Community College",
    "domain": "lorainccc.edu"
  },
  {
    "name": "Loras College",
    "domain": "loras.edu"
  },
  {
    "name": "Lord Fairfax Community College",
    "domain": "lfcc.edu"
  },
  {
    "name": "Los Angeles City College",
    "domain": "lacitycollege.edu"
  },
  {
    "name": "Los Angeles Community College District",
    "domain": "laccd.edu"
  },
  {
    "name": "Los Angeles County College of Nursing and Allied Health",
    "domain": "lacounty.org"
  },
  {
    "name": "Los Angeles Harbor College",
    "domain": "lahc.edu"
  },
  {
    "name": "Los Angeles Mission College",
    "domain": "lamission.edu"
  },
  {
    "name": "Los Angeles Pierce College",
    "domain": "piercecollege.edu"
  },
  {
    "name": "Los Angeles Southwest College",
    "domain": "lasc.edu"
  },
  {
    "name": "Los Angeles Trade Technical College",
    "domain": "lattc.edu"
  },
  {
    "name": "Los Angeles Valley College",
    "domain": "lavc.edu"
  },
  {
    "name": "Los Medanos College",
    "domain": "losmedanos.edu"
  },
  {
    "name": "Los Rios Community College District",
    "domain": "losrios.edu"
  },
  {
    "name": "Louisburg College",
    "domain": "louisburg.edu"
  },
  {
    "name": "Louisiana College",
    "domain": "lacollege.edu"
  },
  {
    "name": "Louisiana Delta Community College",
    "domain": "ladelta.edu"
  },
  {
    "name": "Louisiana State University",
    "domain": "lsu.edu"
  },
  {
    "name": "Louisiana State University - Shreveport",
    "domain": "lsus.edu"
  },
  {
    "name": "Louisiana State University at Alexandria",
    "domain": "lsua.edu"
  },
  {
    "name": "Louisiana State University-Eunice",
    "domain": "lsue.edu"
  },
  {
    "name": "Louisiana Tech University",
    "domain": "latech.edu"
  },
  {
    "name": "Lower Columbia College",
    "domain": "lowercolumbia.edu"
  },
  {
    "name": "Loyola College",
    "domain": "loyola.edu"
  },
  {
    "name": "Loyola Marymount University",
    "domain": "lmu.edu"
  },
  {
    "name": "Loyola University Chicago",
    "domain": "luc.edu"
  },
  {
    "name": "Loyola University New Orleans",
    "domain": "loyno.edu"
  },
  {
    "name": "Luna Community College",
    "domain": "luna.edu"
  },
  {
    "name": "Lurleen B Wallace Community College",
    "domain": "lbwcc.edu"
  },
  {
    "name": "Luther College",
    "domain": "luther.edu"
  },
  {
    "name": "Luther Seminary",
    "domain": "luthersem.edu"
  },
  {
    "name": "Luzerne County Community College",
    "domain": "luzerne.edu"
  },
  {
    "name": "Lycoming College",
    "domain": "lycoming.edu"
  },
  {
    "name": "Lynchburg College",
    "domain": "lynchburg.edu"
  },
  {
    "name": "Lyndon State College",
    "domain": "lyndonstate.edu"
  },
  {
    "name": "Lynn University",
    "domain": "lynn.edu"
  },
  {
    "name": "Lyon College",
    "domain": "lyon.edu"
  },
  {
    "name": "Macalester College",
    "domain": "macalester.edu"
  },
  {
    "name": "MacCormac College",
    "domain": "maccormac.edu"
  },
  {
    "name": "Macomb Community College",
    "domain": "macomb.edu"
  },
  {
    "name": "Madison Area Technical College",
    "domain": "madisoncollege.edu"
  },
  {
    "name": "Madisonville Community College",
    "domain": "madisonville.kctcs.edu"
  },
  {
    "name": "Maharishi University of Management",
    "domain": "mum.edu"
  },
  {
    "name": "Malone College",
    "domain": "malone.edu"
  },
  {
    "name": "Manchester Community College",
    "domain": "mcc.commnet.edu, mccnh.edu"
  },
  {
    "name": "Manhattan Area Technical College",
    "domain": "manhattantech.edu"
  },
  {
    "name": "Manhattan College",
    "domain": "manhattan.edu"
  },
  {
    "name": "Manor College",
    "domain": "manor.edu"
  },
  {
    "name": "Mansfield University of Pennsylvania",
    "domain": "mansfield.edu"
  },
  {
    "name": "Maricopa Community Colleges",
    "domain": "maricopa.edu"
  },
  {
    "name": "Marietta College",
    "domain": "marietta.edu"
  },
  {
    "name": "Marine Biological Laboratory",
    "domain": "mbl.edu"
  },
  {
    "name": "Marion Military Institute",
    "domain": "marionmilitary.edu"
  },
  {
    "name": "Marion Technical College",
    "domain": "mtc.edu"
  },
  {
    "name": "Marist College",
    "domain": "marist.edu"
  },
  {
    "name": "Marlboro College",
    "domain": "marlboro.edu"
  },
  {
    "name": "Marquette University",
    "domain": "marquette.edu"
  },
  {
    "name": "Marshall University",
    "domain": "marshall.edu"
  },
  {
    "name": "Marshalltown Community College",
    "domain": "iavalley.edu"
  },
  {
    "name": "Martin Community College",
    "domain": "martincc.edu"
  },
  {
    "name": "Mary Baldwin College",
    "domain": "mbc.edu"
  },
  {
    "name": "Mary Washington College",
    "domain": "mwc.edu"
  },
  {
    "name": "Maryland Institute College of Arts",
    "domain": "mica.edu"
  },
  {
    "name": "Marymount Manhattan College",
    "domain": "mmm.edu"
  },
  {
    "name": "Marymount University",
    "domain": "marymount.edu"
  },
  {
    "name": "Maryville College",
    "domain": "maryvillecollege.edu"
  },
  {
    "name": "Maryville University",
    "domain": "maryville.edu"
  },
  {
    "name": "Marywood University",
    "domain": "marywood.edu"
  },
  {
    "name": "Massachusetts Bay Community College",
    "domain": "massbay.edu"
  },
  {
    "name": "Massachusetts Institute of Technology",
    "domain": "mit.edu"
  },
  {
    "name": "Massasoit Community College",
    "domain": "massasoit.mass.edu, massasoit.edu"
  },
  {
    "name": "Mat-Su College",
    "domain": "matsu.alaska.edu"
  },
  {
    "name": "Mayland Community College",
    "domain": "mayland.edu"
  },
  {
    "name": "Mayo Clinic",
    "domain": "mayo.edu"
  },
  {
    "name": "Maysville Community and Technical College",
    "domain": "maysville.kctcs.edu"
  },
  {
    "name": "McDaniel College",
    "domain": "mcdaniel.edu"
  },
  {
    "name": "McDowell Technical Community College",
    "domain": "mcdowelltech.edu"
  },
  {
    "name": "McHenry County College",
    "domain": "mchenry.edu"
  },
  {
    "name": "McLennan Community College",
    "domain": "mclennan.edu"
  },
  {
    "name": "McMurry University",
    "domain": "mcm.edu"
  },
  {
    "name": "McNeese State University",
    "domain": "mcneese.edu"
  },
  {
    "name": "McPherson College",
    "domain": "mcpherson.edu"
  },
  {
    "name": "Medical College of Georgia",
    "domain": "mcg.edu"
  },
  {
    "name": "Medical College of Wisconsin",
    "domain": "mcw.edu"
  },
  {
    "name": "Medical University of South Carolina",
    "domain": "musc.edu"
  },
  {
    "name": "Meharry Medical College",
    "domain": "mmc.edu"
  },
  {
    "name": "Mendocino College",
    "domain": "mendocino.edu"
  },
  {
    "name": "Merced College",
    "domain": "mccd.edu"
  },
  {
    "name": "Mercer County Community College",
    "domain": "mccc.edu"
  },
  {
    "name": "Mercer University",
    "domain": "mercer.edu"
  },
  {
    "name": "Mercy College",
    "domain": "mercymavericks.edu, mercy.edu"
  },
  {
    "name": "Mercyhurst University",
    "domain": "mercyhurst.edu"
  },
  {
    "name": "Meredith College",
    "domain": "meredith.edu"
  },
  {
    "name": "Meridian Community College",
    "domain": "meridiancc.edu"
  },
  {
    "name": "Merrimack College",
    "domain": "merrimack.edu"
  },
  {
    "name": "Merritt College",
    "domain": "merritt.edu"
  },
  {
    "name": "Mesa Community College",
    "domain": "mesacc.edu"
  },
  {
    "name": "Mesabi Range Community and Technical College",
    "domain": "mesabirange.edu"
  },
  {
    "name": "Mesalands Community College",
    "domain": "mesalands.edu"
  },
  {
    "name": "Messiah College",
    "domain": "messiah.edu"
  },
  {
    "name": "Metropolitan Community College (MO)",
    "domain": "mcckc.edu"
  },
  {
    "name": "Metropolitan Community College (NE)",
    "domain": "mccneb.edu"
  },
  {
    "name": "Metropolitan State College of Denver",
    "domain": "msudenver.edu"
  },
  {
    "name": "Metropolitan State University",
    "domain": "metrostate.edu"
  },
  {
    "name": "Miami Dade College",
    "domain": "mdc.edu"
  },
  {
    "name": "Miami University of Ohio",
    "domain": "miamioh.edu"
  },
  {
    "name": "Michigan State University",
    "domain": "msu.edu"
  },
  {
    "name": "Michigan Technological University",
    "domain": "mtu.edu"
  },
  {
    "name": "Mid Michigan Community College",
    "domain": "midmich.edu"
  },
  {
    "name": "Mid-America Nazarene College",
    "domain": "manc.edu"
  },
  {
    "name": "Mid-Plains Community College",
    "domain": "mpcc.edu"
  },
  {
    "name": "Mid-South Community College",
    "domain": "midsouthcc.edu"
  },
  {
    "name": "Mid-State Technical College",
    "domain": "mstc.edu"
  },
  {
    "name": "Middle Georgia State College",
    "domain": "mga.edu"
  },
  {
    "name": "Middle Tennessee State University",
    "domain": "mtsu.edu"
  },
  {
    "name": "Middlebury College",
    "domain": "middlebury.edu"
  },
  {
    "name": "Middlesex Community College",
    "domain": "mxcc.commnet.edu, middlesex.mass.edu"
  },
  {
    "name": "Middlesex County College",
    "domain": "middlesexcc.edu"
  },
  {
    "name": "Midlands Technical College",
    "domain": "midlandstech.edu"
  },
  {
    "name": "Midwestern State University",
    "domain": "mwsu.edu"
  },
  {
    "name": "Midwestern University",
    "domain": "midwestern.edu"
  },
  {
    "name": "Miles College",
    "domain": "miles.edu"
  },
  {
    "name": "Miles Community College",
    "domain": "milescc.edu"
  },
  {
    "name": "Miles School of Law",
    "domain": "mlaw.edu"
  },
  {
    "name": "Millersville University of Pennsylvania",
    "domain": "millersville.edu"
  },
  {
    "name": "Milligan College",
    "domain": "milligan.edu"
  },
  {
    "name": "Millikin University",
    "domain": "millikin.edu"
  },
  {
    "name": "Millsaps College",
    "domain": "millsaps.edu"
  },
  {
    "name": "Milwaukee Area Technical College",
    "domain": "matc.edu"
  },
  {
    "name": "Milwaukee School of Engineering",
    "domain": "msoe.edu"
  },
  {
    "name": "Mineral Area College",
    "domain": "mineralarea.edu"
  },
  {
    "name": "Minerva University",
    "domain": "minerva.edu"
  },
  {
    "name": "Minneapolis College of Art and Design",
    "domain": "mcad.edu"
  },
  {
    "name": "Minneapolis Community and Technical College",
    "domain": "minneapolis.edu"
  },
  {
    "name": "Minnesota State College-Southeast Technical",
    "domain": "southeastmn.edu"
  },
  {
    "name": "Minnesota State Community and Technical College",
    "domain": "minnesota.edu"
  },
  {
    "name": "Minnesota State University Moorhead",
    "domain": "mnstate.edu"
  },
  {
    "name": "Minnesota State University, Mankato",
    "domain": "mnsu.edu"
  },
  {
    "name": "Minnesota West Community and Technical College",
    "domain": "mnwest.edu"
  },
  {
    "name": "Minot State University",
    "domain": "minotstateu.edu"
  },
  {
    "name": "MiraCosta College",
    "domain": "miracosta.edu"
  },
  {
    "name": "Mission College",
    "domain": "missioncollege.edu"
  },
  {
    "name": "Mississippi College",
    "domain": "mc.edu"
  },
  {
    "name": "Mississippi Delta Community College",
    "domain": "msdelta.edu"
  },
  {
    "name": "Mississippi Gulf Coast Community College",
    "domain": "mgccc.edu"
  },
  {
    "name": "Mississippi State University",
    "domain": "msstate.edu"
  },
  {
    "name": "Mississippi University for Women",
    "domain": "muw.edu"
  },
  {
    "name": "Mississippi Valley State University",
    "domain": "mvsu.edu"
  },
  {
    "name": "Missouri Southern State College",
    "domain": "mssc.edu"
  },
  {
    "name": "Missouri State University",
    "domain": "missouristate.edu"
  },
  {
    "name": "Missouri State University-West Plains",
    "domain": "wp.missouristate.edu"
  },
  {
    "name": "Missouri University of Science and Technology",
    "domain": "mst.edu"
  },
  {
    "name": "Missouri Western State College",
    "domain": "mwsc.edu"
  },
  {
    "name": "Mitchell Community College",
    "domain": "mitchellcc.edu"
  },
  {
    "name": "Mitchell Technical Institute",
    "domain": "mitchelltech.edu"
  },
  {
    "name": "Moberly Area Community College",
    "domain": "macc.edu"
  },
  {
    "name": "Modesto Junior College",
    "domain": "mjc.edu"
  },
  {
    "name": "Mohave Community College",
    "domain": "mohave.edu"
  },
  {
    "name": "Mohawk Valley Community College",
    "domain": "mvcc.edu"
  },
  {
    "name": "Molloy College",
    "domain": "molloy.edu"
  },
  {
    "name": "Monmouth College",
    "domain": "monmouthcollege.edu"
  },
  {
    "name": "Monmouth University",
    "domain": "monmouth.edu"
  },
  {
    "name": "Monroe College",
    "domain": "monroecollege.edu"
  },
  {
    "name": "Monroe Community College",
    "domain": "monroecc.edu"
  },
  {
    "name": "Monroe County Community College",
    "domain": "monroeccc.edu"
  },
  {
    "name": "Montana State University - Billings",
    "domain": "msubillings.edu"
  },
  {
    "name": "Montana State University - Bozeman",
    "domain": "montana.edu"
  },
  {
    "name": "Montana State University - Northern",
    "domain": "msun.edu"
  },
  {
    "name": "Montana Tech",
    "domain": "mtech.edu"
  },
  {
    "name": "Montcalm Community College",
    "domain": "montcalm.edu"
  },
  {
    "name": "Montclair State University",
    "domain": "montclair.edu"
  },
  {
    "name": "Monterey Peninsula College",
    "domain": "mpc.edu"
  },
  {
    "name": "Montgomery College",
    "domain": "montgomerycollege.edu"
  },
  {
    "name": "Montgomery Community College",
    "domain": "montgomery.edu"
  },
  {
    "name": "Montgomery County Community College",
    "domain": "mc3.edu"
  },
  {
    "name": "Montreat College",
    "domain": "montreat.edu"
  },
  {
    "name": "Moorpark College",
    "domain": "moorparkcollege.edu"
  },
  {
    "name": "Moraine Park Technical College",
    "domain": "morainepark.edu"
  },
  {
    "name": "Moraine Valley Community College",
    "domain": "morainevalley.edu"
  },
  {
    "name": "Moravian College",
    "domain": "moravian.edu"
  },
  {
    "name": "Morehead State University",
    "domain": "moreheadstate.edu"
  },
  {
    "name": "Morehouse",
    "domain": "morehouse.edu"
  },
  {
    "name": "Morehouse School of Medicine",
    "domain": "msm.edu"
  },
  {
    "name": "Moreno Valley College",
    "domain": "mvc.edu"
  },
  {
    "name": "Morgan Community College",
    "domain": "morgancc.edu"
  },
  {
    "name": "Morgan State University",
    "domain": "morgan.edu"
  },
  {
    "name": "Morris Brown College",
    "domain": "morrisbrown.edu"
  },
  {
    "name": "Morris College",
    "domain": "morris.edu"
  },
  {
    "name": "Morton College",
    "domain": "morton.edu"
  },
  {
    "name": "Motlow State Community College",
    "domain": "mscc.edu"
  },
  {
    "name": "Mott Community College",
    "domain": "mcc.edu"
  },
  {
    "name": "Moultrie Technical College",
    "domain": "moultrietech.edu"
  },
  {
    "name": "Mount Holyoke College",
    "domain": "mtholyoke.edu"
  },
  {
    "name": "Mount Saint Joseph College",
    "domain": "msj.edu"
  },
  {
    "name": "Mount Saint Mary College",
    "domain": "msmc.edu"
  },
  {
    "name": "Mount Senario College",
    "domain": "mscfs.edu"
  },
  {
    "name": "Mount St. Mary's University",
    "domain": "msmary.edu"
  },
  {
    "name": "Mount Union College",
    "domain": "muc.edu"
  },
  {
    "name": "Mount Wachusett Community College",
    "domain": "mwcc.edu"
  },
  {
    "name": "Mountain Empire Community College",
    "domain": "mecc.edu"
  },
  {
    "name": "Mountwest Community and Technical College",
    "domain": "mctc.edu"
  },
  {
    "name": "Mt. Hood Community College",
    "domain": "mhcc.edu"
  },
  {
    "name": "Mt. San Antonio College",
    "domain": "mtsac.edu"
  },
  {
    "name": "Mt. San Jacinto Community College District",
    "domain": "msjc.edu"
  },
  {
    "name": "MTI College",
    "domain": "sacramento.mticollege.edu"
  },
  {
    "name": "Murray State College",
    "domain": "mscok.edu"
  },
  {
    "name": "Murray State University",
    "domain": "mursuky.edu"
  },
  {
    "name": "Muskegon Community College",
    "domain": "muskegoncc.edu"
  },
  {
    "name": "Muskingum College",
    "domain": "muskingum.edu"
  },
  {
    "name": "Napa Valley College",
    "domain": "napavalley.edu"
  },
  {
    "name": "Nash Community College",
    "domain": "nashcc.edu"
  },
  {
    "name": "Nashua Community College",
    "domain": "nashuacc.edu"
  },
  {
    "name": "Nashville State Community College",
    "domain": "nscc.edu"
  },
  {
    "name": "Nassau Community College",
    "domain": "ncc.edu"
  },
  {
    "name": "National Defense University",
    "domain": "ndu.edu"
  },
  {
    "name": "National Park College",
    "domain": "np.edu"
  },
  {
    "name": "National Park Community College",
    "domain": "npcc.edu"
  },
  {
    "name": "National Radio Astronomy Observatory",
    "domain": "nrao.edu"
  },
  {
    "name": "National University",
    "domain": "nu.edu"
  },
  {
    "name": "National-Louis University",
    "domain": "nl.edu"
  },
  {
    "name": "Naugatuck Valley Community College",
    "domain": "nv.edu"
  },
  {
    "name": "Naval Postgraduate School",
    "domain": "nps.edu"
  },
  {
    "name": "Navarro College",
    "domain": "navarrocollege.edu"
  },
  {
    "name": "Nazareth College",
    "domain": "naz.edu"
  },
  {
    "name": "Nebraska College of Technical Agriculture",
    "domain": "ncta.unl.edu"
  },
  {
    "name": "Nebraska Indian Community College",
    "domain": "thenicc.edu"
  },
  {
    "name": "Nebraska Wesleyan University",
    "domain": "nebrwesleyan.edu"
  },
  {
    "name": "Neosho County Community College",
    "domain": "neosho.edu"
  },
  {
    "name": "Neumann University",
    "domain": "neumann.edu"
  },
  {
    "name": "Nevada System of Higher Education",
    "domain": "nevada.edu"
  },
  {
    "name": "New College of California",
    "domain": "newcollege.edu"
  },
  {
    "name": "New College of Florida",
    "domain": "ncf.edu"
  },
  {
    "name": "New England Institute of Technology",
    "domain": "neit.edu"
  },
  {
    "name": "New Hampshire College",
    "domain": "nhc.edu"
  },
  {
    "name": "New Jersey City University",
    "domain": "njcu.edu"
  },
  {
    "name": "New Jersey Institute of Technology",
    "domain": "njit.edu"
  },
  {
    "name": "New Mexico Highlands University",
    "domain": "nmhu.edu"
  },
  {
    "name": "New Mexico Institute of Mining & Technology",
    "domain": "nmt.edu"
  },
  {
    "name": "New Mexico Junior College",
    "domain": "nmjc.edu"
  },
  {
    "name": "New Mexico Military Institute",
    "domain": "nmmi.edu"
  },
  {
    "name": "New Mexico State University",
    "domain": "nmsu.edu"
  },
  {
    "name": "New Mexico State University-Alamogordo",
    "domain": "nmsua.edu"
  },
  {
    "name": "New Mexico State University-Carlsbad",
    "domain": "cavern.nmsu.edu"
  },
  {
    "name": "New Mexico State University-Dona Ana",
    "domain": "dabcc.nmsu.edu"
  },
  {
    "name": "New River Community and Technical College",
    "domain": "newriver.edu"
  },
  {
    "name": "New River Community College",
    "domain": "nr.edu"
  },
  {
    "name": "New York Institute of Technology",
    "domain": "nyit.edu"
  },
  {
    "name": "New York Medical College",
    "domain": "nymc.edu"
  },
  {
    "name": "New York University",
    "domain": "nyu.edu"
  },
  {
    "name": "Newberry College",
    "domain": "newberry.edu"
  },
  {
    "name": "NHTI-Concord's Community College",
    "domain": "nhti.edu"
  },
  {
    "name": "Niagara County Community College",
    "domain": "niagaracc.suny.edu"
  },
  {
    "name": "Niagara University",
    "domain": "niagara.edu"
  },
  {
    "name": "Nicholls State University",
    "domain": "nicholls.edu"
  },
  {
    "name": "Nicolet Area Technical College",
    "domain": "nicoletcollege.edu"
  },
  {
    "name": "Norfolk State University",
    "domain": "nsu.edu"
  },
  {
    "name": "Normandale Community College",
    "domain": "normandale.edu"
  },
  {
    "name": "North American University",
    "domain": "na.edu"
  },
  {
    "name": "North Arkansas College",
    "domain": "northark.edu"
  },
  {
    "name": "North Carolina A&T State University",
    "domain": "ncat.edu"
  },
  {
    "name": "North Carolina Central University",
    "domain": "nccu.edu"
  },
  {
    "name": "North Carolina State University",
    "domain": "ncsu.edu"
  },
  {
    "name": "North Carolina Wesleyan College",
    "domain": "ncwc.edu"
  },
  {
    "name": "North Central Bible College",
    "domain": "ncbc.edu"
  },
  {
    "name": "North Central College",
    "domain": "northcentralcollege.edu"
  },
  {
    "name": "North Central Kansas Technical College",
    "domain": "ncktc.edu"
  },
  {
    "name": "North Central Michigan College",
    "domain": "ncmich.edu"
  },
  {
    "name": "North Central Missouri College",
    "domain": "ncmissouri.edu"
  },
  {
    "name": "North Central State College",
    "domain": "ncstatecollege.edu"
  },
  {
    "name": "North Central Texas College",
    "domain": "nctc.edu"
  },
  {
    "name": "North Country Community College",
    "domain": "nccc.edu"
  },
  {
    "name": "North Dakota State College of Science",
    "domain": "ndscs.edu"
  },
  {
    "name": "North Dakota State University",
    "domain": "ndsu.edu"
  },
  {
    "name": "North Dakota University System",
    "domain": "ndus.edu"
  },
  {
    "name": "North Florida Community College",
    "domain": "nfcc.edu"
  },
  {
    "name": "North Georgia Technical College",
    "domain": "northgatech.edu"
  },
  {
    "name": "North Hennepin Community College",
    "domain": "nhcc.edu"
  },
  {
    "name": "North Idaho College",
    "domain": "nic.edu"
  },
  {
    "name": "North Iowa Area Community College",
    "domain": "niacc.edu"
  },
  {
    "name": "North Park College and Theological Seminary",
    "domain": "npcts.edu"
  },
  {
    "name": "North Shore Community College",
    "domain": "northshore.edu"
  },
  {
    "name": "Northampton Community College",
    "domain": "northampton.edu"
  },
  {
    "name": "Northcentral Technical College",
    "domain": "ntc.edu"
  },
  {
    "name": "Northeast Alabama Community College",
    "domain": "nacc.edu"
  },
  {
    "name": "Northeast Community College",
    "domain": "northeast.edu"
  },
  {
    "name": "Northeast Iowa Community College",
    "domain": "nicc.edu"
  },
  {
    "name": "Northeast Mississippi Community College",
    "domain": "nemcc.edu"
  },
  {
    "name": "Northeast State Community College",
    "domain": "northeaststate.edu"
  },
  {
    "name": "Northeast Texas Community College",
    "domain": "ntcc.edu"
  },
  {
    "name": "Northeast Wisconsin Technical College",
    "domain": "nwtc.edu"
  },
  {
    "name": "Northeastern Junior College",
    "domain": "njc.edu"
  },
  {
    "name": "Northeastern Louisiana University",
    "domain": "nlu.edu"
  },
  {
    "name": "Northeastern Oklahoma A&M College",
    "domain": "neo.edu"
  },
  {
    "name": "Northeastern State University",
    "domain": "nsuok.edu"
  },
  {
    "name": "Northeastern Technical College",
    "domain": "netc.edu"
  },
  {
    "name": "Northeastern University",
    "domain": "neu.edu, northeastern.edu"
  },
  {
    "name": "Northern Arizona University",
    "domain": "nau.edu"
  },
  {
    "name": "Northern Essex Community College",
    "domain": "necc.edu, necc.mass.edu"
  },
  {
    "name": "Northern Illinois University",
    "domain": "niu.edu"
  },
  {
    "name": "Northern Kentucky University",
    "domain": "nku.edu"
  },
  {
    "name": "Northern Maine Community College",
    "domain": "nmcc.edu"
  },
  {
    "name": "Northern Michigan University",
    "domain": "nmu.edu"
  },
  {
    "name": "Northern Oklahoma College",
    "domain": "noc.edu"
  },
  {
    "name": "Northern State University",
    "domain": "northern.edu"
  },
  {
    "name": "Northern Virginia Community College",
    "domain": "nvcc.edu"
  },
  {
    "name": "Northland College",
    "domain": "northland.edu"
  },
  {
    "name": "Northland Community and Technical College",
    "domain": "northlandcollege.edu"
  },
  {
    "name": "Northland Pioneer College",
    "domain": "npc.edu"
  },
  {
    "name": "NorthWest Arkansas Community College",
    "domain": "nwacc.edu"
  },
  {
    "name": "Northwest College",
    "domain": "northwestcollege.edu"
  },
  {
    "name": "Northwest Florida State College",
    "domain": "nwfsc.edu"
  },
  {
    "name": "Northwest Iowa Community College",
    "domain": "nwicc.edu"
  },
  {
    "name": "Northwest Kansas Technical College",
    "domain": "nwktc.edu"
  },
  {
    "name": "Northwest Mississippi Community College",
    "domain": "northwestms.edu"
  },
  {
    "name": "Northwest Missouri State University",
    "domain": "nwmissouri.edu"
  },
  {
    "name": "Northwest Nazarene College",
    "domain": "nnc.edu"
  },
  {
    "name": "Northwest State Community College",
    "domain": "northweststate.edu"
  },
  {
    "name": "Northwest Technical College",
    "domain": "ntcmn.edu"
  },
  {
    "name": "Northwest-Shoals Community College",
    "domain": "nwscc.edu"
  },
  {
    "name": "Northwestern College of Iowa",
    "domain": "nwciowa.edu"
  },
  {
    "name": "Northwestern College-Chicago Campus",
    "domain": "northwesterncollege.edu"
  },
  {
    "name": "Northwestern Connecticut Community College",
    "domain": "nwcc.commnet.edu"
  },
  {
    "name": "Northwestern Michigan College",
    "domain": "nmc.edu"
  },
  {
    "name": "Northwestern State University",
    "domain": "nsula.edu"
  },
  {
    "name": "Northwestern University",
    "domain": "northwestern.edu"
  },
  {
    "name": "Northwood University",
    "domain": "northwood.edu"
  },
  {
    "name": "Norwalk Community College",
    "domain": "ncc.commnet.edu"
  },
  {
    "name": "Norwich University",
    "domain": "norwich.edu"
  },
  {
    "name": "Nova Southeastern University",
    "domain": "nova.edu"
  },
  {
    "name": "Nunez Community College",
    "domain": "nunez.edu"
  },
  {
    "name": "Oakland Community College",
    "domain": "oaklandcc.edu"
  },
  {
    "name": "Oakland University",
    "domain": "oakland.edu"
  },
  {
    "name": "Oakton Community College",
    "domain": "oakton.edu"
  },
  {
    "name": "Oakwood University",
    "domain": "oakwood.edu"
  },
  {
    "name": "Oberlin College",
    "domain": "oberlin.edu"
  },
  {
    "name": "Occidental College",
    "domain": "oxy.edu"
  },
  {
    "name": "Ocean County College",
    "domain": "ocean.edu"
  },
  {
    "name": "Odessa College",
    "domain": "odessa.edu"
  },
  {
    "name": "Ogeechee Technical College",
    "domain": "ogeecheetech.edu"
  },
  {
    "name": "Oglethorpe University",
    "domain": "oglethorpe.edu"
  },
  {
    "name": "Ohio Dominican College",
    "domain": "odc.edu"
  },
  {
    "name": "Ohio Northern University",
    "domain": "onu.edu"
  },
  {
    "name": "Ohio State University - Columbus",
    "domain": "osu.edu"
  },
  {
    "name": "Ohio State University Agricultural Technical Institute",
    "domain": "ati.osu.edu"
  },
  {
    "name": "Ohio University",
    "domain": "ohio.edu"
  },
  {
    "name": "Ohio Wesleyan University",
    "domain": "owu.edu"
  },
  {
    "name": "Ohlone College",
    "domain": "ohlone.edu"
  },
  {
    "name": "Ojai Unified School District",
    "domain": "ojaiusd.org"
  },
  {
    "name": "Oklahoma Baptist University",
    "domain": "okbu.edu"
  },
  {
    "name": "Oklahoma Christian University",
    "domain": "oc.edu"
  },
  {
    "name": "Oklahoma City Community College",
    "domain": "occc.edu"
  },
  {
    "name": "Oklahoma City University",
    "domain": "okcu.edu"
  },
  {
    "name": "Oklahoma State University",
    "domain": "okstate.edu"
  },
  {
    "name": "Old Dominion University",
    "domain": "odu.edu"
  },
  {
    "name": "Olin College of Engineering",
    "domain": "students.olin.edu"
  },
  {
    "name": "Olivet Nazarene University",
    "domain": "olivet.edu"
  },
  {
    "name": "Onondaga Community College",
    "domain": "sunyocc.edu"
  },
  {
    "name": "Oral Roberts University",
    "domain": "oru.edu"
  },
  {
    "name": "Orange Coast College",
    "domain": "orangecoastcollege.edu"
  },
  {
    "name": "Orange County Community College",
    "domain": "sunyorange.edu"
  },
  {
    "name": "Orangeburg Calhoun Technical College",
    "domain": "octech.edu"
  },
  {
    "name": "Oregon Graduate Institute of Science and Technology",
    "domain": "ogi.edu"
  },
  {
    "name": "Oregon Health Sciences University",
    "domain": "ohsu.edu"
  },
  {
    "name": "Oregon Institute of Technology",
    "domain": "oit.edu"
  },
  {
    "name": "Oregon State University",
    "domain": "oregonstate.edu"
  },
  {
    "name": "Otero Junior College",
    "domain": "www.ojc.edu"
  },
  {
    "name": "Otterbein College",
    "domain": "otterbein.edu"
  },
  {
    "name": "Our Lady of the Lake University",
    "domain": "ollusa.edu"
  },
  {
    "name": "Owens Community College",
    "domain": "owens.edu"
  },
  {
    "name": "Owensboro Community and Technical College",
    "domain": "owensboro.kctcs.edu"
  },
  {
    "name": "Oxnard College",
    "domain": "oxnardcollege.edu"
  },
  {
    "name": "Ozarka College",
    "domain": "ozarka.edu"
  },
  {
    "name": "Ozarks Technical Community College",
    "domain": "otc.edu"
  },
  {
    "name": "Pace University",
    "domain": "pace.edu"
  },
  {
    "name": "Pacific Lutheran University",
    "domain": "plu.edu"
  },
  {
    "name": "Pacific Northwest University of Health Sciences",
    "domain": "pnwu.edu"
  },
  {
    "name": "Pacific Union College",
    "domain": "puc.edu"
  },
  {
    "name": "Pacific University",
    "domain": "pacificu.edu"
  },
  {
    "name": "Pacific Western University",
    "domain": "pwu.com"
  },
  {
    "name": "Paine College",
    "domain": "paine.edu"
  },
  {
    "name": "Palm Beach Atlantic College",
    "domain": "pbac.edu"
  },
  {
    "name": "Palm Beach State College",
    "domain": "palmbeachstate.edu"
  },
  {
    "name": "Palo Verde College",
    "domain": "paloverde.edu"
  },
  {
    "name": "Palomar College",
    "domain": "palomar.edu"
  },
  {
    "name": "Pamlico Community College",
    "domain": "pamlicocc.edu"
  },
  {
    "name": "Panola College",
    "domain": "panola.edu"
  },
  {
    "name": "Paradise Valley Community College",
    "domain": "pvc.maricopa.edu"
  },
  {
    "name": "Paris Junior College",
    "domain": "parisjc.edu"
  },
  {
    "name": "Park University",
    "domain": "park.edu"
  },
  {
    "name": "Parkland College",
    "domain": "parkland.edu"
  },
  {
    "name": "Pasadena City College",
    "domain": "pasadena.edu"
  },
  {
    "name": "Pasco-Hernando Community College",
    "domain": "phcc.edu"
  },
  {
    "name": "Pasco-Hernando State College",
    "domain": "phsc.edu"
  },
  {
    "name": "Passaic County Community College",
    "domain": "pccc.edu"
  },
  {
    "name": "Patrick Henry Community College",
    "domain": "patrickhenry.edu"
  },
  {
    "name": "Paul D Camp Community College",
    "domain": "pdc.edu"
  },
  {
    "name": "Paul Quinn College",
    "domain": "paulquinn.edu"
  },
  {
    "name": "Peace College",
    "domain": "peace.edu"
  },
  {
    "name": "Pearl River Community College",
    "domain": "prcc.edu"
  },
  {
    "name": "Pellissippi State Community College",
    "domain": "pstcc.edu"
  },
  {
    "name": "Pembroke State University",
    "domain": "pembroke.edu"
  },
  {
    "name": "Pennsylvania College of Technology",
    "domain": "pct.edu"
  },
  {
    "name": "Pennsylvania Highlands Community College",
    "domain": "pennhighlands.edu"
  },
  {
    "name": "Pennsylvania Institute of Technology",
    "domain": "pit.edu"
  },
  {
    "name": "Pennsylvania State University",
    "domain": "psu.edu"
  },
  {
    "name": "Pennsylvania State University - Harrisburg",
    "domain": "harrisburg.psu.edu"
  },
  {
    "name": "Pennsylvania State University - Schuylkill Campus",
    "domain": "sl.psu.edu"
  },
  {
    "name": "Pensacola Christian College",
    "domain": "pcci.edu"
  },
  {
    "name": "Pensacola State College",
    "domain": "pensacolastate.edu"
  },
  {
    "name": "Pepperdine University",
    "domain": "pepperdine.edu"
  },
  {
    "name": "Peru State College",
    "domain": "peru.edu"
  },
  {
    "name": "Philadelphia College of Osteopathic Medicine",
    "domain": "pcom.edu"
  },
  {
    "name": "Philadelphia University",
    "domain": "philau.edu"
  },
  {
    "name": "Philander Smith College",
    "domain": "philander.edu"
  },
  {
    "name": "Phillips Community College of the University of Arkansas",
    "domain": "pccua.edu"
  },
  {
    "name": "Phillips University",
    "domain": "phillips.edu"
  },
  {
    "name": "Phoenix College",
    "domain": "phoenixcollege.edu"
  },
  {
    "name": "Piedmont Community College",
    "domain": "piedmontcc.edu"
  },
  {
    "name": "Piedmont Technical College",
    "domain": "ptc.edu"
  },
  {
    "name": "Piedmont Virginia Community College",
    "domain": "pvcc.edu"
  },
  {
    "name": "Pierce College at Puyallup",
    "domain": "pierce.ctc.edu"
  },
  {
    "name": "Pierpont Community and Technical College",
    "domain": "pierpont.edu"
  },
  {
    "name": "Pikes Peak Community College",
    "domain": "ppcc.edu"
  },
  {
    "name": "Pima Community College",
    "domain": "pima.edu"
  },
  {
    "name": "Pine Technical College",
    "domain": "pinetech.edu"
  },
  {
    "name": "Pitt Community College",
    "domain": "pittcc.edu"
  },
  {
    "name": "Pittsburg State University",
    "domain": "pittstate.edu"
  },
  {
    "name": "Pittsburgh Technical Institute",
    "domain": "pti.edu"
  },
  {
    "name": "Pitzer College",
    "domain": "pitzer.edu"
  },
  {
    "name": "Platt College",
    "domain": "platt.edu"
  },
  {
    "name": "Plymouth State University",
    "domain": "plymouth.edu"
  },
  {
    "name": "Point Park University",
    "domain": "pointpark.edu"
  },
  {
    "name": "Polk State College",
    "domain": "polk.edu"
  },
  {
    "name": "Polytechnic University of New York",
    "domain": "poly.edu"
  },
  {
    "name": "Polytechnic University of Puerto Rico",
    "domain": "pupr.edu"
  },
  {
    "name": "Pomona College",
    "domain": "pomona.edu"
  },
  {
    "name": "Porterville College",
    "domain": "portervillecollege.edu"
  },
  {
    "name": "Portland Community College",
    "domain": "pcc.edu"
  },
  {
    "name": "Portland State University",
    "domain": "pdx.edu"
  },
  {
    "name": "Prairie State College",
    "domain": "prairiestate.edu"
  },
  {
    "name": "Prairie View A&M University",
    "domain": "pvamu.edu"
  },
  {
    "name": "Pratt Community College",
    "domain": "prattcc.edu"
  },
  {
    "name": "Pratt Institute",
    "domain": "pratt.edu"
  },
  {
    "name": "Presbyterian College",
    "domain": "presby.edu"
  },
  {
    "name": "Prescott College",
    "domain": "prescott.edu"
  },
  {
    "name": "Prince George's Community College",
    "domain": "pgcc.edu"
  },
  {
    "name": "Prince William Sound College",
    "domain": "pwsc.alaska.edu"
  },
  {
    "name": "Princeton University",
    "domain": "princeton.edu"
  },
  {
    "name": "Providence College",
    "domain": "providence.edu"
  },
  {
    "name": "Pueblo Community College",
    "domain": "pueblocc.edu"
  },
  {
    "name": "Pulaski Technical College",
    "domain": "pulaskitech.edu"
  },
  {
    "name": "Purdue Global University",
    "domain": "purdueglobal.edu"
  },
  {
    "name": "Purdue Global University (Student email)",
    "domain": "student.purdueglobal.edu"
  },
  {
    "name": "Purdue University",
    "domain": "purdue.edu"
  },
  {
    "name": "Purdue University Calumet",
    "domain": "purduecal.edu"
  },
  {
    "name": "Purdue University Fort Wayne",
    "domain": "pfw.edu"
  },
  {
    "name": "Purdue University North Central",
    "domain": "pnc.edu"
  },
  {
    "name": "Purdue University Northwest",
    "domain": "pnw.edu"
  },
  {
    "name": "Quadrat Academy",
    "domain": "quadratacademy.com"
  },
  {
    "name": "Queens University of Charlotte",
    "domain": "queens.edu"
  },
  {
    "name": "Quincy College",
    "domain": "quincycollege.edu"
  },
  {
    "name": "Quincy University",
    "domain": "quincy.edu"
  },
  {
    "name": "Quinebaug Valley Community College",
    "domain": "qvcc.edu"
  },
  {
    "name": "Quinnipiac College",
    "domain": "quinnipiac.edu"
  },
  {
    "name": "Quinsigamond Community College",
    "domain": "qcc.edu"
  },
  {
    "name": "Radford University",
    "domain": "radford.edu"
  },
  {
    "name": "Rainy River Community College",
    "domain": "rrcc.mnscu.edu"
  },
  {
    "name": "Ramapo College",
    "domain": "ramapo.edu"
  },
  {
    "name": "Randolph Community College",
    "domain": "randolph.edu"
  },
  {
    "name": "Randolph-Macon College",
    "domain": "rmc.edu"
  },
  {
    "name": "Randolph-Macon Woman's College",
    "domain": "rmwc.edu"
  },
  {
    "name": "Ranger College",
    "domain": "rangercollege.edu"
  },
  {
    "name": "Rappahannock Community College",
    "domain": "rappahannock.edu"
  },
  {
    "name": "Raritan Valley Community College",
    "domain": "raritanval.edu"
  },
  {
    "name": "Reading Area Community College",
    "domain": "racc.edu"
  },
  {
    "name": "Red Rocks Community College",
    "domain": "rrcc.edu"
  },
  {
    "name": "Redlands Community College",
    "domain": "redlandscc.edu"
  },
  {
    "name": "Reed College",
    "domain": "reed.edu"
  },
  {
    "name": "Reedley College",
    "domain": "reedleycollege.edu"
  },
  {
    "name": "Regent University",
    "domain": "regent.edu"
  },
  {
    "name": "Regis University",
    "domain": "regis.edu"
  },
  {
    "name": "Rend Lake College",
    "domain": "rlc.edu"
  },
  {
    "name": "Rensselaer Polytechnic Institute",
    "domain": "rpi.edu"
  },
  {
    "name": "Renton Technical College",
    "domain": "rtc.edu"
  },
  {
    "name": "Rhode Island College",
    "domain": "ric.edu"
  },
  {
    "name": "Rhodes College",
    "domain": "rhodes.edu"
  },
  {
    "name": "Rice University",
    "domain": "rice.edu"
  },
  {
    "name": "Rich Mountain Community College",
    "domain": "rmcc.edu"
  },
  {
    "name": "Richard Bland College of the College of William and Mary",
    "domain": "rbc.edu"
  },
  {
    "name": "Richard Stockton College of New Jersey",
    "domain": "stockton.edu"
  },
  {
    "name": "Richland College",
    "domain": "richlandcollege.edu"
  },
  {
    "name": "Richland Community College",
    "domain": "richland.edu"
  },
  {
    "name": "Richmond Community College",
    "domain": "richmondcc.edu"
  },
  {
    "name": "Rider University",
    "domain": "rider.edu"
  },
  {
    "name": "Ridgewater College",
    "domain": "ridgewater.edu"
  },
  {
    "name": "Rio Hondo College",
    "domain": "riohondo.edu"
  },
  {
    "name": "Rio Salado College",
    "domain": "rio.maricopa.edu"
  },
  {
    "name": "Ripon College",
    "domain": "ripon.edu"
  },
  {
    "name": "River Parishes Community College",
    "domain": "rpcc.edu"
  },
  {
    "name": "River Valley Community College",
    "domain": "rivervalley.edu"
  },
  {
    "name": "Riverland Community College",
    "domain": "riverland.edu"
  },
  {
    "name": "Riverside City College",
    "domain": "rcc.edu"
  },
  {
    "name": "Riverside Community College District",
    "domain": "rccd.edu"
  },
  {
    "name": "Rivier College",
    "domain": "riv.edu"
  },
  {
    "name": "Roane State Community College",
    "domain": "roanestate.edu"
  },
  {
    "name": "Roanoke College",
    "domain": "roanoke.edu"
  },
  {
    "name": "Roanoke-Chowan Community College",
    "domain": "roanokechowan.edu"
  },
  {
    "name": "Robert Morris University",
    "domain": "rmu.edu"
  },
  {
    "name": "Robert Morris University Illinois",
    "domain": "robertmorris.edu"
  },
  {
    "name": "Robeson Community College",
    "domain": "robeson.edu"
  },
  {
    "name": "Rochester Community and Technical College",
    "domain": "rctc.edu"
  },
  {
    "name": "Rochester Institute of Technology",
    "domain": "rit.edu"
  },
  {
    "name": "Rock Valley College",
    "domain": "rockvalleycollege.edu"
  },
  {
    "name": "Rockefeller University",
    "domain": "rockefeller.edu"
  },
  {
    "name": "Rockford College",
    "domain": "rockford.edu"
  },
  {
    "name": "Rockhurst College",
    "domain": "rockhurst.edu"
  },
  {
    "name": "Rockingham Community College",
    "domain": "rockinghamcc.edu"
  },
  {
    "name": "Rockland Community College",
    "domain": "sunyrockland.edu"
  },
  {
    "name": "Rocky Mountain College",
    "domain": "rocky.edu"
  },
  {
    "name": "Roger Williams University",
    "domain": "rwu.edu"
  },
  {
    "name": "Rogers State University",
    "domain": "rsu.edu"
  },
  {
    "name": "Rogue Community College",
    "domain": "roguecc.edu"
  },
  {
    "name": "Rollins College",
    "domain": "rollins.edu"
  },
  {
    "name": "Roosevelt University",
    "domain": "roosevelt.edu"
  },
  {
    "name": "Rosary College",
    "domain": "rosary.edu"
  },
  {
    "name": "Rose State College",
    "domain": "rose.edu"
  },
  {
    "name": "Rose-Hulman Institute of Technology",
    "domain": "rose-hulman.edu"
  },
  {
    "name": "Rowan College",
    "domain": "rowan.edu"
  },
  {
    "name": "Rowan College at Burlington County",
    "domain": "rcbc.edu"
  },
  {
    "name": "Rowan College of South Jersey",
    "domain": "rcsj.edu"
  },
  {
    "name": "Rowan-Cabarrus Community College",
    "domain": "rccc.edu"
  },
  {
    "name": "Roxbury Community College",
    "domain": "rcc.mass.edu"
  },
  {
    "name": "Rust College",
    "domain": "rustcollege.edu"
  },
  {
    "name": "Rutgers University",
    "domain": "rutgers.edu"
  },
  {
    "name": "Sacramento City College",
    "domain": "scc.losrios.edu"
  },
  {
    "name": "Sacred Heart University",
    "domain": "sacredheart.edu, mail.sacredheart.edu"
  },
  {
    "name": "Saddleback College",
    "domain": "saddleback.edu"
  },
  {
    "name": "Sage Colleges",
    "domain": "sage.edu"
  },
  {
    "name": "Saginaw Chippewa Tribal College",
    "domain": "sagchip.edu"
  },
  {
    "name": "Saginaw Valley State University",
    "domain": "svsu.edu"
  },
  {
    "name": "Saint Anselm College",
    "domain": "anselm.edu"
  },
  {
    "name": "Saint Cloud State University",
    "domain": "stcloudstate.edu"
  },
  {
    "name": "Saint Edward's University",
    "domain": "stedwards.edu"
  },
  {
    "name": "Saint Elizabeth College of Nursing",
    "domain": "secon.edu"
  },
  {
    "name": "Saint John's University (NY)",
    "domain": "stjohns.edu"
  },
  {
    "name": "Saint Joseph's College (IN)",
    "domain": "saintjoe.edu"
  },
  {
    "name": "Saint Joseph's University",
    "domain": "sju.edu"
  },
  {
    "name": "Saint Leo University",
    "domain": "saintleo.edu"
  },
  {
    "name": "Saint Louis University",
    "domain": "slu.edu"
  },
  {
    "name": "Saint Mary College",
    "domain": "smcks.edu"
  },
  {
    "name": "Saint Mary's College (IN)",
    "domain": "saintmarys.edu"
  },
  {
    "name": "Saint Mary's College of California",
    "domain": "stmarys-ca.edu"
  },
  {
    "name": "Saint Mary's University of Minnesota",
    "domain": "smumn.edu"
  },
  {
    "name": "Saint Michael's College",
    "domain": "smcvt.edu"
  },
  {
    "name": "Saint Olaf College",
    "domain": "stolaf.edu"
  },
  {
    "name": "Saint Paul College",
    "domain": "saintpaul.edu"
  },
  {
    "name": "Saint Vincent College",
    "domain": "stvincent.edu"
  },
  {
    "name": "Saint Xavier University",
    "domain": "sxu.edu"
  },
  {
    "name": "Salem Community College",
    "domain": "salemcc.edu"
  },
  {
    "name": "Salisbury University",
    "domain": "salisbury.edu"
  },
  {
    "name": "Salish Kootenai College",
    "domain": "skc.edu"
  },
  {
    "name": "Salt Lake Community College",
    "domain": "slcc.edu"
  },
  {
    "name": "Sam Houston State University",
    "domain": "shsu.edu"
  },
  {
    "name": "Samford University",
    "domain": "samford.edu"
  },
  {
    "name": "Sampson Community College",
    "domain": "sampsoncc.edu"
  },
  {
    "name": "San Bernardino Valley College",
    "domain": "valleycollege.edu"
  },
  {
    "name": "San Diego Christian College",
    "domain": "sdcc.edu"
  },
  {
    "name": "San Diego City College",
    "domain": "sdcity.edu"
  },
  {
    "name": "San Diego Mesa College",
    "domain": "sdmesa.edu"
  },
  {
    "name": "San Diego Miramar College",
    "domain": "sdmiramar.edu"
  },
  {
    "name": "San Diego State University",
    "domain": "sdsu.edu"
  },
  {
    "name": "San Francisco State University",
    "domain": "sfsu.edu"
  },
  {
    "name": "San Joaquin Delta College",
    "domain": "deltacollege.edu"
  },
  {
    "name": "San Joaquin Valley College-Visalia",
    "domain": "sjvc.edu"
  },
  {
    "name": "San Jose City College",
    "domain": "sjcc.edu"
  },
  {
    "name": "San Jose State University",
    "domain": "sjsu.edu"
  },
  {
    "name": "San Juan College",
    "domain": "sanjuancollege.edu"
  },
  {
    "name": "San Mateo County Community College District",
    "domain": "smccd.edu"
  },
  {
    "name": "Sandhills Community College",
    "domain": "sandhills.edu"
  },
  {
    "name": "SANS Technology Institute",
    "domain": "sans.edu"
  },
  {
    "name": "Santa Ana College",
    "domain": "sac.edu"
  },
  {
    "name": "Santa Barbara City College",
    "domain": "sbcc.edu"
  },
  {
    "name": "Santa Clara University",
    "domain": "scu.edu"
  },
  {
    "name": "Santa Fe Community College",
    "domain": "sfcc.edu"
  },
  {
    "name": "Santa Monica College",
    "domain": "smc.edu"
  },
  {
    "name": "Santa Rosa Junior College",
    "domain": "santarosa.edu"
  },
  {
    "name": "Santiago Canyon College",
    "domain": "sccollege.edu"
  },
  {
    "name": "Sarah Lawrence College",
    "domain": "slc.edu"
  },
  {
    "name": "Sauk Valley Community College",
    "domain": "svcc.edu"
  },
  {
    "name": "Savannah College of Art and Design",
    "domain": "scad.edu, student.scad.edu"
  },
  {
    "name": "Savannah State University",
    "domain": "savannahstate.edu"
  },
  {
    "name": "Savannah Technical College",
    "domain": "savannahtech.edu"
  },
  {
    "name": "Schenectady County Community College",
    "domain": "sunysccc.edu"
  },
  {
    "name": "Schiller International University",
    "domain": "schiller.edu"
  },
  {
    "name": "School of the Art Institute of Chicago",
    "domain": "saic.edu"
  },
  {
    "name": "Schoolcraft College",
    "domain": "schoolcraft.edu"
  },
  {
    "name": "Schreiner University",
    "domain": "schreiner.edu"
  },
  {
    "name": "Scottsdale Community College",
    "domain": "scottsdalecc.edu"
  },
  {
    "name": "Seattle Central College",
    "domain": "seattlecentral.edu"
  },
  {
    "name": "Seattle Colleges",
    "domain": "seattlecolleges.edu"
  },
  {
    "name": "Seattle Pacific University",
    "domain": "spu.edu"
  },
  {
    "name": "Seattle University",
    "domain": "seattleu.edu"
  },
  {
    "name": "Selma University",
    "domain": "selmauniversity.edu"
  },
  {
    "name": "Seminole State College",
    "domain": "sscok.edu"
  },
  {
    "name": "Seton Hall University",
    "domain": "shu.edu"
  },
  {
    "name": "Sewanee, University of the South",
    "domain": "sewanee.edu"
  },
  {
    "name": "Seward County Community College and Area Technical School",
    "domain": "sccc.edu"
  },
  {
    "name": "Shasta College",
    "domain": "shastacollege.edu"
  },
  {
    "name": "Shaw University",
    "domain": "shawu.edu"
  },
  {
    "name": "Shawnee Community College",
    "domain": "shawneecc.edu"
  },
  {
    "name": "Shawnee State University",
    "domain": "shawnee.edu"
  },
  {
    "name": "Shelton State Community College",
    "domain": "sheltonstate.edu"
  },
  {
    "name": "Shenandoah University",
    "domain": "su.edu"
  },
  {
    "name": "Sheridan College",
    "domain": "sheridan.edu"
  },
  {
    "name": "Shippensburg University of Pennsylvania",
    "domain": "ship.edu"
  },
  {
    "name": "Shoreline Community College",
    "domain": "shoreline.edu"
  },
  {
    "name": "Shorter College",
    "domain": "shorter.edu"
  },
  {
    "name": "Siena College",
    "domain": "siena.edu"
  },
  {
    "name": "Sierra College",
    "domain": "sierracollege.edu"
  },
  {
    "name": "Simmons College",
    "domain": "simmons.edu"
  },
  {
    "name": "Simmons College of Kentucky",
    "domain": "simmonscollegeky.edu"
  },
  {
    "name": "Simon's Rock College",
    "domain": "simons-rock.edu"
  },
  {
    "name": "Simpson College",
    "domain": "simpson.edu"
  },
  {
    "name": "Sinclair Community College",
    "domain": "sinclair.edu"
  },
  {
    "name": "Sisseton Wahpeton College",
    "domain": "swc.tc"
  },
  {
    "name": "Skagit Valley College",
    "domain": "skagit.edu"
  },
  {
    "name": "Skidmore College",
    "domain": "skidmore.edu"
  },
  {
    "name": "Skyline College",
    "domain": "skylinecollege.edu"
  },
  {
    "name": "Slippery Rock University of Pennsylvania",
    "domain": "sru.edu"
  },
  {
    "name": "Smith College",
    "domain": "smith.edu"
  },
  {
    "name": "Snead State Community College",
    "domain": "snead.edu"
  },
  {
    "name": "Snow College",
    "domain": "snow.edu"
  },
  {
    "name": "Sofia University",
    "domain": "sofia.edu"
  },
  {
    "name": "Solano Community College",
    "domain": "solano.edu"
  },
  {
    "name": "Somerset Community College",
    "domain": "somerset.kctcs.edu"
  },
  {
    "name": "Sonoma State University",
    "domain": "sonoma.edu"
  },
  {
    "name": "South Arkansas Community College",
    "domain": "southark.edu"
  },
  {
    "name": "South Carolina State University",
    "domain": "scsu.edu"
  },
  {
    "name": "South Central College",
    "domain": "southcentral.edu"
  },
  {
    "name": "South Dakota School of Mines and Technology",
    "domain": "sdsmt.edu"
  },
  {
    "name": "South Dakota State University",
    "domain": "sdstate.edu"
  },
  {
    "name": "South Florida State College",
    "domain": "southflorida.edu"
  },
  {
    "name": "South Georgia Technical College",
    "domain": "southgatech.edu"
  },
  {
    "name": "South Louisiana Community College",
    "domain": "solacc.edu"
  },
  {
    "name": "South Mountain Community College",
    "domain": "southmountaincc.edu"
  },
  {
    "name": "South Piedmont Community College",
    "domain": "spcc.edu"
  },
  {
    "name": "South Plains College",
    "domain": "southplainscollege.edu"
  },
  {
    "name": "South Puget Sound Community College",
    "domain": "spscc.ctc.edu"
  },
  {
    "name": "South Suburban College",
    "domain": "ssc.edu"
  },
  {
    "name": "South Texas College of Law",
    "domain": "stcl.edu"
  },
  {
    "name": "Southcentral Kentucky Community and Technical College",
    "domain": "bowlinggreen.kctcs.edu"
  },
  {
    "name": "Southeast Arkansas College",
    "domain": "seark.edu"
  },
  {
    "name": "Southeast Community College Area",
    "domain": "southeast.edu"
  },
  {
    "name": "Southeast Kentucky Community and Technical College",
    "domain": "southeast.kctcs.edu"
  },
  {
    "name": "Southeast Missouri Hospital College of Nursing and Health Sciences",
    "domain": "southeastmissourihospitalcollege.edu"
  },
  {
    "name": "Southeast Missouri State University",
    "domain": "semo.edu"
  },
  {
    "name": "Southeast Technical Institute",
    "domain": "southeasttech.edu"
  },
  {
    "name": "Southeastern Community College",
    "domain": "scciowa.edu, sccnc.edu"
  },
  {
    "name": "Southeastern Illinois College",
    "domain": "sic.edu"
  },
  {
    "name": "Southeastern Louisiana University",
    "domain": "selu.edu"
  },
  {
    "name": "Southeastern Technical College",
    "domain": "southeasterntech.edu"
  },
  {
    "name": "Southern Arkansas University Tech",
    "domain": "sautech.edu"
  },
  {
    "name": "Southern College",
    "domain": "southern.edu"
  },
  {
    "name": "Southern College of Technology",
    "domain": "sct.edu"
  },
  {
    "name": "Southern Connecticut State University",
    "domain": "southernct.edu"
  },
  {
    "name": "Southern Crescent Technical College",
    "domain": "sctech.edu"
  },
  {
    "name": "Southern Illinois University-Carbondale",
    "domain": "siu.edu"
  },
  {
    "name": "Southern Illinois University-Edwardsville",
    "domain": "siue.edu"
  },
  {
    "name": "Southern Maine Community College",
    "domain": "smccme.edu"
  },
  {
    "name": "Southern Methodist University",
    "domain": "smu.edu"
  },
  {
    "name": "Southern Nazarene University",
    "domain": "snu.edu"
  },
  {
    "name": "Southern New Hampshire University",
    "domain": "snhu.edu"
  },
  {
    "name": "Southern Oregon State College",
    "domain": "sou.edu"
  },
  {
    "name": "Southern State Community College",
    "domain": "sscc.edu"
  },
  {
    "name": "Southern Union State Community College",
    "domain": "suscc.edu"
  },
  {
    "name": "Southern University and A&M College",
    "domain": "subr.edu"
  },
  {
    "name": "Southern University at New Orleans",
    "domain": "suno.edu"
  },
  {
    "name": "Southern University at Shreveport",
    "domain": "susla.edu"
  },
  {
    "name": "Southern Utah University",
    "domain": "suu.edu"
  },
  {
    "name": "Southern Virginia University",
    "domain": "svu.edu"
  },
  {
    "name": "Southern West Virginia Community and Technical College",
    "domain": "southernwv.edu"
  },
  {
    "name": "Southside Virginia Community College",
    "domain": "southside.edu"
  },
  {
    "name": "Southwest Baptist University",
    "domain": "sbuniv.edu"
  },
  {
    "name": "Southwest Georgia Technical College",
    "domain": "southwestgatech.edu"
  },
  {
    "name": "Southwest Minnesota State University",
    "domain": "smsu.edu"
  },
  {
    "name": "Southwest Mississippi Community College",
    "domain": "smcc.edu"
  },
  {
    "name": "Southwest Research Institute",
    "domain": "swri.edu"
  },
  {
    "name": "Southwest Tennessee Community College",
    "domain": "southwest.tn.edu"
  },
  {
    "name": "Southwest Texas Junior College",
    "domain": "swtjc.net"
  },
  {
    "name": "Southwest Texas State University",
    "domain": "swt.edu"
  },
  {
    "name": "Southwest Virginia Community College",
    "domain": "sw.edu"
  },
  {
    "name": "Southwest Wisconsin Technical College",
    "domain": "swtc.edu"
  },
  {
    "name": "Southwestern Adventist College",
    "domain": "swac.edu"
  },
  {
    "name": "Southwestern Assemblies of God University",
    "domain": "sagu.edu"
  },
  {
    "name": "Southwestern Christian College",
    "domain": "swcc.edu"
  },
  {
    "name": "Southwestern College (CA)",
    "domain": "swccd.edu"
  },
  {
    "name": "Southwestern College (KS)",
    "domain": "sckans.edu"
  },
  {
    "name": "Southwestern Community College",
    "domain": "swcciowa.edu, southwesterncc.edu"
  },
  {
    "name": "Southwestern Illinois College",
    "domain": "swic.edu"
  },
  {
    "name": "Southwestern Indian Polytechnic Institute",
    "domain": "sipi.edu"
  },
  {
    "name": "Southwestern Michigan College",
    "domain": "swmich.edu"
  },
  {
    "name": "Southwestern Oregon Community College",
    "domain": "socc.edu"
  },
  {
    "name": "Southwestern University",
    "domain": "southwestern.edu"
  },
  {
    "name": "SOWELA Technical Community College",
    "domain": "sowela.edu"
  },
  {
    "name": "Spartanburg Community College",
    "domain": "sccsc.edu"
  },
  {
    "name": "Spartanburg Methodist College",
    "domain": "smcsc.edu"
  },
  {
    "name": "Spelman College",
    "domain": "auc.edu"
  },
  {
    "name": "Spokane Colleges",
    "domain": "spokane.edu"
  },
  {
    "name": "Spokane Community College",
    "domain": "scc.spokane.edu"
  },
  {
    "name": "Spokane Falls Community College",
    "domain": "spokanefalls.edu"
  },
  {
    "name": "Spoon River College",
    "domain": "src.edu"
  },
  {
    "name": "Spring Arbor College",
    "domain": "arbor.edu"
  },
  {
    "name": "Spring Hill College",
    "domain": "shc.edu"
  },
  {
    "name": "Springfield Technical Community College",
    "domain": "stcc.edu"
  },
  {
    "name": "St Charles Community College",
    "domain": "stchas.edu"
  },
  {
    "name": "St Cloud Technical and Community College",
    "domain": "sctcc.edu"
  },
  {
    "name": "St. Ambrose University",
    "domain": "sau.edu"
  },
  {
    "name": "St. Andrews Presbyterian College",
    "domain": "sapc.edu"
  },
  {
    "name": "St. Augustine's University",
    "domain": "st-aug.edu"
  },
  {
    "name": "St. Bonaventure University",
    "domain": "sbu.edu"
  },
  {
    "name": "St. Clair County Community College",
    "domain": "sc4.edu"
  },
  {
    "name": "St. Francis College",
    "domain": "sfc.edu"
  },
  {
    "name": "St. John's College - Annapolis",
    "domain": "sjca.edu"
  },
  {
    "name": "St. John's College - Santa Fe",
    "domain": "sjcsf.edu"
  },
  {
    "name": "St. Johns River State College",
    "domain": "sjrstate.edu"
  },
  {
    "name": "St. Joseph College (CT)",
    "domain": "sjc.edu"
  },
  {
    "name": "St. Joseph's College (ME)",
    "domain": "sjcme.edu"
  },
  {
    "name": "St. Lawrence University",
    "domain": "stlawu.edu"
  },
  {
    "name": "St. Louis College of Pharmacy",
    "domain": "stlcop.edu"
  },
  {
    "name": "St. Martin's College",
    "domain": "stmartin.edu"
  },
  {
    "name": "St. Mary's College of Maryland",
    "domain": "smcm.edu"
  },
  {
    "name": "St. Mary's University",
    "domain": "stmarytx.edu"
  },
  {
    "name": "St. Petersburg College",
    "domain": "spcollege.edu"
  },
  {
    "name": "St. Thomas University (FL)",
    "domain": "stu.edu"
  },
  {
    "name": "Stanford University",
    "domain": "stanford.edu"
  },
  {
    "name": "Stanly Community College",
    "domain": "stanly.edu"
  },
  {
    "name": "Stark State College",
    "domain": "starkstate.edu"
  },
  {
    "name": "State Center Community College District",
    "domain": "scccd.edu"
  },
  {
    "name": "State Fair Community College",
    "domain": "sfccmo.edu"
  },
  {
    "name": "State University of New York at Albany",
    "domain": "albany.edu"
  },
  {
    "name": "State University of New York at Binghamton",
    "domain": "binghamton.edu"
  },
  {
    "name": "State University of New York at Buffalo",
    "domain": "buffalo.edu"
  },
  {
    "name": "State University of New York at Farmingdale",
    "domain": "farmingdale.edu"
  },
  {
    "name": "State University of New York at Fredonia",
    "domain": "fredonia.edu"
  },
  {
    "name": "State University of New York at Oneonta",
    "domain": "suny.oneonta.edu"
  },
  {
    "name": "State University of New York at Oswego",
    "domain": "oswego.edu"
  },
  {
    "name": "State University of New York at Plattsburgh",
    "domain": "plattsburgh.edu"
  },
  {
    "name": "State University of New York at Stony Brook",
    "domain": "stonybrook.edu, fsl.cs.sunysb.edu, cs.sunysb.edu, lmc.cs.sunysb.edu"
  },
  {
    "name": "State University of New York College at Brockport",
    "domain": "brockport.edu"
  },
  {
    "name": "State University of New York College at Buffalo",
    "domain": "buffalostate.edu"
  },
  {
    "name": "State University of New York College at Cortland",
    "domain": "cortland.edu"
  },
  {
    "name": "State University of New York College at Geneseo",
    "domain": "geneseo.edu"
  },
  {
    "name": "State University of New York College at New Paltz",
    "domain": "newpaltz.edu"
  },
  {
    "name": "State University of New York College at Oneonta",
    "domain": "oneonta.edu"
  },
  {
    "name": "State University of New York College at Potsdam",
    "domain": "potsdam.edu"
  },
  {
    "name": "State University of New York College of Agriculture and Technology at Cobleskill",
    "domain": "cobleskill.edu"
  },
  {
    "name": "State University of New York College of Environmental Science and Forestry",
    "domain": "esf.edu"
  },
  {
    "name": "State University of New York College of Technology at Alfred",
    "domain": "alfredtech.edu"
  },
  {
    "name": "State University of New York Polytechnic Institute",
    "domain": "sunyit.edu"
  },
  {
    "name": "State University of New York System",
    "domain": "sunycentral.edu"
  },
  {
    "name": "Stephen F. Austin State University",
    "domain": "sfasu.edu"
  },
  {
    "name": "Stephens College",
    "domain": "stephens.edu"
  },
  {
    "name": "Stetson University",
    "domain": "stetson.edu"
  },
  {
    "name": "Stevens Institute of Technology",
    "domain": "stevens.edu"
  },
  {
    "name": "Stevenson University",
    "domain": "stevenson.edu"
  },
  {
    "name": "Stillman College",
    "domain": "stillman.edu"
  },
  {
    "name": "Stone Child College",
    "domain": "stonechild.edu"
  },
  {
    "name": "Stonehill College",
    "domain": "stonehill.edu"
  },
  {
    "name": "Stratford University",
    "domain": "stratford.edu"
  },
  {
    "name": "Strayer College",
    "domain": "strayer.edu"
  },
  {
    "name": "Suffolk County Community College",
    "domain": "www3.sunysuffolk.edu"
  },
  {
    "name": "Suffolk University",
    "domain": "suffolk.edu"
  },
  {
    "name": "Sul Ross State University",
    "domain": "sulross.edu"
  },
  {
    "name": "Sullivan County Community College",
    "domain": "sunysullivan.edu"
  },
  {
    "name": "Sullivan University",
    "domain": "sullivan.edu"
  },
  {
    "name": "Summit University of Louisiana",
    "domain": "summitunivofla.edu"
  },
  {
    "name": "SUNY Broome Community College",
    "domain": "sunybroome.edu"
  },
  {
    "name": "SUNY Downstate Health Sciences University",
    "domain": "downstate.edu"
  },
  {
    "name": "SUNY Maritime College",
    "domain": "sunymaritime.edu"
  },
  {
    "name": "SUNY Westchester Community College",
    "domain": "sunywcc.edu"
  },
  {
    "name": "Surry Community College",
    "domain": "surry.edu"
  },
  {
    "name": "Susquehanna University",
    "domain": "susqu.edu"
  },
  {
    "name": "Sussex County Community College",
    "domain": "sussex.edu"
  },
  {
    "name": "Swarthmore College",
    "domain": "swarthmore.edu"
  },
  {
    "name": "Sweet Briar College",
    "domain": "sbc.edu"
  },
  {
    "name": "Syracuse University",
    "domain": "syr.edu"
  },
  {
    "name": "Tabor College",
    "domain": "tabor.edu"
  },
  {
    "name": "Tacoma Community College",
    "domain": "tacomacc.edu"
  },
  {
    "name": "Taft College",
    "domain": "taftcollege.edu"
  },
  {
    "name": "Talladega College",
    "domain": "talladega.edu"
  },
  {
    "name": "Tallahassee Community College",
    "domain": "tcc.fl.edu"
  },
  {
    "name": "Tarleton State University",
    "domain": "tarleton.edu"
  },
  {
    "name": "Tarrant County College",
    "domain": "tccd.edu"
  },
  {
    "name": "Taylor University",
    "domain": "tayloru.edu"
  },
  {
    "name": "Technical Career Institutes",
    "domain": "tcicollege.edu"
  },
  {
    "name": "Technical College of the Lowcountry",
    "domain": "tcl.edu"
  },
  {
    "name": "Temple College",
    "domain": "templejc.edu"
  },
  {
    "name": "Temple University",
    "domain": "temple.edu"
  },
  {
    "name": "Tennessee State University",
    "domain": "tnstate.edu"
  },
  {
    "name": "Tennessee Technological University",
    "domain": "tntech.edu"
  },
  {
    "name": "Terra State Community College",
    "domain": "terra.edu"
  },
  {
    "name": "Texarkana College",
    "domain": "texarkanacollege.edu"
  },
  {
    "name": "Texas A&M International University",
    "domain": "tamiu.edu"
  },
  {
    "name": "Texas A&M University - College Station",
    "domain": "tamu.edu"
  },
  {
    "name": "Texas A&M University - Commerce",
    "domain": "tamuc.edu"
  },
  {
    "name": "Texas A&M University - Corpus Christi",
    "domain": "tamucc.edu"
  },
  {
    "name": "Texas A&M University - Kingsville",
    "domain": "tamuk.edu"
  },
  {
    "name": "Texas A&M University-Texarkana",
    "domain": "ace.tamut.edu"
  },
  {
    "name": "Texas Christian University",
    "domain": "tcu.edu"
  },
  {
    "name": "Texas College",
    "domain": "texascollege.edu"
  },
  {
    "name": "Texas Southern University",
    "domain": "tsu.edu"
  },
  {
    "name": "Texas State Technical College-Harlingen",
    "domain": "harlingen.tstc.edu"
  },
  {
    "name": "Texas State Technical College-Marshall",
    "domain": "marshall.tstc.edu"
  },
  {
    "name": "Texas State Technical College-Waco",
    "domain": "waco.tstc.edu"
  },
  {
    "name": "Texas State Technical College-West Texas",
    "domain": "westtexas.tstc.edu"
  },
  {
    "name": "Texas State University",
    "domain": "txstate.edu"
  },
  {
    "name": "Texas Tech University",
    "domain": "ttu.edu"
  },
  {
    "name": "Texas Tech University-Health Sciences Center",
    "domain": "ttuhsc.edu"
  },
  {
    "name": "Texas Wesleyan University",
    "domain": "txwes.edu"
  },
  {
    "name": "Texas Woman's University",
    "domain": "twu.edu"
  },
  {
    "name": "Thaddeus Stevens College of Technology",
    "domain": "stevenscollege.edu"
  },
  {
    "name": "The Art Institutes",
    "domain": "aii.edu"
  },
  {
    "name": "The Citadel",
    "domain": "citadel.edu"
  },
  {
    "name": "The College of New Jersey",
    "domain": "tcnj.edu"
  },
  {
    "name": "The Jewish Theological Seminary",
    "domain": "jtsa.edu"
  },
  {
    "name": "The Principia",
    "domain": "principia.edu"
  },
  {
    "name": "The Scripps Research Institute",
    "domain": "scripps.edu"
  },
  {
    "name": "The University of Alabama",
    "domain": "ua.edu"
  },
  {
    "name": "The University of Montana Western",
    "domain": "umwestern.edu"
  },
  {
    "name": "The University of North Carolina at Greensboro",
    "domain": "uncg.edu"
  },
  {
    "name": "The University of Olivet",
    "domain": "olivetcollege.edu"
  },
  {
    "name": "The University of Texas at Austin",
    "domain": "utexas.edu"
  },
  {
    "name": "The University of Texas at Rio Grande Valley",
    "domain": "utrgv.edu"
  },
  {
    "name": "The University of Texas at San Antonio",
    "domain": "utsa.edu"
  },
  {
    "name": "Thomas College",
    "domain": "thomas.edu"
  },
  {
    "name": "Thomas Edison State University",
    "domain": "tesc.edu, tesu.edu"
  },
  {
    "name": "Thomas Jefferson University",
    "domain": "tju.edu, jefferson.edu"
  },
  {
    "name": "Thomas More College",
    "domain": "thomasmore.edu"
  },
  {
    "name": "Thomas Nelson Community College",
    "domain": "tncc.edu"
  },
  {
    "name": "Three Rivers Community College",
    "domain": "trcc.commnet.edu, trcc.edu"
  },
  {
    "name": "Thunderbird School of Global Management",
    "domain": "thunderbird.edu"
  },
  {
    "name": "Tidewater Community College",
    "domain": "tcc.edu"
  },
  {
    "name": "Tiffin University",
    "domain": "tiffin.edu"
  },
  {
    "name": "Tillamook Bay Community College",
    "domain": "tbcc.cc.or.us"
  },
  {
    "name": "Tohono O'Odham Community College",
    "domain": "tocc.edu"
  },
  {
    "name": "Tompkins Cortland Community College",
    "domain": "tc3.edu"
  },
  {
    "name": "Tougaloo College",
    "domain": "tougaloo.edu"
  },
  {
    "name": "Touro College",
    "domain": "touro.edu"
  },
  {
    "name": "Towson University",
    "domain": "towson.edu"
  },
  {
    "name": "Transylvania University",
    "domain": "transy.edu"
  },
  {
    "name": "Treasure Valley Community College",
    "domain": "tvcc.cc"
  },
  {
    "name": "Trenton State College",
    "domain": "trenton.edu"
  },
  {
    "name": "Tri-County Community College",
    "domain": "tricountycc.edu"
  },
  {
    "name": "Tri-County Technical College",
    "domain": "tctc.edu"
  },
  {
    "name": "Trident Technical College",
    "domain": "tridenttech.edu"
  },
  {
    "name": "Trident University",
    "domain": "trident.edu"
  },
  {
    "name": "Trine University",
    "domain": "trine.edu"
  },
  {
    "name": "Trinidad State Junior College",
    "domain": "trinidadstate.edu"
  },
  {
    "name": "Trinity Bible College & Graduate School",
    "domain": "trinitybiblecollege.edu"
  },
  {
    "name": "Trinity College (CT)",
    "domain": "trincoll.edu"
  },
  {
    "name": "Trinity College (DC)",
    "domain": "trinitydc.edu"
  },
  {
    "name": "Trinity University",
    "domain": "trinity.edu"
  },
  {
    "name": "Trinity Valley Community College",
    "domain": "tvcc.edu"
  },
  {
    "name": "Triton College",
    "domain": "triton.edu"
  },
  {
    "name": "Troy State University",
    "domain": "tsufl.edu"
  },
  {
    "name": "Troy University",
    "domain": "troy.edu"
  },
  {
    "name": "Truckee Meadows Community College",
    "domain": "tmcc.edu"
  },
  {
    "name": "Truman State University",
    "domain": "truman.edu"
  },
  {
    "name": "Tucson University",
    "domain": "tucsonu.edu"
  },
  {
    "name": "Tufts University",
    "domain": "tufts.edu"
  },
  {
    "name": "Tulane University",
    "domain": "tulane.edu"
  },
  {
    "name": "Tulsa Community College",
    "domain": "tulsacc.edu"
  },
  {
    "name": "Tunxis Community College",
    "domain": "tunxis.edu"
  },
  {
    "name": "Tusculum College",
    "domain": "tusculum.edu"
  },
  {
    "name": "Tuskegee University",
    "domain": "tuskegee.edu"
  },
  {
    "name": "Tyler Junior College",
    "domain": "www.tjc.edu"
  },
  {
    "name": "UC Hastings College of the Law",
    "domain": "uchastings.edu"
  },
  {
    "name": "Ulster County Community College",
    "domain": "www.sunyulster.edu"
  },
  {
    "name": "Umpqua Community College",
    "domain": "umpqua.edu"
  },
  {
    "name": "Uniformed Services University of the Health Sciences",
    "domain": "usuhs.mil"
  },
  {
    "name": "Union College",
    "domain": "union.edu"
  },
  {
    "name": "Union County College",
    "domain": "ucc.edu"
  },
  {
    "name": "Union Institute",
    "domain": "tui.edu"
  },
  {
    "name": "Union University",
    "domain": "uu.edu"
  },
  {
    "name": "United States Air Force Academy",
    "domain": "usafa.af.mil, usafa.edu"
  },
  {
    "name": "United States Coast Guard Academy",
    "domain": "uscga.edu"
  },
  {
    "name": "United States International University",
    "domain": "usiu.edu"
  },
  {
    "name": "United States Merchant Marine Academy",
    "domain": "usmma.edu"
  },
  {
    "name": "United States Military Academy",
    "domain": "usma.edu"
  },
  {
    "name": "United States Naval Academy",
    "domain": "usna.edu"
  },
  {
    "name": "Unity Environmental College",
    "domain": "unity.edu"
  },
  {
    "name": "University of Advancing Technology",
    "domain": "uat.edu"
  },
  {
    "name": "University of Akron",
    "domain": "uakron.edu"
  },
  {
    "name": "University of Akron Wayne College",
    "domain": "wayne.uakron.edu"
  },
  {
    "name": "University of Alabama at Birmingham",
    "domain": "uab.edu"
  },
  {
    "name": "University of Alabama at Huntsville",
    "domain": "uah.edu"
  },
  {
    "name": "University of Alaska",
    "domain": "alaska.edu"
  },
  {
    "name": "University of Alaska - Anchorage",
    "domain": "uaa.alaska.edu"
  },
  {
    "name": "University of Alaska - Fairbanks",
    "domain": "uaf.edu"
  },
  {
    "name": "University of Alaska - Southeast",
    "domain": "uas.alaska.edu"
  },
  {
    "name": "University of Arizona",
    "domain": "arizona.edu"
  },
  {
    "name": "University of Arkansas - Fayetteville",
    "domain": "uark.edu"
  },
  {
    "name": "University of Arkansas - Fort Smith",
    "domain": "uafs.edu"
  },
  {
    "name": "University of Arkansas - Little Rock",
    "domain": "ualr.edu"
  },
  {
    "name": "University of Arkansas - Monticello",
    "domain": "uamont.edu"
  },
  {
    "name": "University of Arkansas Community College-Batesville",
    "domain": "uaccb.edu"
  },
  {
    "name": "University of Arkansas Community College-Hope",
    "domain": "uacch.edu"
  },
  {
    "name": "University of Arkansas Community College-Morrilton",
    "domain": "uaccm.edu"
  },
  {
    "name": "University of Arkansas for Medical Sciences",
    "domain": "uams.edu"
  },
  {
    "name": "University of Arkansas System eVersity",
    "domain": "uasys.edu"
  },
  {
    "name": "University of Baltimore",
    "domain": "ubalt.edu"
  },
  {
    "name": "University of Bridgeport",
    "domain": "bridgeport.edu"
  },
  {
    "name": "University of California, Berkeley",
    "domain": "berkeley.edu"
  },
  {
    "name": "University of California, Davis",
    "domain": "ucdavis.edu"
  },
  {
    "name": "University of California, Irvine",
    "domain": "uci.edu"
  },
  {
    "name": "University of California, Los Angeles",
    "domain": "ucla.edu"
  },
  {
    "name": "University of California, Merced",
    "domain": "ucmerced.edu"
  },
  {
    "name": "University of California, Office of the President",
    "domain": "ucop.edu"
  },
  {
    "name": "University of California, Riverside",
    "domain": "ucr.edu"
  },
  {
    "name": "University of California, San Diego",
    "domain": "ucsd.edu"
  },
  {
    "name": "University of California, San Francisco",
    "domain": "ucsf.edu"
  },
  {
    "name": "University of California, Santa Barbara",
    "domain": "ucsb.edu"
  },
  {
    "name": "University of California, Santa Cruz",
    "domain": "ucsc.edu"
  },
  {
    "name": "University of Central Arkansas",
    "domain": "uca.edu"
  },
  {
    "name": "University of Central Florida",
    "domain": "ucf.edu"
  },
  {
    "name": "University of Central Missouri",
    "domain": "ucmo.edu"
  },
  {
    "name": "University of Central Oklahoma",
    "domain": "uco.edu"
  },
  {
    "name": "University of Charleston",
    "domain": "uchaswv.edu"
  },
  {
    "name": "University of Chicago",
    "domain": "uchicago.edu"
  },
  {
    "name": "University of Cincinnati",
    "domain": "uc.edu"
  },
  {
    "name": "University of Colorado Anschutz Medical Campus",
    "domain": "cuanschutz.edu"
  },
  {
    "name": "University of Colorado at Boulder",
    "domain": "colorado.edu"
  },
  {
    "name": "University of Colorado at Colorado Springs",
    "domain": "uccs.edu"
  },
  {
    "name": "University of Colorado at Denver",
    "domain": "ucdenver.edu"
  },
  {
    "name": "University of Colorado Health Sciences Center",
    "domain": "hsc.colorado.edu"
  },
  {
    "name": "University of Connecticut",
    "domain": "uconn.edu"
  },
  {
    "name": "University of Dallas",
    "domain": "udallas.edu"
  },
  {
    "name": "University of Dayton",
    "domain": "udayton.edu"
  },
  {
    "name": "University of Delaware",
    "domain": "udel.edu"
  },
  {
    "name": "University of Denver",
    "domain": "du.edu"
  },
  {
    "name": "University of Detroit Mercy",
    "domain": "udmercy.edu"
  },
  {
    "name": "University of Dubuque",
    "domain": "dbq.edu"
  },
  {
    "name": "University of Evansville",
    "domain": "evansville.edu"
  },
  {
    "name": "University of Findlay",
    "domain": "findlay.edu"
  },
  {
    "name": "University of Florida",
    "domain": "ufl.edu"
  },
  {
    "name": "University of Georgia",
    "domain": "uga.edu"
  },
  {
    "name": "University of Great Falls",
    "domain": "ugf.edu"
  },
  {
    "name": "University of Hartford",
    "domain": "hartford.edu"
  },
  {
    "name": "University of Hawaii at Hilo",
    "domain": "hilo.hawaii.edu"
  },
  {
    "name": "University of Hawaii at Manoa",
    "domain": "manoa.hawaii.edu"
  },
  {
    "name": "University of Hawaii System",
    "domain": "hawaii.edu"
  },
  {
    "name": "University of Holy Cross",
    "domain": "uhcno.edu"
  },
  {
    "name": "University of Houston",
    "domain": "uh.edu"
  },
  {
    "name": "University of Houston-Downtown",
    "domain": "uhd.edu"
  },
  {
    "name": "University of Idaho",
    "domain": "uidaho.edu"
  },
  {
    "name": "University of Illinois Chicago",
    "domain": "uic.edu"
  },
  {
    "name": "University of Illinois Springfield",
    "domain": "uis.edu"
  },
  {
    "name": "University of Illinois Urbana-Champaign",
    "domain": "uiuc.edu, illinois.edu"
  },
  {
    "name": "University of Indianapolis",
    "domain": "uindy.edu"
  },
  {
    "name": "University of Iowa",
    "domain": "uiowa.edu"
  },
  {
    "name": "University of Jamestown",
    "domain": "uj.edu"
  },
  {
    "name": "University of Kansas",
    "domain": "ku.edu"
  },
  {
    "name": "University of Kansas School of Medicine",
    "domain": "kumc.edu"
  },
  {
    "name": "University of Kentucky",
    "domain": "uky.edu"
  },
  {
    "name": "University of La Verne",
    "domain": "laverne.edu"
  },
  {
    "name": "University of Louisiana at Lafeyette",
    "domain": "louisiana.edu"
  },
  {
    "name": "University of Louisiana at Monroe",
    "domain": "ulm.edu"
  },
  {
    "name": "University of Louisville",
    "domain": "louisville.edu"
  },
  {
    "name": "University of Maine",
    "domain": "umaine.edu"
  },
  {
    "name": "University of Maine at Farmington",
    "domain": "umf.maine.edu"
  },
  {
    "name": "University of Maine at Fort Kent",
    "domain": "umfk.maine.edu"
  },
  {
    "name": "University of Maine at Machias",
    "domain": "umm.maine.edu"
  },
  {
    "name": "University of Maine at Presque Island",
    "domain": "umpi.maine.edu"
  },
  {
    "name": "University of Maine System",
    "domain": "maine.edu"
  },
  {
    "name": "University of Mary Washington",
    "domain": "umw.edu"
  },
  {
    "name": "University of Maryland - University College",
    "domain": "umuc.edu"
  },
  {
    "name": "University of Maryland Eastern Shore",
    "domain": "umes.edu"
  },
  {
    "name": "University of Maryland, Baltimore",
    "domain": "umaryland.edu"
  },
  {
    "name": "University of Maryland, Baltimore County",
    "domain": "umbc.edu"
  },
  {
    "name": "University of Maryland, College Park",
    "domain": "umd.edu"
  },
  {
    "name": "University of Massachusetts at Amherst",
    "domain": "umass.edu"
  },
  {
    "name": "University of Massachusetts at Dartmouth",
    "domain": "umassd.edu"
  },
  {
    "name": "University of Massachusetts at Lowell",
    "domain": "uml.edu, student.uml.edu"
  },
  {
    "name": "University of Massachusetts Boston",
    "domain": "umb.edu"
  },
  {
    "name": "University of Memphis",
    "domain": "memphis.edu"
  },
  {
    "name": "University of Miami",
    "domain": "miami.edu"
  },
  {
    "name": "University of Michigan - Ann Arbor",
    "domain": "umich.edu"
  },
  {
    "name": "University of Michigan - Dearborn",
    "domain": "umdearborn.edu"
  },
  {
    "name": "University of Michigan-Flint",
    "domain": "umflint.edu"
  },
  {
    "name": "University of Minnesota",
    "domain": "umn.edu"
  },
  {
    "name": "University of Minnesota - Crookston",
    "domain": "crk.umn.edu"
  },
  {
    "name": "University of Minnesota - Duluth",
    "domain": "d.umn.edu"
  },
  {
    "name": "University of Minnesota - Morris",
    "domain": "mrs.umn.edu"
  },
  {
    "name": "University of Mississippi",
    "domain": "olemiss.edu"
  },
  {
    "name": "University of Mississippi Medical Center",
    "domain": "umc.edu"
  },
  {
    "name": "University of Missouri",
    "domain": "missouri.edu, umsystem.edu"
  },
  {
    "name": "University of Missouri - Kansas City",
    "domain": "umkc.edu"
  },
  {
    "name": "University of Missouri - Rolla",
    "domain": "umr.edu"
  },
  {
    "name": "University of Missouri - Saint Louis",
    "domain": "umsl.edu"
  },
  {
    "name": "University of Montana",
    "domain": "umt.edu"
  },
  {
    "name": "University of Mount Olive",
    "domain": "umo.edu"
  },
  {
    "name": "University of Nebraska, Kearney",
    "domain": "unk.edu"
  },
  {
    "name": "University of Nebraska, Lincoln",
    "domain": "unl.edu"
  },
  {
    "name": "University of Nebraska, Omaha",
    "domain": "unomaha.edu"
  },
  {
    "name": "University of Nevada, Las Vegas",
    "domain": "unlv.edu"
  },
  {
    "name": "University of Nevada, Reno",
    "domain": "unr.edu"
  },
  {
    "name": "University of New England",
    "domain": "une.edu"
  },
  {
    "name": "University of New Hampshire",
    "domain": "unh.edu"
  },
  {
    "name": "University of New Haven",
    "domain": "newhaven.edu"
  },
  {
    "name": "University of New Mexico",
    "domain": "unm.edu"
  },
  {
    "name": "University of New Orleans",
    "domain": "uno.edu"
  },
  {
    "name": "University of North Alabama",
    "domain": "una.edu"
  },
  {
    "name": "University of North Carolina at Asheville",
    "domain": "unca.edu"
  },
  {
    "name": "University of North Carolina at Chapel Hill",
    "domain": "unc.edu, ad.unc.edu"
  },
  {
    "name": "University of North Carolina at Charlotte",
    "domain": "uncc.edu"
  },
  {
    "name": "University of North Carolina at Wilmington",
    "domain": "uncw.edu"
  },
  {
    "name": "University of North Dakota",
    "domain": "und.edu, nodak.edu"
  },
  {
    "name": "University of North Florida",
    "domain": "unf.edu"
  },
  {
    "name": "University of North Georgia",
    "domain": "ung.edu"
  },
  {
    "name": "University of North Texas",
    "domain": "unt.edu"
  },
  {
    "name": "University of North Texas at Dallas",
    "domain": "untdallas.edu"
  },
  {
    "name": "University of North Texas Health Science Center",
    "domain": "hsc.unt.edu, unthsc.edu"
  },
  {
    "name": "University of Northern Colorado",
    "domain": "unco.edu"
  },
  {
    "name": "University of Northern Iowa",
    "domain": "uni.edu"
  },
  {
    "name": "University of Notre Dame",
    "domain": "nd.edu"
  },
  {
    "name": "University of Oklahoma",
    "domain": "ou.edu"
  },
  {
    "name": "University of Oregon",
    "domain": "uoregon.edu"
  },
  {
    "name": "University of Pennsylvania",
    "domain": "upenn.edu, seas.upenn.edu"
  },
  {
    "name": "University of Phoenix",
    "domain": "phoenix.edu, email.uophx.edu"
  },
  {
    "name": "University of Pikeville",
    "domain": "upike.edu"
  },
  {
    "name": "University of Pittsburgh",
    "domain": "pitt.edu"
  },
  {
    "name": "University of Pittsburgh at Bradford",
    "domain": "upb.pitt.edu"
  },
  {
    "name": "University of Pittsburgh at Johnstown",
    "domain": "upj.pitt.edu"
  },
  {
    "name": "University of Pittsburgh Medical Center",
    "domain": "upmc.edu, upmc.com"
  },
  {
    "name": "University of Pittsburgh-Titusville",
    "domain": "upt.pitt.edu"
  },
  {
    "name": "University of Portland",
    "domain": "up.edu"
  },
  {
    "name": "University of Puerto Rico",
    "domain": "upr.edu"
  },
  {
    "name": "University of Puget Sound",
    "domain": "ups.edu"
  },
  {
    "name": "University of Redlands",
    "domain": "uor.edu"
  },
  {
    "name": "University of Rhode Island",
    "domain": "uri.edu"
  },
  {
    "name": "University of Richmond",
    "domain": "urich.edu"
  },
  {
    "name": "University of Rochester",
    "domain": "rochester.edu"
  },
  {
    "name": "University of Saint Thomas (MN)",
    "domain": "stthomas.edu"
  },
  {
    "name": "University of Saint Thomas (TX)",
    "domain": "stthom.edu"
  },
  {
    "name": "University of San Diego",
    "domain": "sandiego.edu"
  },
  {
    "name": "University of San Francisco",
    "domain": "usfca.edu"
  },
  {
    "name": "University of Science & Arts of Oklahoma",
    "domain": "usao.edu"
  },
  {
    "name": "University of Scranton",
    "domain": "scranton.edu"
  },
  {
    "name": "University of Sioux Falls",
    "domain": "usouixfalls.edu"
  },
  {
    "name": "University of South Alabama",
    "domain": "southalabama.edu"
  },
  {
    "name": "University of South Carolina",
    "domain": "sc.edu"
  },
  {
    "name": "University of South Carolina - Aiken",
    "domain": "usca.edu"
  },
  {
    "name": "University of South Carolina Upstate",
    "domain": "email.uscupstate.edu"
  },
  {
    "name": "University of South Carolina, Beaufort",
    "domain": "uscb.edu"
  },
  {
    "name": "University of South Dakota",
    "domain": "usd.edu"
  },
  {
    "name": "University of South Florida",
    "domain": "usf.edu"
  },
  {
    "name": "University of Southern California",
    "domain": "usc.edu, isi.edu"
  },
  {
    "name": "University of Southern Indiana",
    "domain": "usi.edu"
  },
  {
    "name": "University of Southern Maine",
    "domain": "usm.maine.edu"
  },
  {
    "name": "University of Southern Mississippi",
    "domain": "usm.edu"
  },
  {
    "name": "University of Southwestern Louisiana",
    "domain": "usl.edu"
  },
  {
    "name": "University of St. Augustine for Health Sciences",
    "domain": "usa.edu"
  },
  {
    "name": "University of Tampa",
    "domain": "ut.edu"
  },
  {
    "name": "University of Tennessee at Chattanooga",
    "domain": "utc.edu"
  },
  {
    "name": "University of Tennessee, Knoxville",
    "domain": "utk.edu"
  },
  {
    "name": "University of Tennessee, Martin",
    "domain": "utm.edu"
  },
  {
    "name": "University of Texas - Pan American",
    "domain": "panam.edu"
  },
  {
    "name": "University of Texas at Arlington",
    "domain": "uta.edu"
  },
  {
    "name": "University of Texas at Brownsville",
    "domain": "utb.edu"
  },
  {
    "name": "University of Texas at Dallas",
    "domain": "utd.edu, utdallas.edu"
  },
  {
    "name": "University of Texas at El Paso",
    "domain": "utep.edu"
  },
  {
    "name": "University of Texas at Tyler",
    "domain": "uttyler.edu"
  },
  {
    "name": "University of Texas Medical Branch",
    "domain": "utmb.edu"
  },
  {
    "name": "University of Texas Permian Basin",
    "domain": "utpb.edu"
  },
  {
    "name": "University of Texas Southwestern Medical Center",
    "domain": "swmed.edu, utsouthwestern.edu"
  },
  {
    "name": "University of the District of Columbia",
    "domain": "udc.edu"
  },
  {
    "name": "University of the Incarnate Word",
    "domain": "uiw.edu, uiwtx.edu"
  },
  {
    "name": "University of the Ozarks",
    "domain": "ozarks.edu"
  },
  {
    "name": "University of the Pacific",
    "domain": "uop.edu, pacific.edu"
  },
  {
    "name": "University of the People",
    "domain": "uopeople.edu"
  },
  {
    "name": "University of Toledo",
    "domain": "utoledo.edu"
  },
  {
    "name": "University of Tulsa",
    "domain": "utulsa.edu"
  },
  {
    "name": "University of Utah",
    "domain": "utah.edu"
  },
  {
    "name": "University of Vermont",
    "domain": "uvm.edu"
  },
  {
    "name": "University of Virginia, Charlottesville",
    "domain": "virginia.edu"
  },
  {
    "name": "University of Washington",
    "domain": "uw.edu, washington.edu"
  },
  {
    "name": "University of West Alabama",
    "domain": "westal.edu"
  },
  {
    "name": "University of West Florida",
    "domain": "uwf.edu"
  },
  {
    "name": "University of West Georgia",
    "domain": "westga.edu"
  },
  {
    "name": "University of Wisconsin - Eau Claire",
    "domain": "uwec.edu"
  },
  {
    "name": "University of Wisconsin - Green Bay",
    "domain": "uwgb.edu"
  },
  {
    "name": "University of Wisconsin - LaCrosse",
    "domain": "uwlax.edu"
  },
  {
    "name": "University of Wisconsin - Madison",
    "domain": "wisc.edu"
  },
  {
    "name": "University of Wisconsin - Milwaukee",
    "domain": "uwm.edu"
  },
  {
    "name": "University of Wisconsin - Oshkosh",
    "domain": "uwosh.edu"
  },
  {
    "name": "University of Wisconsin - Parkside",
    "domain": "uwp.edu"
  },
  {
    "name": "University of Wisconsin - Platteville",
    "domain": "uwplatt.edu"
  },
  {
    "name": "University of Wisconsin - River Falls",
    "domain": "uwrf.edu"
  },
  {
    "name": "University of Wisconsin - Stevens Point",
    "domain": "uwsp.edu"
  },
  {
    "name": "University of Wisconsin - Stout",
    "domain": "uwstout.edu"
  },
  {
    "name": "University of Wisconsin - Superior",
    "domain": "uwsuper.edu"
  },
  {
    "name": "University of Wisconsin - Whitewater",
    "domain": "uww.edu"
  },
  {
    "name": "University of Wisconsin Colleges",
    "domain": "uwc.edu"
  },
  {
    "name": "University of Wisconsin System",
    "domain": "uwsa.edu"
  },
  {
    "name": "University of Wyoming",
    "domain": "uwyo.edu"
  },
  {
    "name": "Upper Iowa University",
    "domain": "uiu.edu"
  },
  {
    "name": "Urban College of Boston",
    "domain": "urbancollege.edu"
  },
  {
    "name": "Ursinus College",
    "domain": "ursinus.edu"
  },
  {
    "name": "Utah State University",
    "domain": "usu.edu"
  },
  {
    "name": "Utah Tech University",
    "domain": "utahtech.edu"
  },
  {
    "name": "Utah Valley State College",
    "domain": "uvsc.edu"
  },
  {
    "name": "Utah Valley University",
    "domain": "uvu.edu"
  },
  {
    "name": "Utica College",
    "domain": "utica.edu"
  },
  {
    "name": "Valdosta State University",
    "domain": "valdosta.edu"
  },
  {
    "name": "Valencia College",
    "domain": "valenciacollege.edu"
  },
  {
    "name": "Valley City State University",
    "domain": "vcsu.edu"
  },
  {
    "name": "Valley Forge Military Academy and College",
    "domain": "vfmac.edu"
  },
  {
    "name": "Valparaiso University",
    "domain": "valpo.edu"
  },
  {
    "name": "Vance-Granville Community College",
    "domain": "vgcc.edu"
  },
  {
    "name": "Vanderbilt University",
    "domain": "vanderbilt.edu"
  },
  {
    "name": "Vassar College",
    "domain": "vassar.edu"
  },
  {
    "name": "Ventura College",
    "domain": "venturacollege.edu"
  },
  {
    "name": "Verde Valley School",
    "domain": "vvsaz.org"
  },
  {
    "name": "Vermilion Community College",
    "domain": "vcc.edu"
  },
  {
    "name": "Vermont Law School",
    "domain": "vermontlaw.edu"
  },
  {
    "name": "Vermont Technical College",
    "domain": "vtc.edu"
  },
  {
    "name": "Vernon College",
    "domain": "vernoncollege.edu"
  },
  {
    "name": "Victor Valley College",
    "domain": "vvc.edu"
  },
  {
    "name": "Victoria College",
    "domain": "victoriacollege.edu"
  },
  {
    "name": "Villa Julie College",
    "domain": "vjc.edu"
  },
  {
    "name": "Villanova University",
    "domain": "villanova.edu"
  },
  {
    "name": "Virginia Commonwealth University",
    "domain": "vcu.edu"
  },
  {
    "name": "Virginia Community College System",
    "domain": "vccs.edu"
  },
  {
    "name": "Virginia Highlands Community College",
    "domain": "vhcc.edu"
  },
  {
    "name": "Virginia Intermont College",
    "domain": "vic.edu"
  },
  {
    "name": "Virginia Military Institute",
    "domain": "vmi.edu"
  },
  {
    "name": "Virginia State University",
    "domain": "vsu.edu"
  },
  {
    "name": "Virginia Tech",
    "domain": "vt.edu"
  },
  {
    "name": "Virginia Union University",
    "domain": "vuu.edu"
  },
  {
    "name": "Virginia University of Lynchburg",
    "domain": "vul.edu"
  },
  {
    "name": "Virginia Wesleyan College",
    "domain": "vwc.edu"
  },
  {
    "name": "Virginia Western Community College",
    "domain": "virginiawestern.edu"
  },
  {
    "name": "Volunteer State Community College",
    "domain": "volstate.edu"
  },
  {
    "name": "Voorhees University",
    "domain": "voorhees.edu"
  },
  {
    "name": "Wabash College",
    "domain": "wabash.edu"
  },
  {
    "name": "Wagner College",
    "domain": "wagner.edu"
  },
  {
    "name": "Wake Forest Baptist Health",
    "domain": "wakehealth.edu"
  },
  {
    "name": "Wake Forest University",
    "domain": "wfu.edu"
  },
  {
    "name": "Wake Technical Community College",
    "domain": "waketech.edu"
  },
  {
    "name": "Walden University",
    "domain": "waldenu.edu"
  },
  {
    "name": "Walla Walla Community College",
    "domain": "wwcc.edu"
  },
  {
    "name": "Walla Walla University",
    "domain": "wallawalla.edu"
  },
  {
    "name": "Walsh College",
    "domain": "walshcollege.edu"
  },
  {
    "name": "Walters State Community College",
    "domain": "ws.edu"
  },
  {
    "name": "Warren County Community College",
    "domain": "warren.edu"
  },
  {
    "name": "Warren Wilson College",
    "domain": "warren-wilson.edu"
  },
  {
    "name": "Wartburg College",
    "domain": "wartburg.edu"
  },
  {
    "name": "Washburn University",
    "domain": "wuacc.edu"
  },
  {
    "name": "Washington & Jefferson College",
    "domain": "washjeff.edu"
  },
  {
    "name": "Washington & Lee University",
    "domain": "wlu.edu"
  },
  {
    "name": "Washington Bible College/Capital Bible Seminary",
    "domain": "bible.edu"
  },
  {
    "name": "Washington College",
    "domain": "washcoll.edu"
  },
  {
    "name": "Washington County Community College",
    "domain": "wccc.me.edu"
  },
  {
    "name": "Washington State Community College",
    "domain": "wscc.edu"
  },
  {
    "name": "Washington State University",
    "domain": "wsu.edu"
  },
  {
    "name": "Washington State University at Vancouver",
    "domain": "vancouver.wsu.edu"
  },
  {
    "name": "Washington University, Saint Louis",
    "domain": "wustl.edu"
  },
  {
    "name": "Washtenaw Community College",
    "domain": "wccnet.edu"
  },
  {
    "name": "Waubonsee Community College",
    "domain": "waubonsee.edu"
  },
  {
    "name": "Waukesha County Technical College",
    "domain": "wctc.edu"
  },
  {
    "name": "Wayland Baptist University",
    "domain": "wbu.edu"
  },
  {
    "name": "Wayne Community College",
    "domain": "waynecc.edu"
  },
  {
    "name": "Wayne County Community College District",
    "domain": "wcccd.edu"
  },
  {
    "name": "Wayne State University",
    "domain": "wayne.edu"
  },
  {
    "name": "Waynesburg College",
    "domain": "waynesburg.edu"
  },
  {
    "name": "Weatherford College",
    "domain": "wc.edu"
  },
  {
    "name": "Weber State University",
    "domain": "weber.edu"
  },
  {
    "name": "Webster University",
    "domain": "webster.edu"
  },
  {
    "name": "Wellesley College",
    "domain": "wellesley.edu"
  },
  {
    "name": "Wells College",
    "domain": "wells.edu"
  },
  {
    "name": "Wenatchee Valley College",
    "domain": "wvc.edu"
  },
  {
    "name": "Wentworth Institute of Technology",
    "domain": "wit.edu"
  },
  {
    "name": "Wentworth Military Academy & Junior College",
    "domain": "wma.edu"
  },
  {
    "name": "Wesley College",
    "domain": "wesley.edu"
  },
  {
    "name": "Wesleyan University",
    "domain": "wesleyan.edu"
  },
  {
    "name": "West Chester University of Pennsylvania",
    "domain": "wcupa.edu"
  },
  {
    "name": "West Coast University",
    "domain": "westcoastuniversity.edu"
  },
  {
    "name": "West Georgia Technical College",
    "domain": "westgatech.edu"
  },
  {
    "name": "West Hills College-Coalinga",
    "domain": "westhillscollege.com"
  },
  {
    "name": "West Kentucky Community and Technical College",
    "domain": "westkentucky.kctcs.edu"
  },
  {
    "name": "West Liberty State College",
    "domain": "wlsc.wvnet.edu"
  },
  {
    "name": "West Los Angeles College",
    "domain": "wlac.edu"
  },
  {
    "name": "West Shore Community College",
    "domain": "westshore.edu"
  },
  {
    "name": "West Texas A&M University",
    "domain": "wtamu.edu"
  },
  {
    "name": "West Valley College",
    "domain": "westvalley.edu"
  },
  {
    "name": "West Virginia Northern Community College",
    "domain": "wvncc.edu"
  },
  {
    "name": "West Virginia State University",
    "domain": "wvstate.edu"
  },
  {
    "name": "West Virginia University",
    "domain": "wvu.edu"
  },
  {
    "name": "West Virginia University at Parkersburg",
    "domain": "westliberty.edu"
  },
  {
    "name": "West Virginia Wesleyan College",
    "domain": "wvwc.edu"
  },
  {
    "name": "Western Carolina University",
    "domain": "wcu.edu"
  },
  {
    "name": "Western Connecticut State University",
    "domain": "wcsu.edu"
  },
  {
    "name": "Western Dakota Technical Institute",
    "domain": "wdt.edu"
  },
  {
    "name": "Western Governors University",
    "domain": "wgu.edu"
  },
  {
    "name": "Western Illinois University",
    "domain": "wiu.edu"
  },
  {
    "name": "Western Iowa Tech Community College",
    "domain": "witcc.edu"
  },
  {
    "name": "Western Kentucky University",
    "domain": "wku.edu"
  },
  {
    "name": "Western Michigan University",
    "domain": "wmich.edu"
  },
  {
    "name": "Western Montana College",
    "domain": "wmc.edu"
  },
  {
    "name": "Western Nebraska Community College",
    "domain": "wncc.edu"
  },
  {
    "name": "Western Nevada College",
    "domain": "wnc.edu"
  },
  {
    "name": "Western New England College",
    "domain": "wnec.edu"
  },
  {
    "name": "Western New England University",
    "domain": "wne.edu"
  },
  {
    "name": "Western New Mexico University",
    "domain": "wnmu.edu"
  },
  {
    "name": "Western Oklahoma State College",
    "domain": "wosc.edu"
  },
  {
    "name": "Western Piedmont Community College",
    "domain": "wpcc.edu"
  },
  {
    "name": "Western State Colorado University",
    "domain": "western.edu"
  },
  {
    "name": "Western Technical College",
    "domain": "westerntc.edu"
  },
  {
    "name": "Western Texas College",
    "domain": "wtc.edu"
  },
  {
    "name": "Western University of Health Sciences",
    "domain": "westernu.edu"
  },
  {
    "name": "Western Washington University",
    "domain": "wwu.edu"
  },
  {
    "name": "Western Wyoming Community College",
    "domain": "wwcc.wy.edu"
  },
  {
    "name": "Westfield State College",
    "domain": "westfield.mass.edu"
  },
  {
    "name": "Westminster College of Fulton",
    "domain": "westminster-mo.edu"
  },
  {
    "name": "Westminster College of New Wilmington",
    "domain": "westminster.edu"
  },
  {
    "name": "Westminster College of Salt Lake City",
    "domain": "wcslc.edu"
  },
  {
    "name": "Westminster Theological Seminary",
    "domain": "wts.edu"
  },
  {
    "name": "Westminster University",
    "domain": "westminsteru.edu"
  },
  {
    "name": "Westmont College",
    "domain": "westmont.edu"
  },
  {
    "name": "Westmoreland County Community College",
    "domain": "wccc.edu"
  },
  {
    "name": "Wharton County Junior College",
    "domain": "wcjc.edu"
  },
  {
    "name": "Whatcom Community College",
    "domain": "whatcom.ctc.edu"
  },
  {
    "name": "Wheaton College",
    "domain": "wheaton.edu"
  },
  {
    "name": "Wheaton College, Norton MA",
    "domain": "wheatonma.edu"
  },
  {
    "name": "Wheeling Jesuit College",
    "domain": "wjc.edu"
  },
  {
    "name": "White Earth Tribal and Community College",
    "domain": "wetcc.edu"
  },
  {
    "name": "White Mountains Community College",
    "domain": "wmcc.edu"
  },
  {
    "name": "Whitman College",
    "domain": "whitman.edu"
  },
  {
    "name": "Whittier College",
    "domain": "whittier.edu"
  },
  {
    "name": "Whitworth College",
    "domain": "whitworth.edu"
  },
  {
    "name": "Wichita Area Technical College",
    "domain": "watc.edu"
  },
  {
    "name": "Wichita State University",
    "domain": "wichita.edu"
  },
  {
    "name": "Widener University",
    "domain": "widener.edu"
  },
  {
    "name": "Wilberforce University",
    "domain": "wilberforce.edu"
  },
  {
    "name": "Wiley College",
    "domain": "wileyc.edu"
  },
  {
    "name": "Wilkes Community College",
    "domain": "wilkescc.edu"
  },
  {
    "name": "Wilkes University",
    "domain": "wilkes.edu"
  },
  {
    "name": "Willamette University",
    "domain": "willamette.edu"
  },
  {
    "name": "William Howard Taft University",
    "domain": "taftu.edu"
  },
  {
    "name": "William Jewell College",
    "domain": "jewell.edu"
  },
  {
    "name": "William Mitchell College of Law",
    "domain": "wmitchell.edu"
  },
  {
    "name": "William Paterson University",
    "domain": "wpunj.edu"
  },
  {
    "name": "William Penn College",
    "domain": "wmpenn.edu"
  },
  {
    "name": "William Woods University",
    "domain": "wmwoods.edu"
  },
  {
    "name": "Williams College",
    "domain": "williams.edu"
  },
  {
    "name": "Williamsburg Technical College",
    "domain": "wiltech.edu"
  },
  {
    "name": "Williston State College",
    "domain": "willistonstate.edu"
  },
  {
    "name": "Wilmington College",
    "domain": "wilmington.edu"
  },
  {
    "name": "Wilmington University",
    "domain": "wilmu.edu"
  },
  {
    "name": "Wilson Community College",
    "domain": "wilsoncc.edu"
  },
  {
    "name": "Windward Community College",
    "domain": "windward.hawaii.edu"
  },
  {
    "name": "Wingate University",
    "domain": "wingate.edu"
  },
  {
    "name": "Winona State University",
    "domain": "winona.edu"
  },
  {
    "name": "Winston-Salem State University",
    "domain": "wssu.edu"
  },
  {
    "name": "Winthrop University",
    "domain": "winthrop.edu"
  },
  {
    "name": "Wiregrass Georgia Technical College",
    "domain": "wiregrass.edu"
  },
  {
    "name": "Wisconsin Indianhead Technical College",
    "domain": "witc.edu"
  },
  {
    "name": "Wisconsin Lutheran College",
    "domain": "wlc.edu"
  },
  {
    "name": "Wittenberg University",
    "domain": "wittenberg.edu"
  },
  {
    "name": "Wofford College",
    "domain": "wofford.edu"
  },
  {
    "name": "Woodbury University",
    "domain": "woodbury.edu"
  },
  {
    "name": "Woodland Community College",
    "domain": "wcc.yccd.edu"
  },
  {
    "name": "Woods Hole Oceanographic Institution",
    "domain": "whoi.edu"
  },
  {
    "name": "Wor-Wic Community College",
    "domain": "worwic.edu"
  },
  {
    "name": "Worcester Polytechnic Institute",
    "domain": "wpi.edu"
  },
  {
    "name": "Wright State University",
    "domain": "wright.edu"
  },
  {
    "name": "Wytheville Community College",
    "domain": "wcc.vccs.edu"
  },
  {
    "name": "Xavier University",
    "domain": "xavier.edu"
  },
  {
    "name": "Xavier University of Louisiana",
    "domain": "xula.edu"
  },
  {
    "name": "Yakima Valley Community College",
    "domain": "yvcc.edu"
  },
  {
    "name": "Yale University",
    "domain": "yale.edu"
  },
  {
    "name": "Yavapai College",
    "domain": "yc.edu"
  },
  {
    "name": "Yeshiva University",
    "domain": "yu.edu"
  },
  {
    "name": "York College of Pennsylvania",
    "domain": "ycp.edu"
  },
  {
    "name": "York County Community College",
    "domain": "yccc.edu"
  },
  {
    "name": "York Technical College",
    "domain": "yorktech.edu"
  },
  {
    "name": "Yosemite Community College District",
    "domain": "yosemite.edu"
  },
  {
    "name": "Young Harris College",
    "domain": "yhc.edu"
  },
  {
    "name": "Youngstown State University",
    "domain": "ysu.edu"
  },
  {
    "name": "YTI Career Institute",
    "domain": "yti.edu"
  },
  {
    "name": "Yuba College",
    "domain": "yc.yccd.edu"
  },
  {
    "name": "Zane State College",
    "domain": "zanestate.edu"
  }
];

export default UNIVERSITIES;